import require$$0 from 'url';
import { AllIssuers, SupportedIssuers, SecondaryUnitTypes, StateCodes, StreetTypes, UsageType, DwellingType, PolicyTypes, PropertyPolicyCoverageTypes } from '@trellisconnect/types';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

/** Used for built-in method references. */

var objectProto$c = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype$2(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$c;

  return value === proto;
}

var _isPrototype = isPrototype$2;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */

function overArg$1(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg$1;

var overArg = _overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys$1 = overArg(Object.keys, Object);

var _nativeKeys = nativeKeys$1;

var isPrototype$1 = _isPrototype,
    nativeKeys = _nativeKeys;

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$b.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys$2(object) {
  if (!isPrototype$1(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$9.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys$2;

/** Detect free variable `global` from Node.js. */

var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal$1;

var freeGlobal = _freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$8 = freeGlobal || freeSelf || Function('return this')();

var _root = root$8;

var root$7 = _root;

/** Built-in value references. */
var Symbol$3 = root$7.Symbol;

var _Symbol = Symbol$3;

var Symbol$2 = _Symbol;

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$a.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$8.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

var _getRawTag = getRawTag$1;

/** Used for built-in method references. */

var objectProto$9 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$9.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString$1;

var Symbol$1 = _Symbol,
    getRawTag = _getRawTag,
    objectToString = _objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$5(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

var _baseGetTag = baseGetTag$5;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject$2(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$2;

var baseGetTag$4 = _baseGetTag,
    isObject$1 = isObject_1;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag$1 = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$2(value) {
  if (!isObject$1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag$4(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction$2;

var root$6 = _root;

/** Used to detect overreaching core-js shims. */
var coreJsData$1 = root$6['__core-js_shared__'];

var _coreJsData = coreJsData$1;

var coreJsData = _coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$1(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked$1;

/** Used for built-in method references. */

var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource$2;

var isFunction$1 = isFunction_1,
    isMasked = _isMasked,
    isObject = isObject_1,
    toSource$1 = _toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto$8 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$8.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty$7).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$1(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}

var _baseIsNative = baseIsNative$1;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue$1(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue$1;

var baseIsNative = _baseIsNative,
    getValue = _getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$6(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

var _getNative = getNative$6;

var getNative$5 = _getNative,
    root$5 = _root;

/* Built-in method references that are verified to be native. */
var DataView$1 = getNative$5(root$5, 'DataView');

var _DataView = DataView$1;

var getNative$4 = _getNative,
    root$4 = _root;

/* Built-in method references that are verified to be native. */
var Map$3 = getNative$4(root$4, 'Map');

var _Map = Map$3;

var getNative$3 = _getNative,
    root$3 = _root;

/* Built-in method references that are verified to be native. */
var Promise$2 = getNative$3(root$3, 'Promise');

var _Promise = Promise$2;

var getNative$2 = _getNative,
    root$2 = _root;

/* Built-in method references that are verified to be native. */
var Set$2 = getNative$2(root$2, 'Set');

var _Set = Set$2;

var getNative$1 = _getNative,
    root$1 = _root;

/* Built-in method references that are verified to be native. */
var WeakMap$1 = getNative$1(root$1, 'WeakMap');

var _WeakMap = WeakMap$1;

var DataView = _DataView,
    Map$2 = _Map,
    Promise$1 = _Promise,
    Set$1 = _Set,
    WeakMap = _WeakMap,
    baseGetTag$3 = _baseGetTag,
    toSource = _toSource;

/** `Object#toString` result references. */
var mapTag$3 = '[object Map]',
    objectTag$2 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$3 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';

var dataViewTag$2 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map$2),
    promiseCtorString = toSource(Promise$1),
    setCtorString = toSource(Set$1),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag$2 = baseGetTag$3;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag$2(new DataView(new ArrayBuffer(1))) != dataViewTag$2) ||
    (Map$2 && getTag$2(new Map$2) != mapTag$3) ||
    (Promise$1 && getTag$2(Promise$1.resolve()) != promiseTag) ||
    (Set$1 && getTag$2(new Set$1) != setTag$3) ||
    (WeakMap && getTag$2(new WeakMap) != weakMapTag$1)) {
  getTag$2 = function(value) {
    var result = baseGetTag$3(value),
        Ctor = result == objectTag$2 ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$2;
        case mapCtorString: return mapTag$3;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$3;
        case weakMapCtorString: return weakMapTag$1;
      }
    }
    return result;
  };
}

var _getTag = getTag$2;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike$5(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike$5;

var baseGetTag$2 = _baseGetTag,
    isObjectLike$4 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments$1(value) {
  return isObjectLike$4(value) && baseGetTag$2(value) == argsTag$2;
}

var _baseIsArguments = baseIsArguments$1;

var baseIsArguments = _baseIsArguments,
    isObjectLike$3 = isObjectLike_1;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$7.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments$2 = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike$3(value) && hasOwnProperty$6.call(value, 'callee') &&
    !propertyIsEnumerable$1.call(value, 'callee');
};

var isArguments_1 = isArguments$2;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray$4 = Array.isArray;

var isArray_1 = isArray$4;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$1 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength$2(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}

var isLength_1 = isLength$2;

var isFunction = isFunction_1,
    isLength$1 = isLength_1;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike$2(value) {
  return value != null && isLength$1(value.length) && !isFunction(value);
}

var isArrayLike_1 = isArrayLike$2;

var isBuffer$3 = {exports: {}};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

isBuffer$3.exports;

(function (module, exports) {
	var root = _root,
	    stubFalse = stubFalse_1;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;

	module.exports = isBuffer; 
} (isBuffer$3, isBuffer$3.exports));

var isBufferExports = isBuffer$3.exports;

var baseGetTag$1 = _baseGetTag,
    isLength = isLength_1,
    isObjectLike$2 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag = '[object Function]',
    mapTag$2 = '[object Map]',
    numberTag$2 = '[object Number]',
    objectTag$1 = '[object Object]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] =
typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] =
typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag$1] =
typedArrayTags[errorTag$1] = typedArrayTags[funcTag] =
typedArrayTags[mapTag$2] = typedArrayTags[numberTag$2] =
typedArrayTags[objectTag$1] = typedArrayTags[regexpTag$1] =
typedArrayTags[setTag$2] = typedArrayTags[stringTag$1] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray$1(value) {
  return isObjectLike$2(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag$1(value)];
}

var _baseIsTypedArray = baseIsTypedArray$1;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */

function baseUnary$1(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary$1;

var _nodeUtil = {exports: {}};

_nodeUtil.exports;

(function (module, exports) {
	var freeGlobal = _freeGlobal;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;

	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;

	    if (types) {
	      return types;
	    }

	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());

	module.exports = nodeUtil; 
} (_nodeUtil, _nodeUtil.exports));

var _nodeUtilExports = _nodeUtil.exports;

var baseIsTypedArray = _baseIsTypedArray,
    baseUnary = _baseUnary,
    nodeUtil = _nodeUtilExports;

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray$3 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

var isTypedArray_1 = isTypedArray$3;

var baseKeys$1 = _baseKeys,
    getTag$1 = _getTag,
    isArguments$1 = isArguments_1,
    isArray$3 = isArray_1,
    isArrayLike$1 = isArrayLike_1,
    isBuffer$2 = isBufferExports,
    isPrototype = _isPrototype,
    isTypedArray$2 = isTypedArray_1;

/** `Object#toString` result references. */
var mapTag$1 = '[object Map]',
    setTag$1 = '[object Set]';

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike$1(value) &&
      (isArray$3(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer$2(value) || isTypedArray$2(value) || isArguments$1(value))) {
    return !value.length;
  }
  var tag = getTag$1(value);
  if (tag == mapTag$1 || tag == setTag$1) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys$1(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty$5.call(value, key)) {
      return false;
    }
  }
  return true;
}

var isEmpty_1 = isEmpty;

var isEmpty$1 = /*@__PURE__*/getDefaultExportFromCjs(isEmpty_1);

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */

function isNil(value) {
  return value == null;
}

var isNil_1 = isNil;

var isNil$1 = /*@__PURE__*/getDefaultExportFromCjs(isNil_1);

var helpers$3 = {};

var uri = require$$0;

var ValidationError = helpers$3.ValidationError = function ValidationError (message, instance, schema, path, name, argument) {
  if(Array.isArray(path)){
    this.path = path;
    this.property = path.reduce(function(sum, item){
      return sum + makeSuffix(item);
    }, 'instance');
  }else if(path !== undefined){
    this.property = path;
  }
  if (message) {
    this.message = message;
  }
  if (schema) {
    var id = schema.$id || schema.id;
    this.schema = id || schema;
  }
  if (instance !== undefined) {
    this.instance = instance;
  }
  this.name = name;
  this.argument = argument;
  this.stack = this.toString();
};

ValidationError.prototype.toString = function toString() {
  return this.property + ' ' + this.message;
};

var ValidatorResult$2 = helpers$3.ValidatorResult = function ValidatorResult(instance, schema, options, ctx) {
  this.instance = instance;
  this.schema = schema;
  this.options = options;
  this.path = ctx.path;
  this.propertyPath = ctx.propertyPath;
  this.errors = [];
  this.throwError = options && options.throwError;
  this.throwFirst = options && options.throwFirst;
  this.throwAll = options && options.throwAll;
  this.disableFormat = options && options.disableFormat === true;
};

ValidatorResult$2.prototype.addError = function addError(detail) {
  var err;
  if (typeof detail == 'string') {
    err = new ValidationError(detail, this.instance, this.schema, this.path);
  } else {
    if (!detail) throw new Error('Missing error detail');
    if (!detail.message) throw new Error('Missing error message');
    if (!detail.name) throw new Error('Missing validator type');
    err = new ValidationError(detail.message, this.instance, this.schema, this.path, detail.name, detail.argument);
  }

  this.errors.push(err);
  if (this.throwFirst) {
    throw new ValidatorResultError$1(this);
  }else if(this.throwError){
    throw err;
  }
  return err;
};

ValidatorResult$2.prototype.importErrors = function importErrors(res) {
  if (typeof res == 'string' || (res && res.validatorType)) {
    this.addError(res);
  } else if (res && res.errors) {
    Array.prototype.push.apply(this.errors, res.errors);
  }
};

function stringizer (v,i){
  return i+': '+v.toString()+'\n';
}
ValidatorResult$2.prototype.toString = function toString(res) {
  return this.errors.map(stringizer).join('');
};

Object.defineProperty(ValidatorResult$2.prototype, "valid", { get: function() {
  return !this.errors.length;
} });

helpers$3.ValidatorResultError = ValidatorResultError$1;
function ValidatorResultError$1(result) {
  if(Error.captureStackTrace){
    Error.captureStackTrace(this, ValidatorResultError$1);
  }
  this.instance = result.instance;
  this.schema = result.schema;
  this.options = result.options;
  this.errors = result.errors;
}
ValidatorResultError$1.prototype = new Error();
ValidatorResultError$1.prototype.constructor = ValidatorResultError$1;
ValidatorResultError$1.prototype.name = "Validation Error";

/**
 * Describes a problem with a Schema which prevents validation of an instance
 * @name SchemaError
 * @constructor
 */
var SchemaError$2 = helpers$3.SchemaError = function SchemaError (msg, schema) {
  this.message = msg;
  this.schema = schema;
  Error.call(this, msg);
  Error.captureStackTrace(this, SchemaError);
};
SchemaError$2.prototype = Object.create(Error.prototype,
  {
    constructor: {value: SchemaError$2, enumerable: false},
    name: {value: 'SchemaError', enumerable: false},
  });

var SchemaContext$1 = helpers$3.SchemaContext = function SchemaContext (schema, options, path, base, schemas) {
  this.schema = schema;
  this.options = options;
  if(Array.isArray(path)){
    this.path = path;
    this.propertyPath = path.reduce(function(sum, item){
      return sum + makeSuffix(item);
    }, 'instance');
  }else {
    this.propertyPath = path;
  }
  this.base = base;
  this.schemas = schemas;
};

SchemaContext$1.prototype.resolve = function resolve (target) {
  return uri.resolve(this.base, target);
};

SchemaContext$1.prototype.makeChild = function makeChild(schema, propertyName){
  var path = (propertyName===undefined) ? this.path : this.path.concat([propertyName]);
  var id = schema.$id || schema.id;
  var base = uri.resolve(this.base, id||'');
  var ctx = new SchemaContext$1(schema, this.options, path, base, Object.create(this.schemas));
  if(id && !ctx.schemas[base]){
    ctx.schemas[base] = schema;
  }
  return ctx;
};

var FORMAT_REGEXPS = helpers$3.FORMAT_REGEXPS = {
  'date-time': /^\d{4}-(?:0[0-9]{1}|1[0-2]{1})-(3[01]|0[1-9]|[12][0-9])[tT ](2[0-4]|[01][0-9]):([0-5][0-9]):(60|[0-5][0-9])(\.\d+)?([zZ]|[+-]([0-5][0-9]):(60|[0-5][0-9]))$/,
  'date': /^\d{4}-(?:0[0-9]{1}|1[0-2]{1})-(3[01]|0[1-9]|[12][0-9])$/,
  'time': /^(2[0-4]|[01][0-9]):([0-5][0-9]):(60|[0-5][0-9])$/,

  'email': /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/,
  'ip-address': /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
  'ipv6': /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/,

  // TODO: A more accurate regular expression for "uri" goes:
  // [A-Za-z][+\-.0-9A-Za-z]*:((/(/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?)?)?#(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|(/(/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?[/?]|[!$&-.0-;=?-Z_a-z~])|/?%[0-9A-Fa-f]{2}|[!$&-.0-;=?-Z_a-z~])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*(#(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*)?|/(/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+(:\d*)?|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?:\d*|\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)?)?
  'uri': /^[a-zA-Z][a-zA-Z0-9+-.]*:[^\s]*$/,
  'uri-reference': /^(((([A-Za-z][+\-.0-9A-Za-z]*(:%[0-9A-Fa-f]{2}|:[!$&-.0-;=?-Z_a-z~]|[/?])|\?)(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|([A-Za-z][+\-.0-9A-Za-z]*:?)?)|([A-Za-z][+\-.0-9A-Za-z]*:)?\/((%[0-9A-Fa-f]{2}|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?[/?]|[!$&-.0-;=?-Z_a-z~])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|(\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?)?))#(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|(([A-Za-z][+\-.0-9A-Za-z]*)?%[0-9A-Fa-f]{2}|[!$&-.0-9;=@_~]|[A-Za-z][+\-.0-9A-Za-z]*[!$&-*,;=@_~])(%[0-9A-Fa-f]{2}|[!$&-.0-9;=@-Z_a-z~])*((([/?](%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*)?#|[/?])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*)?|([A-Za-z][+\-.0-9A-Za-z]*(:%[0-9A-Fa-f]{2}|:[!$&-.0-;=?-Z_a-z~]|[/?])|\?)(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|([A-Za-z][+\-.0-9A-Za-z]*:)?\/((%[0-9A-Fa-f]{2}|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)(:\d*)?[/?]|[!$&-.0-;=?-Z_a-z~])(%[0-9A-Fa-f]{2}|[!$&-;=?-Z_a-z~])*|\/((%[0-9A-Fa-f]{2}|[!$&-.0-9;=A-Z_a-z~])+(:\d*)?|(\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?:\d*|\[(([Vv][0-9A-Fa-f]+\.[!$&-.0-;=A-Z_a-z~]+)?|[.0-:A-Fa-f]+)\])?)?|[A-Za-z][+\-.0-9A-Za-z]*:?)?$/,

  'color': /^(#?([0-9A-Fa-f]{3}){1,2}\b|aqua|black|blue|fuchsia|gray|green|lime|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow|(rgb\(\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*\))|(rgb\(\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*\)))$/,

  // hostname regex from: http://stackoverflow.com/a/1420225/5628
  'hostname': /^(?=.{1,255}$)[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?(?:\.[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?)*\.?$/,
  'host-name': /^(?=.{1,255}$)[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?(?:\.[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?)*\.?$/,

  'alpha': /^[a-zA-Z]+$/,
  'alphanumeric': /^[a-zA-Z0-9]+$/,
  'utc-millisec': function (input) {
    return (typeof input === 'string') && parseFloat(input) === parseInt(input, 10) && !isNaN(input);
  },
  'regex': function (input) {
    var result = true;
    try {
      new RegExp(input);
    } catch (e) {
      result = false;
    }
    return result;
  },
  'style': /\s*(.+?):\s*([^;]+);?/,
  'phone': /^\+(?:[0-9] ?){6,14}[0-9]$/,
};

FORMAT_REGEXPS.regexp = FORMAT_REGEXPS.regex;
FORMAT_REGEXPS.pattern = FORMAT_REGEXPS.regex;
FORMAT_REGEXPS.ipv4 = FORMAT_REGEXPS['ip-address'];

helpers$3.isFormat = function isFormat (input, format, validator) {
  if (typeof input === 'string' && FORMAT_REGEXPS[format] !== undefined) {
    if (FORMAT_REGEXPS[format] instanceof RegExp) {
      return FORMAT_REGEXPS[format].test(input);
    }
    if (typeof FORMAT_REGEXPS[format] === 'function') {
      return FORMAT_REGEXPS[format](input);
    }
  } else if (validator && validator.customFormats &&
      typeof validator.customFormats[format] === 'function') {
    return validator.customFormats[format](input);
  }
  return true;
};

var makeSuffix = helpers$3.makeSuffix = function makeSuffix (key) {
  key = key.toString();
  // This function could be capable of outputting valid a ECMAScript string, but the
  // resulting code for testing which form to use would be tens of thousands of characters long
  // That means this will use the name form for some illegal forms
  if (!key.match(/[.\s\[\]]/) && !key.match(/^[\d]/)) {
    return '.' + key;
  }
  if (key.match(/^\d+$/)) {
    return '[' + key + ']';
  }
  return '[' + JSON.stringify(key) + ']';
};

helpers$3.deepCompareStrict = function deepCompareStrict (a, b) {
  if (typeof a !== typeof b) {
    return false;
  }
  if (Array.isArray(a)) {
    if (!Array.isArray(b)) {
      return false;
    }
    if (a.length !== b.length) {
      return false;
    }
    return a.every(function (v, i) {
      return deepCompareStrict(a[i], b[i]);
    });
  }
  if (typeof a === 'object') {
    if (!a || !b) {
      return a === b;
    }
    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) {
      return false;
    }
    return aKeys.every(function (v) {
      return deepCompareStrict(a[v], b[v]);
    });
  }
  return a === b;
};

function deepMerger (target, dst, e, i) {
  if (typeof e === 'object') {
    dst[i] = deepMerge(target[i], e);
  } else {
    if (target.indexOf(e) === -1) {
      dst.push(e);
    }
  }
}

function copyist (src, dst, key) {
  dst[key] = src[key];
}

function copyistWithDeepMerge (target, src, dst, key) {
  if (typeof src[key] !== 'object' || !src[key]) {
    dst[key] = src[key];
  }
  else {
    if (!target[key]) {
      dst[key] = src[key];
    } else {
      dst[key] = deepMerge(target[key], src[key]);
    }
  }
}

function deepMerge (target, src) {
  var array = Array.isArray(src);
  var dst = array && [] || {};

  if (array) {
    target = target || [];
    dst = dst.concat(target);
    src.forEach(deepMerger.bind(null, target, dst));
  } else {
    if (target && typeof target === 'object') {
      Object.keys(target).forEach(copyist.bind(null, target, dst));
    }
    Object.keys(src).forEach(copyistWithDeepMerge.bind(null, target, src, dst));
  }

  return dst;
}

helpers$3.deepMerge = deepMerge;

/**
 * Validates instance against the provided schema
 * Implements URI+JSON Pointer encoding, e.g. "%7e"="~0"=>"~", "~1"="%2f"=>"/"
 * @param o
 * @param s The path to walk o along
 * @return any
 */
helpers$3.objectGetPath = function objectGetPath(o, s) {
  var parts = s.split('/').slice(1);
  var k;
  while (typeof (k=parts.shift()) == 'string') {
    var n = decodeURIComponent(k.replace(/~0/,'~').replace(/~1/g,'/'));
    if (!(n in o)) return;
    o = o[n];
  }
  return o;
};

function pathEncoder (v) {
  return '/'+encodeURIComponent(v).replace(/~/g,'%7E');
}
/**
 * Accept an Array of property names and return a JSON Pointer URI fragment
 * @param Array a
 * @return {String}
 */
helpers$3.encodePath = function encodePointer(a){
  // ~ must be encoded explicitly because hacks
  // the slash is encoded by encodeURIComponent
  return a.map(pathEncoder).join('');
};


/**
 * Calculate the number of decimal places a number uses
 * We need this to get correct results out of multipleOf and divisibleBy
 * when either figure is has decimal places, due to IEEE-754 float issues.
 * @param number
 * @returns {number}
 */
helpers$3.getDecimalPlaces = function getDecimalPlaces(number) {

  var decimalPlaces = 0;
  if (isNaN(number)) return decimalPlaces;

  if (typeof number !== 'number') {
    number = Number(number);
  }

  var parts = number.toString().split('e');
  if (parts.length === 2) {
    if (parts[1][0] !== '-') {
      return decimalPlaces;
    } else {
      decimalPlaces = Number(parts[1].slice(1));
    }
  }

  var decimalParts = parts[0].split('.');
  if (decimalParts.length === 2) {
    decimalPlaces += decimalParts[1].length;
  }

  return decimalPlaces;
};

helpers$3.isSchema = function isSchema(val){
  return (typeof val === 'object' && val) || (typeof val === 'boolean');
};

var helpers$2 = helpers$3;

/** @type ValidatorResult */
var ValidatorResult$1 = helpers$2.ValidatorResult;
/** @type SchemaError */
var SchemaError$1 = helpers$2.SchemaError;

var attribute$1 = {};

attribute$1.ignoreProperties = {
  // informative properties
  'id': true,
  'default': true,
  'description': true,
  'title': true,
  // arguments to other properties
  'additionalItems': true,
  'then': true,
  'else': true,
  // special-handled properties
  '$schema': true,
  '$ref': true,
  'extends': true,
};

/**
 * @name validators
 */
var validators = attribute$1.validators = {};

/**
 * Validates whether the instance if of a certain type
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {ValidatorResult|null}
 */
validators.type = function validateType (instance, schema, options, ctx) {
  // Ignore undefined instances
  if (instance === undefined) {
    return null;
  }
  var result = new ValidatorResult$1(instance, schema, options, ctx);
  var types = Array.isArray(schema.type) ? schema.type : [schema.type];
  if (!types.some(this.testType.bind(this, instance, schema, options, ctx))) {
    var list = types.map(function (v) {
      if(!v) return;
      var id = v.$id || v.id;
      return id ? ('<' + id + '>') : (v+'');
    });
    result.addError({
      name: 'type',
      argument: list,
      message: "is not of a type(s) " + list,
    });
  }
  return result;
};

function testSchemaNoThrow(instance, options, ctx, callback, schema){
  var throwError = options.throwError;
  var throwAll = options.throwAll;
  options.throwError = false;
  options.throwAll = false;
  var res = this.validateSchema(instance, schema, options, ctx);
  options.throwError = throwError;
  options.throwAll = throwAll;

  if (!res.valid && callback instanceof Function) {
    callback(res);
  }
  return res.valid;
}

/**
 * Validates whether the instance matches some of the given schemas
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {ValidatorResult|null}
 */
validators.anyOf = function validateAnyOf (instance, schema, options, ctx) {
  // Ignore undefined instances
  if (instance === undefined) {
    return null;
  }
  var result = new ValidatorResult$1(instance, schema, options, ctx);
  var inner = new ValidatorResult$1(instance, schema, options, ctx);
  if (!Array.isArray(schema.anyOf)){
    throw new SchemaError$1("anyOf must be an array");
  }
  if (!schema.anyOf.some(
    testSchemaNoThrow.bind(
      this, instance, options, ctx, function(res){inner.importErrors(res);}
    ))) {
    var list = schema.anyOf.map(function (v, i) {
      var id = v.$id || v.id;
      if(id) return '<' + id + '>';
      return (v.title && JSON.stringify(v.title)) || (v['$ref'] && ('<' + v['$ref'] + '>')) || '[subschema '+i+']';
    });
    if (options.nestedErrors) {
      result.importErrors(inner);
    }
    result.addError({
      name: 'anyOf',
      argument: list,
      message: "is not any of " + list.join(','),
    });
  }
  return result;
};

/**
 * Validates whether the instance matches every given schema
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null}
 */
validators.allOf = function validateAllOf (instance, schema, options, ctx) {
  // Ignore undefined instances
  if (instance === undefined) {
    return null;
  }
  if (!Array.isArray(schema.allOf)){
    throw new SchemaError$1("allOf must be an array");
  }
  var result = new ValidatorResult$1(instance, schema, options, ctx);
  var self = this;
  schema.allOf.forEach(function(v, i){
    var valid = self.validateSchema(instance, v, options, ctx);
    if(!valid.valid){
      var id = v.$id || v.id;
      var msg = id || (v.title && JSON.stringify(v.title)) || (v['$ref'] && ('<' + v['$ref'] + '>')) || '[subschema '+i+']';
      result.addError({
        name: 'allOf',
        argument: { id: msg, length: valid.errors.length, valid: valid },
        message: 'does not match allOf schema ' + msg + ' with ' + valid.errors.length + ' error[s]:',
      });
      result.importErrors(valid);
    }
  });
  return result;
};

/**
 * Validates whether the instance matches exactly one of the given schemas
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null}
 */
validators.oneOf = function validateOneOf (instance, schema, options, ctx) {
  // Ignore undefined instances
  if (instance === undefined) {
    return null;
  }
  if (!Array.isArray(schema.oneOf)){
    throw new SchemaError$1("oneOf must be an array");
  }
  var result = new ValidatorResult$1(instance, schema, options, ctx);
  var inner = new ValidatorResult$1(instance, schema, options, ctx);
  var count = schema.oneOf.filter(
    testSchemaNoThrow.bind(
      this, instance, options, ctx, function(res) {inner.importErrors(res);}
    ) ).length;
  var list = schema.oneOf.map(function (v, i) {
    var id = v.$id || v.id;
    return id || (v.title && JSON.stringify(v.title)) || (v['$ref'] && ('<' + v['$ref'] + '>')) || '[subschema '+i+']';
  });
  if (count!==1) {
    if (options.nestedErrors) {
      result.importErrors(inner);
    }
    result.addError({
      name: 'oneOf',
      argument: list,
      message: "is not exactly one from " + list.join(','),
    });
  }
  return result;
};

/**
 * Validates "then" or "else" depending on the result of validating "if"
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null}
 */
validators.if = function validateIf (instance, schema, options, ctx) {
  // Ignore undefined instances
  if (instance === undefined) return null;
  if (!helpers$2.isSchema(schema.if)) throw new Error('Expected "if" keyword to be a schema');
  var ifValid = testSchemaNoThrow.call(this, instance, options, ctx, null, schema.if);
  var result = new ValidatorResult$1(instance, schema, options, ctx);
  var res;
  if(ifValid){
    if (schema.then === undefined) return;
    if (!helpers$2.isSchema(schema.then)) throw new Error('Expected "then" keyword to be a schema');
    res = this.validateSchema(instance, schema.then, options, ctx.makeChild(schema.then));
    result.importErrors(res);
  }else {
    if (schema.else === undefined) return;
    if (!helpers$2.isSchema(schema.else)) throw new Error('Expected "else" keyword to be a schema');
    res = this.validateSchema(instance, schema.else, options, ctx.makeChild(schema.else));
    result.importErrors(res);
  }
  return result;
};

function getEnumerableProperty(object, key){
  // Determine if `key` shows up in `for(var key in object)`
  // First test Object.hasOwnProperty.call as an optimization: that guarantees it does
  if(Object.hasOwnProperty.call(object, key)) return object[key];
  // Test `key in object` as an optimization; false means it won't
  if(!(key in object)) return;
  while( (object = Object.getPrototypeOf(object)) ){
    if(Object.propertyIsEnumerable.call(object, key)) return object[key];
  }
}

/**
 * Validates propertyNames
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null|ValidatorResult}
 */
validators.propertyNames = function validatePropertyNames (instance, schema, options, ctx) {
  if(!this.types.object(instance)) return;
  var result = new ValidatorResult$1(instance, schema, options, ctx);
  var subschema = schema.propertyNames!==undefined ? schema.propertyNames : {};
  if(!helpers$2.isSchema(subschema)) throw new SchemaError$1('Expected "propertyNames" to be a schema (object or boolean)');

  for (var property in instance) {
    if(getEnumerableProperty(instance, property) !== undefined){
      var res = this.validateSchema(property, subschema, options, ctx.makeChild(subschema));
      result.importErrors(res);
    }
  }

  return result;
};

/**
 * Validates properties
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null|ValidatorResult}
 */
validators.properties = function validateProperties (instance, schema, options, ctx) {
  if(!this.types.object(instance)) return;
  var result = new ValidatorResult$1(instance, schema, options, ctx);
  var properties = schema.properties || {};
  for (var property in properties) {
    var subschema = properties[property];
    if(subschema===undefined){
      continue;
    }else if(subschema===null){
      throw new SchemaError$1('Unexpected null, expected schema in "properties"');
    }
    if (typeof options.preValidateProperty == 'function') {
      options.preValidateProperty(instance, property, subschema, options, ctx);
    }
    var prop = getEnumerableProperty(instance, property);
    var res = this.validateSchema(prop, subschema, options, ctx.makeChild(subschema, property));
    if(res.instance !== result.instance[property]) result.instance[property] = res.instance;
    result.importErrors(res);
  }
  return result;
};

/**
 * Test a specific property within in instance against the additionalProperties schema attribute
 * This ignores properties with definitions in the properties schema attribute, but no other attributes.
 * If too many more types of property-existence tests pop up they may need their own class of tests (like `type` has)
 * @private
 * @return {boolean}
 */
function testAdditionalProperty (instance, schema, options, ctx, property, result) {
  if(!this.types.object(instance)) return;
  if (schema.properties && schema.properties[property] !== undefined) {
    return;
  }
  if (schema.additionalProperties === false) {
    result.addError({
      name: 'additionalProperties',
      argument: property,
      message: "is not allowed to have the additional property " + JSON.stringify(property),
    });
  } else {
    var additionalProperties = schema.additionalProperties || {};

    if (typeof options.preValidateProperty == 'function') {
      options.preValidateProperty(instance, property, additionalProperties, options, ctx);
    }

    var res = this.validateSchema(instance[property], additionalProperties, options, ctx.makeChild(additionalProperties, property));
    if(res.instance !== result.instance[property]) result.instance[property] = res.instance;
    result.importErrors(res);
  }
}

/**
 * Validates patternProperties
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null|ValidatorResult}
 */
validators.patternProperties = function validatePatternProperties (instance, schema, options, ctx) {
  if(!this.types.object(instance)) return;
  var result = new ValidatorResult$1(instance, schema, options, ctx);
  var patternProperties = schema.patternProperties || {};

  for (var property in instance) {
    var test = true;
    for (var pattern in patternProperties) {
      var subschema = patternProperties[pattern];
      if(subschema===undefined){
        continue;
      }else if(subschema===null){
        throw new SchemaError$1('Unexpected null, expected schema in "patternProperties"');
      }
      try {
        var regexp = new RegExp(pattern, 'u');
      } catch(_e) {
        // In the event the stricter handling causes an error, fall back on the forgiving handling
        // DEPRECATED
        regexp = new RegExp(pattern);
      }
      if (!regexp.test(property)) {
        continue;
      }
      test = false;

      if (typeof options.preValidateProperty == 'function') {
        options.preValidateProperty(instance, property, subschema, options, ctx);
      }

      var res = this.validateSchema(instance[property], subschema, options, ctx.makeChild(subschema, property));
      if(res.instance !== result.instance[property]) result.instance[property] = res.instance;
      result.importErrors(res);
    }
    if (test) {
      testAdditionalProperty.call(this, instance, schema, options, ctx, property, result);
    }
  }

  return result;
};

/**
 * Validates additionalProperties
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null|ValidatorResult}
 */
validators.additionalProperties = function validateAdditionalProperties (instance, schema, options, ctx) {
  if(!this.types.object(instance)) return;
  // if patternProperties is defined then we'll test when that one is called instead
  if (schema.patternProperties) {
    return null;
  }
  var result = new ValidatorResult$1(instance, schema, options, ctx);
  for (var property in instance) {
    testAdditionalProperty.call(this, instance, schema, options, ctx, property, result);
  }
  return result;
};

/**
 * Validates whether the instance value is at least of a certain length, when the instance value is a string.
 * @param instance
 * @param schema
 * @return {String|null}
 */
validators.minProperties = function validateMinProperties (instance, schema, options, ctx) {
  if (!this.types.object(instance)) return;
  var result = new ValidatorResult$1(instance, schema, options, ctx);
  var keys = Object.keys(instance);
  if (!(keys.length >= schema.minProperties)) {
    result.addError({
      name: 'minProperties',
      argument: schema.minProperties,
      message: "does not meet minimum property length of " + schema.minProperties,
    });
  }
  return result;
};

/**
 * Validates whether the instance value is at most of a certain length, when the instance value is a string.
 * @param instance
 * @param schema
 * @return {String|null}
 */
validators.maxProperties = function validateMaxProperties (instance, schema, options, ctx) {
  if (!this.types.object(instance)) return;
  var result = new ValidatorResult$1(instance, schema, options, ctx);
  var keys = Object.keys(instance);
  if (!(keys.length <= schema.maxProperties)) {
    result.addError({
      name: 'maxProperties',
      argument: schema.maxProperties,
      message: "does not meet maximum property length of " + schema.maxProperties,
    });
  }
  return result;
};

/**
 * Validates items when instance is an array
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {String|null|ValidatorResult}
 */
validators.items = function validateItems (instance, schema, options, ctx) {
  var self = this;
  if (!this.types.array(instance)) return;
  if (!schema.items) return;
  var result = new ValidatorResult$1(instance, schema, options, ctx);
  instance.every(function (value, i) {
    var items = Array.isArray(schema.items) ? (schema.items[i] || schema.additionalItems) : schema.items;
    if (items === undefined) {
      return true;
    }
    if (items === false) {
      result.addError({
        name: 'items',
        message: "additionalItems not permitted",
      });
      return false;
    }
    var res = self.validateSchema(value, items, options, ctx.makeChild(items, i));
    if(res.instance !== result.instance[i]) result.instance[i] = res.instance;
    result.importErrors(res);
    return true;
  });
  return result;
};

/**
 * Validates minimum and exclusiveMinimum when the type of the instance value is a number.
 * @param instance
 * @param schema
 * @return {String|null}
 */
validators.minimum = function validateMinimum (instance, schema, options, ctx) {
  if (!this.types.number(instance)) return;
  var result = new ValidatorResult$1(instance, schema, options, ctx);
  if (schema.exclusiveMinimum && schema.exclusiveMinimum === true) {
    if(!(instance > schema.minimum)){
      result.addError({
        name: 'minimum',
        argument: schema.minimum,
        message: "must be greater than " + schema.minimum,
      });
    }
  } else {
    if(!(instance >= schema.minimum)){
      result.addError({
        name: 'minimum',
        argument: schema.minimum,
        message: "must be greater than or equal to " + schema.minimum,
      });
    }
  }
  return result;
};

/**
 * Validates maximum and exclusiveMaximum when the type of the instance value is a number.
 * @param instance
 * @param schema
 * @return {String|null}
 */
validators.maximum = function validateMaximum (instance, schema, options, ctx) {
  if (!this.types.number(instance)) return;
  var result = new ValidatorResult$1(instance, schema, options, ctx);
  if (schema.exclusiveMaximum && schema.exclusiveMaximum === true) {
    if(!(instance < schema.maximum)){
      result.addError({
        name: 'maximum',
        argument: schema.maximum,
        message: "must be less than " + schema.maximum,
      });
    }
  } else {
    if(!(instance <= schema.maximum)){
      result.addError({
        name: 'maximum',
        argument: schema.maximum,
        message: "must be less than or equal to " + schema.maximum,
      });
    }
  }
  return result;
};

/**
 * Validates the number form of exclusiveMinimum when the type of the instance value is a number.
 * @param instance
 * @param schema
 * @return {String|null}
 */
validators.exclusiveMinimum = function validateExclusiveMinimum (instance, schema, options, ctx) {
  // Support the boolean form of exclusiveMinimum, which is handled by the "minimum" keyword.
  if(typeof schema.exclusiveMaximum === 'boolean') return;
  if (!this.types.number(instance)) return;
  var result = new ValidatorResult$1(instance, schema, options, ctx);
  var valid = instance > schema.exclusiveMinimum;
  if (!valid) {
    result.addError({
      name: 'exclusiveMinimum',
      argument: schema.exclusiveMinimum,
      message: "must be strictly greater than " + schema.exclusiveMinimum,
    });
  }
  return result;
};

/**
 * Validates the number form of exclusiveMaximum when the type of the instance value is a number.
 * @param instance
 * @param schema
 * @return {String|null}
 */
validators.exclusiveMaximum = function validateExclusiveMaximum (instance, schema, options, ctx) {
  // Support the boolean form of exclusiveMaximum, which is handled by the "maximum" keyword.
  if(typeof schema.exclusiveMaximum === 'boolean') return;
  if (!this.types.number(instance)) return;
  var result = new ValidatorResult$1(instance, schema, options, ctx);
  var valid = instance < schema.exclusiveMaximum;
  if (!valid) {
    result.addError({
      name: 'exclusiveMaximum',
      argument: schema.exclusiveMaximum,
      message: "must be strictly less than " + schema.exclusiveMaximum,
    });
  }
  return result;
};

/**
 * Perform validation for multipleOf and divisibleBy, which are essentially the same.
 * @param instance
 * @param schema
 * @param validationType
 * @param errorMessage
 * @returns {String|null}
 */
var validateMultipleOfOrDivisbleBy = function validateMultipleOfOrDivisbleBy (instance, schema, options, ctx, validationType, errorMessage) {
  if (!this.types.number(instance)) return;

  var validationArgument = schema[validationType];
  if (validationArgument == 0) {
    throw new SchemaError$1(validationType + " cannot be zero");
  }

  var result = new ValidatorResult$1(instance, schema, options, ctx);

  var instanceDecimals = helpers$2.getDecimalPlaces(instance);
  var divisorDecimals = helpers$2.getDecimalPlaces(validationArgument);

  var maxDecimals = Math.max(instanceDecimals , divisorDecimals);
  var multiplier = Math.pow(10, maxDecimals);

  if (Math.round(instance * multiplier) % Math.round(validationArgument * multiplier) !== 0) {
    result.addError({
      name: validationType,
      argument:  validationArgument,
      message: errorMessage + JSON.stringify(validationArgument),
    });
  }

  return result;
};

/**
 * Validates divisibleBy when the type of the instance value is a number.
 * @param instance
 * @param schema
 * @return {String|null}
 */
validators.multipleOf = function validateMultipleOf (instance, schema, options, ctx) {
  return validateMultipleOfOrDivisbleBy.call(this, instance, schema, options, ctx, "multipleOf", "is not a multiple of (divisible by) ");
};

/**
 * Validates multipleOf when the type of the instance value is a number.
 * @param instance
 * @param schema
 * @return {String|null}
 */
validators.divisibleBy = function validateDivisibleBy (instance, schema, options, ctx) {
  return validateMultipleOfOrDivisbleBy.call(this, instance, schema, options, ctx, "divisibleBy", "is not divisible by (multiple of) ");
};

/**
 * Validates whether the instance value is present.
 * @param instance
 * @param schema
 * @return {String|null}
 */
validators.required = function validateRequired (instance, schema, options, ctx) {
  var result = new ValidatorResult$1(instance, schema, options, ctx);
  if (instance === undefined && schema.required === true) {
    // A boolean form is implemented for reverse-compatibility with schemas written against older drafts
    result.addError({
      name: 'required',
      message: "is required",
    });
  } else if (this.types.object(instance) && Array.isArray(schema.required)) {
    schema.required.forEach(function(n){
      if(getEnumerableProperty(instance, n)===undefined){
        result.addError({
          name: 'required',
          argument: n,
          message: "requires property " + JSON.stringify(n),
        });
      }
    });
  }
  return result;
};

/**
 * Validates whether the instance value matches the regular expression, when the instance value is a string.
 * @param instance
 * @param schema
 * @return {String|null}
 */
validators.pattern = function validatePattern (instance, schema, options, ctx) {
  if (!this.types.string(instance)) return;
  var result = new ValidatorResult$1(instance, schema, options, ctx);
  var pattern = schema.pattern;
  try {
    var regexp = new RegExp(pattern, 'u');
  } catch(_e) {
    // In the event the stricter handling causes an error, fall back on the forgiving handling
    // DEPRECATED
    regexp = new RegExp(pattern);
  }
  if (!instance.match(regexp)) {
    result.addError({
      name: 'pattern',
      argument: schema.pattern,
      message: "does not match pattern " + JSON.stringify(schema.pattern.toString()),
    });
  }
  return result;
};

/**
 * Validates whether the instance value is of a certain defined format or a custom
 * format.
 * The following formats are supported for string types:
 *   - date-time
 *   - date
 *   - time
 *   - ip-address
 *   - ipv6
 *   - uri
 *   - color
 *   - host-name
 *   - alpha
 *   - alpha-numeric
 *   - utc-millisec
 * @param instance
 * @param schema
 * @param [options]
 * @param [ctx]
 * @return {String|null}
 */
validators.format = function validateFormat (instance, schema, options, ctx) {
  if (instance===undefined) return;
  var result = new ValidatorResult$1(instance, schema, options, ctx);
  if (!result.disableFormat && !helpers$2.isFormat(instance, schema.format, this)) {
    result.addError({
      name: 'format',
      argument: schema.format,
      message: "does not conform to the " + JSON.stringify(schema.format) + " format",
    });
  }
  return result;
};

/**
 * Validates whether the instance value is at least of a certain length, when the instance value is a string.
 * @param instance
 * @param schema
 * @return {String|null}
 */
validators.minLength = function validateMinLength (instance, schema, options, ctx) {
  if (!this.types.string(instance)) return;
  var result = new ValidatorResult$1(instance, schema, options, ctx);
  var hsp = instance.match(/[\uDC00-\uDFFF]/g);
  var length = instance.length - (hsp ? hsp.length : 0);
  if (!(length >= schema.minLength)) {
    result.addError({
      name: 'minLength',
      argument: schema.minLength,
      message: "does not meet minimum length of " + schema.minLength,
    });
  }
  return result;
};

/**
 * Validates whether the instance value is at most of a certain length, when the instance value is a string.
 * @param instance
 * @param schema
 * @return {String|null}
 */
validators.maxLength = function validateMaxLength (instance, schema, options, ctx) {
  if (!this.types.string(instance)) return;
  var result = new ValidatorResult$1(instance, schema, options, ctx);
  // TODO if this was already computed in "minLength", use that value instead of re-computing
  var hsp = instance.match(/[\uDC00-\uDFFF]/g);
  var length = instance.length - (hsp ? hsp.length : 0);
  if (!(length <= schema.maxLength)) {
    result.addError({
      name: 'maxLength',
      argument: schema.maxLength,
      message: "does not meet maximum length of " + schema.maxLength,
    });
  }
  return result;
};

/**
 * Validates whether instance contains at least a minimum number of items, when the instance is an Array.
 * @param instance
 * @param schema
 * @return {String|null}
 */
validators.minItems = function validateMinItems (instance, schema, options, ctx) {
  if (!this.types.array(instance)) return;
  var result = new ValidatorResult$1(instance, schema, options, ctx);
  if (!(instance.length >= schema.minItems)) {
    result.addError({
      name: 'minItems',
      argument: schema.minItems,
      message: "does not meet minimum length of " + schema.minItems,
    });
  }
  return result;
};

/**
 * Validates whether instance contains no more than a maximum number of items, when the instance is an Array.
 * @param instance
 * @param schema
 * @return {String|null}
 */
validators.maxItems = function validateMaxItems (instance, schema, options, ctx) {
  if (!this.types.array(instance)) return;
  var result = new ValidatorResult$1(instance, schema, options, ctx);
  if (!(instance.length <= schema.maxItems)) {
    result.addError({
      name: 'maxItems',
      argument: schema.maxItems,
      message: "does not meet maximum length of " + schema.maxItems,
    });
  }
  return result;
};

/**
 * Deep compares arrays for duplicates
 * @param v
 * @param i
 * @param a
 * @private
 * @return {boolean}
 */
function testArrays (v, i, a) {
  var j, len = a.length;
  for (j = i + 1, len; j < len; j++) {
    if (helpers$2.deepCompareStrict(v, a[j])) {
      return false;
    }
  }
  return true;
}

/**
 * Validates whether there are no duplicates, when the instance is an Array.
 * @param instance
 * @return {String|null}
 */
validators.uniqueItems = function validateUniqueItems (instance, schema, options, ctx) {
  if (schema.uniqueItems!==true) return;
  if (!this.types.array(instance)) return;
  var result = new ValidatorResult$1(instance, schema, options, ctx);
  if (!instance.every(testArrays)) {
    result.addError({
      name: 'uniqueItems',
      message: "contains duplicate item",
    });
  }
  return result;
};

/**
 * Validate for the presence of dependency properties, if the instance is an object.
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {null|ValidatorResult}
 */
validators.dependencies = function validateDependencies (instance, schema, options, ctx) {
  if (!this.types.object(instance)) return;
  var result = new ValidatorResult$1(instance, schema, options, ctx);
  for (var property in schema.dependencies) {
    if (instance[property] === undefined) {
      continue;
    }
    var dep = schema.dependencies[property];
    var childContext = ctx.makeChild(dep, property);
    if (typeof dep == 'string') {
      dep = [dep];
    }
    if (Array.isArray(dep)) {
      dep.forEach(function (prop) {
        if (instance[prop] === undefined) {
          result.addError({
            // FIXME there's two different "dependencies" errors here with slightly different outputs
            // Can we make these the same? Or should we create different error types?
            name: 'dependencies',
            argument: childContext.propertyPath,
            message: "property " + prop + " not found, required by " + childContext.propertyPath,
          });
        }
      });
    } else {
      var res = this.validateSchema(instance, dep, options, childContext);
      if(result.instance !== res.instance) result.instance = res.instance;
      if (res && res.errors.length) {
        result.addError({
          name: 'dependencies',
          argument: childContext.propertyPath,
          message: "does not meet dependency required by " + childContext.propertyPath,
        });
        result.importErrors(res);
      }
    }
  }
  return result;
};

/**
 * Validates whether the instance value is one of the enumerated values.
 *
 * @param instance
 * @param schema
 * @return {ValidatorResult|null}
 */
validators['enum'] = function validateEnum (instance, schema, options, ctx) {
  if (instance === undefined) {
    return null;
  }
  if (!Array.isArray(schema['enum'])) {
    throw new SchemaError$1("enum expects an array", schema);
  }
  var result = new ValidatorResult$1(instance, schema, options, ctx);
  if (!schema['enum'].some(helpers$2.deepCompareStrict.bind(null, instance))) {
    result.addError({
      name: 'enum',
      argument: schema['enum'],
      message: "is not one of enum values: " + schema['enum'].map(String).join(','),
    });
  }
  return result;
};

/**
 * Validates whether the instance exactly matches a given value
 *
 * @param instance
 * @param schema
 * @return {ValidatorResult|null}
 */
validators['const'] = function validateEnum (instance, schema, options, ctx) {
  if (instance === undefined) {
    return null;
  }
  var result = new ValidatorResult$1(instance, schema, options, ctx);
  if (!helpers$2.deepCompareStrict(schema['const'], instance)) {
    result.addError({
      name: 'const',
      argument: schema['const'],
      message: "does not exactly match expected constant: " + schema['const'],
    });
  }
  return result;
};

/**
 * Validates whether the instance if of a prohibited type.
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @return {null|ValidatorResult}
 */
validators.not = validators.disallow = function validateNot (instance, schema, options, ctx) {
  var self = this;
  if(instance===undefined) return null;
  var result = new ValidatorResult$1(instance, schema, options, ctx);
  var notTypes = schema.not || schema.disallow;
  if(!notTypes) return null;
  if(!Array.isArray(notTypes)) notTypes=[notTypes];
  notTypes.forEach(function (type) {
    if (self.testType(instance, schema, options, ctx, type)) {
      var id = type && (type.$id || type.id);
      var schemaId = id || type;
      result.addError({
        name: 'not',
        argument: schemaId,
        message: "is of prohibited type " + schemaId,
      });
    }
  });
  return result;
};

var attribute_1 = attribute$1;

var scan = {};

var urilib$1 = require$$0;
var helpers$1 = helpers$3;

scan.SchemaScanResult = SchemaScanResult;
function SchemaScanResult(found, ref){
  this.id = found;
  this.ref = ref;
}

/**
 * Adds a schema with a certain urn to the Validator instance.
 * @param string uri
 * @param object schema
 * @return {Object}
 */
scan.scan = function scan(base, schema){
  function scanSchema(baseuri, schema){
    if(!schema || typeof schema!='object') return;
    // Mark all referenced schemas so we can tell later which schemas are referred to, but never defined
    if(schema.$ref){
      var resolvedUri = urilib$1.resolve(baseuri, schema.$ref);
      ref[resolvedUri] = ref[resolvedUri] ? ref[resolvedUri]+1 : 0;
      return;
    }
    var id = schema.$id || schema.id;
    var ourBase = id ? urilib$1.resolve(baseuri, id) : baseuri;
    if (ourBase) {
      // If there's no fragment, append an empty one
      if(ourBase.indexOf('#')<0) ourBase += '#';
      if(found[ourBase]){
        if(!helpers$1.deepCompareStrict(found[ourBase], schema)){
          throw new Error('Schema <'+ourBase+'> already exists with different definition');
        }
        return found[ourBase];
      }
      found[ourBase] = schema;
      // strip trailing fragment
      if(ourBase[ourBase.length-1]=='#'){
        found[ourBase.substring(0, ourBase.length-1)] = schema;
      }
    }
    scanArray(ourBase+'/items', (Array.isArray(schema.items)?schema.items:[schema.items]));
    scanArray(ourBase+'/extends', (Array.isArray(schema.extends)?schema.extends:[schema.extends]));
    scanSchema(ourBase+'/additionalItems', schema.additionalItems);
    scanObject(ourBase+'/properties', schema.properties);
    scanSchema(ourBase+'/additionalProperties', schema.additionalProperties);
    scanObject(ourBase+'/definitions', schema.definitions);
    scanObject(ourBase+'/patternProperties', schema.patternProperties);
    scanObject(ourBase+'/dependencies', schema.dependencies);
    scanArray(ourBase+'/disallow', schema.disallow);
    scanArray(ourBase+'/allOf', schema.allOf);
    scanArray(ourBase+'/anyOf', schema.anyOf);
    scanArray(ourBase+'/oneOf', schema.oneOf);
    scanSchema(ourBase+'/not', schema.not);
  }
  function scanArray(baseuri, schemas){
    if(!Array.isArray(schemas)) return;
    for(var i=0; i<schemas.length; i++){
      scanSchema(baseuri+'/'+i, schemas[i]);
    }
  }
  function scanObject(baseuri, schemas){
    if(!schemas || typeof schemas!='object') return;
    for(var p in schemas){
      scanSchema(baseuri+'/'+p, schemas[p]);
    }
  }

  var found = {};
  var ref = {};
  scanSchema(base, schema);
  return new SchemaScanResult(found, ref);
};

var urilib = require$$0;

var attribute = attribute_1;
var helpers = helpers$3;
var scanSchema = scan.scan;
var ValidatorResult = helpers.ValidatorResult;
var ValidatorResultError = helpers.ValidatorResultError;
var SchemaError = helpers.SchemaError;
var SchemaContext = helpers.SchemaContext;
//var anonymousBase = 'vnd.jsonschema:///';
var anonymousBase = '/';

/**
 * Creates a new Validator object
 * @name Validator
 * @constructor
 */
var Validator$1 = function Validator () {
  // Allow a validator instance to override global custom formats or to have their
  // own custom formats.
  this.customFormats = Object.create(Validator.prototype.customFormats);
  this.schemas = {};
  this.unresolvedRefs = [];

  // Use Object.create to make this extensible without Validator instances stepping on each other's toes.
  this.types = Object.create(types$1);
  this.attributes = Object.create(attribute.validators);
};

// Allow formats to be registered globally.
Validator$1.prototype.customFormats = {};

// Hint at the presence of a property
Validator$1.prototype.schemas = null;
Validator$1.prototype.types = null;
Validator$1.prototype.attributes = null;
Validator$1.prototype.unresolvedRefs = null;

/**
 * Adds a schema with a certain urn to the Validator instance.
 * @param schema
 * @param urn
 * @return {Object}
 */
Validator$1.prototype.addSchema = function addSchema (schema, base) {
  var self = this;
  if (!schema) {
    return null;
  }
  var scan = scanSchema(base||anonymousBase, schema);
  var ourUri = base || schema.$id || schema.id;
  for(var uri in scan.id){
    this.schemas[uri] = scan.id[uri];
  }
  for(var uri in scan.ref){
    // If this schema is already defined, it will be filtered out by the next step
    this.unresolvedRefs.push(uri);
  }
  // Remove newly defined schemas from unresolvedRefs
  this.unresolvedRefs = this.unresolvedRefs.filter(function(uri){
    return typeof self.schemas[uri]==='undefined';
  });
  return this.schemas[ourUri];
};

Validator$1.prototype.addSubSchemaArray = function addSubSchemaArray(baseuri, schemas) {
  if(!Array.isArray(schemas)) return;
  for(var i=0; i<schemas.length; i++){
    this.addSubSchema(baseuri, schemas[i]);
  }
};

Validator$1.prototype.addSubSchemaObject = function addSubSchemaArray(baseuri, schemas) {
  if(!schemas || typeof schemas!='object') return;
  for(var p in schemas){
    this.addSubSchema(baseuri, schemas[p]);
  }
};



/**
 * Sets all the schemas of the Validator instance.
 * @param schemas
 */
Validator$1.prototype.setSchemas = function setSchemas (schemas) {
  this.schemas = schemas;
};

/**
 * Returns the schema of a certain urn
 * @param urn
 */
Validator$1.prototype.getSchema = function getSchema (urn) {
  return this.schemas[urn];
};

/**
 * Validates instance against the provided schema
 * @param instance
 * @param schema
 * @param [options]
 * @param [ctx]
 * @return {Array}
 */
Validator$1.prototype.validate = function validate (instance, schema, options, ctx) {
  if((typeof schema !== 'boolean' && typeof schema !== 'object') || schema === null){
    throw new SchemaError('Expected `schema` to be an object or boolean');
  }
  if (!options) {
    options = {};
  }
  // This section indexes subschemas in the provided schema, so they don't need to be added with Validator#addSchema
  // This will work so long as the function at uri.resolve() will resolve a relative URI to a relative URI
  var id = schema.$id || schema.id;
  var base = urilib.resolve(options.base||anonymousBase, id||'');
  if(!ctx){
    ctx = new SchemaContext(schema, options, [], base, Object.create(this.schemas));
    if (!ctx.schemas[base]) {
      ctx.schemas[base] = schema;
    }
    var found = scanSchema(base, schema);
    for(var n in found.id){
      var sch = found.id[n];
      ctx.schemas[n] = sch;
    }
  }
  if(options.required && instance===undefined){
    var result = new ValidatorResult(instance, schema, options, ctx);
    result.addError('is required, but is undefined');
    return result;
  }
  var result = this.validateSchema(instance, schema, options, ctx);
  if (!result) {
    throw new Error('Result undefined');
  }else if(options.throwAll && result.errors.length){
    throw new ValidatorResultError(result);
  }
  return result;
};

/**
* @param Object schema
* @return mixed schema uri or false
*/
function shouldResolve(schema) {
  var ref = (typeof schema === 'string') ? schema : schema.$ref;
  if (typeof ref=='string') return ref;
  return false;
}

/**
 * Validates an instance against the schema (the actual work horse)
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @private
 * @return {ValidatorResult}
 */
Validator$1.prototype.validateSchema = function validateSchema (instance, schema, options, ctx) {
  var result = new ValidatorResult(instance, schema, options, ctx);

  // Support for the true/false schemas
  if(typeof schema==='boolean') {
    if(schema===true){
      // `true` is always valid
      schema = {};
    }else if(schema===false){
      // `false` is always invalid
      schema = {type: []};
    }
  }else if(!schema){
    // This might be a string
    throw new Error("schema is undefined");
  }

  if (schema['extends']) {
    if (Array.isArray(schema['extends'])) {
      var schemaobj = {schema: schema, ctx: ctx};
      schema['extends'].forEach(this.schemaTraverser.bind(this, schemaobj));
      schema = schemaobj.schema;
      schemaobj.schema = null;
      schemaobj.ctx = null;
      schemaobj = null;
    } else {
      schema = helpers.deepMerge(schema, this.superResolve(schema['extends'], ctx));
    }
  }

  // If passed a string argument, load that schema URI
  var switchSchema = shouldResolve(schema);
  if (switchSchema) {
    var resolved = this.resolve(schema, switchSchema, ctx);
    var subctx = new SchemaContext(resolved.subschema, options, ctx.path, resolved.switchSchema, ctx.schemas);
    return this.validateSchema(instance, resolved.subschema, options, subctx);
  }

  var skipAttributes = options && options.skipAttributes || [];
  // Validate each schema attribute against the instance
  for (var key in schema) {
    if (!attribute.ignoreProperties[key] && skipAttributes.indexOf(key) < 0) {
      var validatorErr = null;
      var validator = this.attributes[key];
      if (validator) {
        validatorErr = validator.call(this, instance, schema, options, ctx);
      } else if (options.allowUnknownAttributes === false) {
        // This represents an error with the schema itself, not an invalid instance
        throw new SchemaError("Unsupported attribute: " + key, schema);
      }
      if (validatorErr) {
        result.importErrors(validatorErr);
      }
    }
  }

  if (typeof options.rewrite == 'function') {
    var value = options.rewrite.call(this, instance, schema, options, ctx);
    result.instance = value;
  }
  return result;
};

/**
* @private
* @param Object schema
* @param SchemaContext ctx
* @returns Object schema or resolved schema
*/
Validator$1.prototype.schemaTraverser = function schemaTraverser (schemaobj, s) {
  schemaobj.schema = helpers.deepMerge(schemaobj.schema, this.superResolve(s, schemaobj.ctx));
};

/**
* @private
* @param Object schema
* @param SchemaContext ctx
* @returns Object schema or resolved schema
*/
Validator$1.prototype.superResolve = function superResolve (schema, ctx) {
  var ref = shouldResolve(schema);
  if(ref) {
    return this.resolve(schema, ref, ctx).subschema;
  }
  return schema;
};

/**
* @private
* @param Object schema
* @param Object switchSchema
* @param SchemaContext ctx
* @return Object resolved schemas {subschema:String, switchSchema: String}
* @throws SchemaError
*/
Validator$1.prototype.resolve = function resolve (schema, switchSchema, ctx) {
  switchSchema = ctx.resolve(switchSchema);
  // First see if the schema exists under the provided URI
  if (ctx.schemas[switchSchema]) {
    return {subschema: ctx.schemas[switchSchema], switchSchema: switchSchema};
  }
  // Else try walking the property pointer
  var parsed = urilib.parse(switchSchema);
  var fragment = parsed && parsed.hash;
  var document = fragment && fragment.length && switchSchema.substr(0, switchSchema.length - fragment.length);
  if (!document || !ctx.schemas[document]) {
    throw new SchemaError("no such schema <" + switchSchema + ">", schema);
  }
  var subschema = helpers.objectGetPath(ctx.schemas[document], fragment.substr(1));
  if(subschema===undefined){
    throw new SchemaError("no such schema " + fragment + " located in <" + document + ">", schema);
  }
  return {subschema: subschema, switchSchema: switchSchema};
};

/**
 * Tests whether the instance if of a certain type.
 * @private
 * @param instance
 * @param schema
 * @param options
 * @param ctx
 * @param type
 * @return {boolean}
 */
Validator$1.prototype.testType = function validateType (instance, schema, options, ctx, type) {
  if(type===undefined){
    return;
  }else if(type===null){
    throw new SchemaError('Unexpected null in "type" keyword');
  }
  if (typeof this.types[type] == 'function') {
    return this.types[type].call(this, instance);
  }
  if (type && typeof type == 'object') {
    var res = this.validateSchema(instance, type, options, ctx);
    return res === undefined || !(res && res.errors.length);
  }
  // Undefined or properties not on the list are acceptable, same as not being defined
  return true;
};

var types$1 = Validator$1.prototype.types = {};
types$1.string = function testString (instance) {
  return typeof instance == 'string';
};
types$1.number = function testNumber (instance) {
  // isFinite returns false for NaN, Infinity, and -Infinity
  return typeof instance == 'number' && isFinite(instance);
};
types$1.integer = function testInteger (instance) {
  return (typeof instance == 'number') && instance % 1 === 0;
};
types$1.boolean = function testBoolean (instance) {
  return typeof instance == 'boolean';
};
types$1.array = function testArray (instance) {
  return Array.isArray(instance);
};
types$1['null'] = function testNull (instance) {
  return instance === null;
};
types$1.date = function testDate (instance) {
  return instance instanceof Date;
};
types$1.any = function testAny (instance) {
  return true;
};
types$1.object = function testObject (instance) {
  // TODO: fix this - see #15
  return instance && (typeof instance === 'object') && !(Array.isArray(instance)) && !(instance instanceof Date);
};

var validator = Validator$1;

var Validator_1;

var Validator = Validator_1 = validator;

helpers$3.ValidatorResult;
helpers$3.ValidatorResultError;
helpers$3.ValidationError;
helpers$3.SchemaError;

var validate$1 = function (instance, schema, options) {
  var v = new Validator();
  return v.validate(instance, schema, options);
};

var schemaProperties$8 = {
    city: {
        type: 'string',
    },
    state: {
        enum: [
            'AK',
            'AL',
            'AR',
            'AZ',
            'CA',
            'CO',
            'CT',
            'DC',
            'DE',
            'FL',
            'GA',
            'HI',
            'IA',
            'ID',
            'IL',
            'IN',
            'KS',
            'KY',
            'LA',
            'MA',
            'MD',
            'ME',
            'MI',
            'MN',
            'MO',
            'MS',
            'MT',
            'NC',
            'ND',
            'NE',
            'NH',
            'NJ',
            'NM',
            'NV',
            'NY',
            'OH',
            'OK',
            'OR',
            'PA',
            'RI',
            'SC',
            'SD',
            'TN',
            'TX',
            'UT',
            'VA',
            'VT',
            'WA',
            'WI',
            'WV',
            'WY',
        ],
    },
    zip: {
        type: 'string',
    },
    address1: {
        type: 'string',
        format: 'emptyString',
    },
    address2: {
        type: 'string',
        format: 'emptyString',
    },
};
var jsonSchemaMinimumId$d = '/SavvyMinimumBasicAddress';
var jsonSchemaQuoteMinimumId$9 = '/SavvyQuoteMinimumBasicAddress';
var jsonSchemaMinimum$d = {
    id: jsonSchemaMinimumId$d,
    type: 'object',
    properties: schemaProperties$8,
};
var jsonSchemaQuoteMinimum$9 = {
    id: jsonSchemaQuoteMinimumId$9,
    type: 'object',
    properties: schemaProperties$8,
    required: ['address1', 'city', 'state', 'zip'],
};

var schemaProperties$7 = __assign(__assign({}, schemaProperties$8), { number: {
        type: 'string',
    }, street: {
        type: 'string',
    }, type: {
        type: 'string',
    }, secUnitType: {
        type: 'string',
    }, secUnitNum: {
        type: '["integer", "string"]',
    }, plus4: {
        type: ['string', 'integer'],
    }, suffix: {
        type: 'string',
    }, prefix: {
        type: 'string',
    } });
var jsonSchemaMinimumId$c = '/SavvyMinimumAddress';
var jsonSchemaQuoteMinimumId$8 = '/SavvyQuoteMinimumAddress';
var jsonSchemaMinimum$c = {
    id: jsonSchemaMinimumId$c,
    type: 'object',
    properties: schemaProperties$7,
};
var jsonSchemaQuoteMinimum$8 = {
    id: jsonSchemaQuoteMinimumId$8,
    type: 'object',
    properties: schemaProperties$7,
    required: ['number', 'street', 'type', 'city', 'state', 'zip'],
};

var SavvyCoverageName;
(function (SavvyCoverageName) {
    SavvyCoverageName["AccidentalDeathandDismemberment"] = "Accidental Death and Dismemberment";
    SavvyCoverageName["AdditionalPersonalInjuryProtection"] = "Additional Personal Injury Protection";
    SavvyCoverageName["BodilyInjuryLiability"] = "Bodily Injury Liability";
    SavvyCoverageName["CarRentalAndTravelExpenses"] = "Car Rental & Travel Expenses";
    SavvyCoverageName["Collision"] = "Collision";
    SavvyCoverageName["CollisionDeductibleWaiver"] = "Collision Deductible Waiver";
    SavvyCoverageName["CombinedFirstPartyBenefits"] = "Combined First Party Benefits";
    SavvyCoverageName["Comprehensive"] = "Comprehensive";
    SavvyCoverageName["ComprehensiveGlass"] = "Comprehensive Glass";
    SavvyCoverageName["CustomPartsAndEquipment"] = "Custom Parts and Equipment";
    SavvyCoverageName["Disability"] = "Disability";
    SavvyCoverageName["EmergencyRoadService"] = "Emergency Road Service";
    SavvyCoverageName["ExtraordinaryMedicalBenefits"] = "Extraordinary Medical Benefits";
    SavvyCoverageName["FuneralBenefits"] = "Funeral Benefits";
    SavvyCoverageName["GuestPersonalInjuryProtection"] = "Guest Personal Injury Protection";
    SavvyCoverageName["LimitedPropertyDamage"] = "Limited Property Damage";
    SavvyCoverageName["LoanOrLeasePayoff"] = "Loan/Lease Payoff";
    SavvyCoverageName["MechanicalBreakdown"] = "Mechanical Breakdown";
    SavvyCoverageName["MedicalPayments"] = "Medical Payments";
    SavvyCoverageName["NecessaryExpenses"] = "Necessary Expenses";
    SavvyCoverageName["OptionalBasicEconomicLoss"] = "Optional Basic Economic Loss";
    SavvyCoverageName["PermissiveUser"] = "Permissive User";
    SavvyCoverageName["PersonalInjuryProtection"] = "Personal Injury Protection";
    SavvyCoverageName["PetInjury"] = "Pet Injury";
    SavvyCoverageName["PropertyDamageLiability"] = "Property Damage Liability";
    SavvyCoverageName["PropertyProtectionInsurance"] = "Property Protection Insurance";
    SavvyCoverageName["RideshareGap"] = "Rideshare Gap";
    SavvyCoverageName["RoadTripAccidentAccomodations"] = "Road Trip Accident Accomodations";
    SavvyCoverageName["UnderinsuredMotoristBodilyInjury"] = "Underinsured Motorist Bodily Injury";
    SavvyCoverageName["UnderinsuredMotoristPropertyDamage"] = "Underinsured Motorist Property Damage";
    SavvyCoverageName["UninsuredMotoristBodilyInjury"] = "Uninsured Motorist Bodily Injury";
    SavvyCoverageName["UninsuredMotoristPropertyDamage"] = "Uninsured Motorist Property Damage";
    SavvyCoverageName["VanishingDeductible"] = "Vanishing Deductible";
    SavvyCoverageName["WorkLossBenefit"] = "Work Loss Benefit";
})(SavvyCoverageName || (SavvyCoverageName = {}));
var jsonSchemaMinimumId$b = '/SavvyMinimumVehicleCoverage';
var jsonSchemaMinimum$b = {
    id: jsonSchemaMinimumId$b,
    type: 'object',
    properties: {
        name: {
            type: 'string',
        },
        premiumCents: {
            type: 'integer',
        },
        isDeclined: {
            type: 'boolean',
        },
        isImputed: {
            type: 'boolean',
        },
        perPersonLimitCents: {
            type: 'integer',
        },
        perAccidentLimitCents: {
            type: 'integer',
        },
        deductibleCents: {
            type: 'integer',
        },
        glassDeductibleCents: {
            type: 'integer',
        },
        hitAndRunDeductibleCents: {
            type: 'integer',
        },
        perDayLimitCents: {
            type: 'integer',
        },
        perWeekLimitCents: {
            type: 'integer',
        },
        perMonthLimitCents: {
            type: 'integer',
        },
        description: {
            type: 'string',
        },
        displayName: {
            type: 'string',
        },
    },
    required: ['name'],
};
var jsonSchemaCoverageNameId = '/SavvyVehicleCoverageNames';
var jsonSchemaCoverageName = {
    id: jsonSchemaCoverageNameId,
    type: 'object',
    properties: {
        name: {
            enum: Object.values(SavvyCoverageName),
        },
    },
    required: ['name'],
};
var validateMinimumCoverage = function (coverage) {
    return validate$1(coverage, jsonSchemaMinimum$b, { required: true });
};
var validateCoverageName = function (coverage) {
    return validate$1(coverage, jsonSchemaCoverageName, { required: true });
};

var SavvyDiscountName;
(function (SavvyDiscountName) {
    SavvyDiscountName["GoodDriver"] = "Good Driver";
    SavvyDiscountName["CustomerLoyalty"] = "Customer Loyalty";
    SavvyDiscountName["Homeowner"] = "Homeowner";
    SavvyDiscountName["MultiProduct"] = "Multi-Product";
    SavvyDiscountName["MultiVehicle"] = "Multi-Vehicle";
    SavvyDiscountName["AutoPay"] = "AutoPay";
    SavvyDiscountName["NewCar"] = "New Car";
    SavvyDiscountName["Professional"] = "Professional";
    SavvyDiscountName["AutoSafetyEquipment"] = "Auto Safety Equipment";
    SavvyDiscountName["LowMileage"] = "Low Mileage";
    SavvyDiscountName["ElectricVehicle"] = "Electric Vehicle";
    SavvyDiscountName["AntiTheft"] = "Anti-Theft";
    SavvyDiscountName["AutomaticDisabling"] = "Automatic Disabling";
    SavvyDiscountName["OnStar"] = "OnStar";
    SavvyDiscountName["VehicleRecoveryDevice"] = "Vehicle Recovery Device";
    SavvyDiscountName["AudibleAlarm"] = "Audible Alarm";
    SavvyDiscountName["VINEtching"] = "VIN Etching";
    SavvyDiscountName["ManualDisabling"] = "Manual Disabling";
    SavvyDiscountName["Other"] = "Other";
})(SavvyDiscountName || (SavvyDiscountName = {}));
var jsonSchemaMinimumId$a = '/SavvyMinimumVehicleDiscount';
var jsonSchemaMinimum$a = {
    id: jsonSchemaMinimumId$a,
    type: 'object',
    properties: {
        name: {
            type: 'string',
        },
        discountCents: {
            type: 'number',
        },
    },
    required: ['name'],
};
var jsonSchemaDiscountNameId = '/SavvyVehicleDiscountNames';
var jsonSchemaDiscountName = {
    id: jsonSchemaDiscountNameId,
    type: 'object',
    properties: {
        name: {
            enum: [
                'Good Driver',
                'Customer Loyalty',
                'Homeowner',
                'Multi-Product',
                'Multi-Vehicle',
                'AutoPay',
                'New Car',
                'Professional',
                'Auto Safety Equipment',
                'Low Mileage',
                'Electric Vehicle',
                'Anti-Theft',
                'Automatic Disabling',
                'OnStar',
                'Vehicle Recovery Device',
                'Audible Alarm',
                'VIN Etching',
                'Manual Disabling',
                'Other',
            ],
        },
    },
    required: ['name'],
};
var validateMinimumDiscount = function (discount) {
    return validate$1(discount, jsonSchemaMinimum$a, { required: true });
};
var validateDiscountName = function (discount) {
    return validate$1(discount, jsonSchemaDiscountName, { required: true });
};

var jsonSchemaMinimumId$9 = '/SavvyMinimumName';
var jsonSchemaMinimum$9 = {
    id: jsonSchemaMinimumId$9,
    type: 'object',
    properties: {
        firstName: {
            type: 'string',
            minLength: 1,
        },
        middleName: {
            type: 'string',
        },
        lastName: {
            type: 'string',
            minLength: 1,
        },
    },
    required: ['firstName', 'lastName'],
};

var AtFault;
(function (AtFault) {
    AtFault["Yes"] = "yes";
    AtFault["No"] = "no";
    AtFault["Unknown"] = "unknown";
})(AtFault || (AtFault = {}));
var SavvyIncidentType;
(function (SavvyIncidentType) {
    SavvyIncidentType["Ticket"] = "TICKET";
    SavvyIncidentType["DUI"] = "DUI";
    SavvyIncidentType["Accident"] = "ACCIDENT";
    SavvyIncidentType["Claim"] = "CLAIM";
    SavvyIncidentType["Suspension"] = "SUSPENSION";
})(SavvyIncidentType || (SavvyIncidentType = {}));
var SavvyIncidentSubType;
(function (SavvyIncidentSubType) {
    SavvyIncidentSubType["ActOfNature"] = "Act of nature";
    SavvyIncidentSubType["Alcohol"] = "ALCOHOL";
    SavvyIncidentSubType["CarFire"] = "Car fire";
    SavvyIncidentSubType["CarelessDriving"] = "Careless driving";
    SavvyIncidentSubType["CarpoolLaneViolation"] = "Carpool lane violation";
    SavvyIncidentSubType["ChildNotInCarSeat"] = "Child not in car seat";
    SavvyIncidentSubType["CollidedWithAnotherVehicle"] = "Collided with another vehicle";
    SavvyIncidentSubType["DUIOrDWAI"] = "DUI/DWAI";
    SavvyIncidentSubType["DefectiveEquipment"] = "Defective equipment";
    SavvyIncidentSubType["DefectiveVehicle"] = "Defective vehicle (reduced violation)";
    SavvyIncidentSubType["DrivingTooFastForConditions"] = "Driving too fast for conditions";
    SavvyIncidentSubType["DrivingWithoutALicense"] = "Driving without a license";
    SavvyIncidentSubType["DrugPossession"] = "Drug possession";
    SavvyIncidentSubType["Drugs"] = "DRUGS";
    SavvyIncidentSubType["ExcessiveNoise"] = "Excessive noise";
    SavvyIncidentSubType["ExhibitionDriving"] = "Exhibition driving";
    SavvyIncidentSubType["ExpiredDriversLicense"] = "Expired drivers license";
    SavvyIncidentSubType["ExpiredEmissions"] = "Expired emissions";
    SavvyIncidentSubType["ExpiredRegistration"] = "Expired registration";
    SavvyIncidentSubType["FailureToObeyTrafficSignal"] = "Failure to obey traffic signal";
    SavvyIncidentSubType["FailureToSignal"] = "Failure to signal";
    SavvyIncidentSubType["FailureToStop"] = "Failure to stop";
    SavvyIncidentSubType["FailureToYield"] = "Failure to yield";
    SavvyIncidentSubType["FloodDamage"] = "Flood damage";
    SavvyIncidentSubType["FollowingTooClose"] = "Following too close";
    SavvyIncidentSubType["HailDamage"] = "Hail damage";
    SavvyIncidentSubType["HitAnimal"] = "Hit an animal";
    SavvyIncidentSubType["HitByAnotherPerson"] = "Hit by another person";
    SavvyIncidentSubType["HitObstruction"] = "Hit an obstruction";
    SavvyIncidentSubType["HitWhileStopped"] = "Hit while stopped";
    SavvyIncidentSubType["IllegalLaneChange"] = "Illegal lane change";
    SavvyIncidentSubType["IllegalPassing"] = "Illegal passing";
    SavvyIncidentSubType["IllegalTurn"] = "Illegal turn";
    SavvyIncidentSubType["IllegalTurnOnRed"] = "Illegal turn on red";
    SavvyIncidentSubType["IllegalUTurn"] = "Illegal u turn";
    SavvyIncidentSubType["InattentiveDriving"] = "Inattentive driving";
    SavvyIncidentSubType["LessThan10MPHOver"] = "Less than 10 mph over";
    SavvyIncidentSubType["MinorInPossession"] = "Minor in possession";
    SavvyIncidentSubType["MoreThan10MPHOver"] = "More than 10 mph over";
    SavvyIncidentSubType["MoreThan20MPHOver"] = "More than 20 mph over";
    SavvyIncidentSubType["NoInsurance"] = "No insurance";
    SavvyIncidentSubType["NoSeatbelt"] = "No seatbelt";
    SavvyIncidentSubType["OpenContainer"] = "Open container";
    SavvyIncidentSubType["OtherUnlistedMovingViolation"] = "Other unlisted moving violation";
    SavvyIncidentSubType["PassingInANoPassingZone"] = "Passing in a no-passing zone";
    SavvyIncidentSubType["PassingOnShoulder"] = "Passing on shoulder";
    SavvyIncidentSubType["PassingSchoolBus"] = "Passing a school bus";
    SavvyIncidentSubType["RanRedLight"] = "Ran a red light";
    SavvyIncidentSubType["RanStopSign"] = "Ran a stop sign";
    SavvyIncidentSubType["RearendedByAnotherPerson"] = "Rearended by another person";
    SavvyIncidentSubType["RecklessDriving"] = "Reckless driving";
    SavvyIncidentSubType["RecklessEndangerment"] = "Reckless endangerment";
    SavvyIncidentSubType["TheftOfStereo"] = "Theft of stereo";
    SavvyIncidentSubType["TheftOfVehicle"] = "Theft of vehicle";
    SavvyIncidentSubType["TowingService"] = "Towing service";
    SavvyIncidentSubType["Unknown"] = "UNKNOWN";
    SavvyIncidentSubType["Vandalism"] = "Vandalism";
    SavvyIncidentSubType["WindshieldReplacement"] = "Windshield replacement";
    SavvyIncidentSubType["WrongWayOnOneWay"] = "Wrong way on a one way";
})(SavvyIncidentSubType || (SavvyIncidentSubType = {}));
var jsonSchemaMinimumId$8 = '/SavvyMinimumIncident';
var jsonSchemaMinimum$8 = {
    id: jsonSchemaMinimumId$8,
    type: 'object',
    properties: {
        operator: {
            type: 'number',
        },
        operatorName: {
            $ref: jsonSchemaMinimumId$9,
        },
        type: {
            enum: ['TICKET', 'DUI', 'ACCIDENT', 'CLAIM', 'SUSPENSION'],
        },
        subType: {
            enum: [
                'Act of nature',
                'ALCOHOL',
                'Car fire',
                'Careless driving',
                'Carpool lane violation',
                'Child not in car seat',
                'Collided with another vehicle',
                'DUI/DWAI',
                'Defective equipment',
                'Defective vehicle (reduced violation)',
                'Driving too fast for conditions',
                'Driving without a license',
                'Drug possession',
                'DRUGS',
                'Excessive noise',
                'Exhibition driving',
                'Expired drivers license',
                'Expired emissions',
                'Expired registration',
                'Failure to obey traffic signal',
                'Failure to signal',
                'Failure to stop',
                'Failure to yield',
                'Flood damage',
                'Following too close',
                'Hail damage',
                'Hit an animal',
                'Hit by another person',
                'Hit an obstruction',
                'Hit while stopped',
                'Illegal lane change',
                'Illegal passing',
                'Illegal turn',
                'Illegal turn on red',
                'Illegal u turn',
                'Inattentive driving',
                'Less than 10 mph over',
                'Minor in possession',
                'More than 10 mph over',
                'More than 20 mph over',
                'No insurance',
                'No seatbelt',
                'Open container',
                'Other unlisted moving violation',
                'Passing in a no-passing zone',
                'Passing on shoulder',
                'Passing a school bus',
                'Ran a red light',
                'Ran a stop sign',
                'Rearended by another person',
                'Reckless driving',
                'Reckless endangerment',
                'Theft of stereo',
                'Theft of vehicle',
                'Towing service',
                'UNKNOWN',
                'Vandalism',
                'Windshield replacement',
                'Wrong way on a one way',
            ],
        },
        date: {
            type: 'string',
            format: 'date',
        },
        state: {
            type: 'string',
        },
        policyHolderAtFault: {
            enum: ['yes', 'no', 'unknown'],
        },
        paidAmountCents: {
            type: 'integer',
        },
        liabilityMedicalPaidAmountCents: {
            type: 'integer',
        },
    },
    required: ['type'],
};

var SavvyDriversLicenseStatus;
(function (SavvyDriversLicenseStatus) {
    SavvyDriversLicenseStatus["ValidUSLicense"] = "ValidUSLicense";
    SavvyDriversLicenseStatus["Permit"] = "Permit";
    SavvyDriversLicenseStatus["Suspended"] = "Suspended";
    SavvyDriversLicenseStatus["Restricted"] = "Restricted";
    SavvyDriversLicenseStatus["PermanentlyRevoked"] = "PermanentlyRevoked";
    SavvyDriversLicenseStatus["Expired"] = "Expired";
    SavvyDriversLicenseStatus["Surrendered"] = "Surrendered";
    SavvyDriversLicenseStatus["NonLicensed"] = "NonLicensed";
})(SavvyDriversLicenseStatus || (SavvyDriversLicenseStatus = {}));
var SavvyEducation;
(function (SavvyEducation) {
    SavvyEducation["Associates"] = "associates";
    SavvyEducation["Bachelors"] = "bachelors";
    SavvyEducation["Doctorate"] = "doctorate";
    SavvyEducation["NoHighSchoolDiploma"] = "no high school diploma";
    SavvyEducation["HighSchool"] = "high school";
    SavvyEducation["Masters"] = "masters";
    SavvyEducation["MedicalSchool"] = "medical school";
    SavvyEducation["LawSchool"] = "law school";
    SavvyEducation["Other"] = "other";
})(SavvyEducation || (SavvyEducation = {}));
var SavvyGender;
(function (SavvyGender) {
    SavvyGender["Female"] = "female";
    SavvyGender["Male"] = "male";
    SavvyGender["Nonbinary"] = "nonbinary";
})(SavvyGender || (SavvyGender = {}));
var SavvyMaritalStatus;
(function (SavvyMaritalStatus) {
    SavvyMaritalStatus["Married"] = "married";
    SavvyMaritalStatus["Single"] = "single";
    SavvyMaritalStatus["Other"] = "other";
})(SavvyMaritalStatus || (SavvyMaritalStatus = {}));
var SavvyRelationship;
(function (SavvyRelationship) {
    SavvyRelationship["PrimaryInsured"] = "primary insured";
    SavvyRelationship["AuPair"] = "au pair";
    SavvyRelationship["Aunt"] = "aunt";
    SavvyRelationship["Brother"] = "brother";
    SavvyRelationship["BrotherInLaw"] = "brother-in-law";
    SavvyRelationship["Cousin"] = "cousin";
    SavvyRelationship["Daughter"] = "daughter";
    SavvyRelationship["DaughterInLaw"] = "daughter-in-law";
    SavvyRelationship["RegisteredDomesticPartner"] = "registered domestic partner";
    SavvyRelationship["DomesticPartner"] = "domestic partner";
    SavvyRelationship["EstrangedSpouse"] = "estranged spouse";
    SavvyRelationship["EstDomesticPartner"] = "est-domestic partner";
    SavvyRelationship["EstRegisteredDomesticPartner"] = "est-registered domestic partner";
    SavvyRelationship["ExDomesticPartner"] = "ex-domestic partner";
    SavvyRelationship["ExRegisteredDomesticPartner"] = "ex-registered domestic partner";
    SavvyRelationship["ExSpouse"] = "ex-spouse";
    SavvyRelationship["Father"] = "father";
    SavvyRelationship["FatherInLaw"] = "father-in-law";
    SavvyRelationship["FianceFiancee"] = "fiance/fiancee";
    SavvyRelationship["Friend"] = "friend";
    SavvyRelationship["Granddaughter"] = "granddaughter";
    SavvyRelationship["Grandfather"] = "grandfather";
    SavvyRelationship["Grandmother"] = "grandmother";
    SavvyRelationship["Grandson"] = "grandson";
    SavvyRelationship["Mother"] = "mother";
    SavvyRelationship["MotherInLaw"] = "mother-in-law";
    SavvyRelationship["Nephew"] = "nephew";
    SavvyRelationship["Niece"] = "niece";
    SavvyRelationship["Other"] = "other";
    SavvyRelationship["Roommate"] = "roommate";
    SavvyRelationship["Sister"] = "sister";
    SavvyRelationship["SisterInLaw"] = "sister-in-law";
    SavvyRelationship["Son"] = "son";
    SavvyRelationship["SonInLaw"] = "son-in-law";
    SavvyRelationship["Spouse"] = "spouse";
    SavvyRelationship["Stepbrother"] = "stepbrother";
    SavvyRelationship["Stepdaughter"] = "stepdaughter";
    SavvyRelationship["Stepfather"] = "stepfather";
    SavvyRelationship["Stepmother"] = "stepmother";
    SavvyRelationship["Stepsister"] = "stepsister";
    SavvyRelationship["Stepson"] = "stepson";
    SavvyRelationship["Uncle"] = "uncle";
})(SavvyRelationship || (SavvyRelationship = {}));
var policySchemaPersonBase = {
    name: {
        $ref: jsonSchemaMinimumId$9,
    },
    dateOfBirth: {
        type: 'string',
        format: 'date',
    },
};
var schemaProperties$6 = __assign(__assign({}, policySchemaPersonBase), { isPolicyHolder: {
        type: 'boolean',
    }, gender: {
        enum: ['female', 'male', 'nonbinary'],
    }, age: {
        type: 'integer',
    }, ageLicensed: {
        type: 'integer',
    }, driversLicenseState: {
        type: 'string',
    }, driversLicenseStatus: {
        enum: [
            'ValidUSLicense',
            'Permit',
            'Suspended',
            'Restricted',
            'PermanentlyRevoked',
            'Expired',
            'Surrendered',
            'NonLicensed',
        ],
    }, driversLicenseNumber: {
        type: 'string',
    }, maritalStatus: {
        enum: ['married', 'single', 'other'],
    }, relationship: {
        enum: [
            'primary insured',
            'au pair',
            'aunt',
            'brother',
            'brother-in-law',
            'cousin',
            'daughter',
            'daughter-in-law',
            'registered domestic partner',
            'domestic partner',
            'estranged spouse',
            'est-domestic partner',
            'est-registered domestic partner',
            'ex-domestic partner',
            'ex-registered domestic partner',
            'ex-spouse',
            'father',
            'father-in-law',
            'fiance/fiancee',
            'friend',
            'granddaughter',
            'grandfather',
            'grandmother',
            'grandson',
            'mother',
            'mother-in-law',
            'nephew',
            'niece',
            'other',
            'roommate',
            'sister',
            'sister-in-law',
            'son',
            'son-in-law',
            'spouse',
            'stepbrother',
            'stepdaughter',
            'stepfather',
            'stepmother',
            'stepsister',
            'stepson',
            'uncle',
        ],
    }, monthsAtCurrentEmployer: {
        type: 'integer',
    }, education: {
        enum: [
            'associates',
            'bachelors',
            'doctorate',
            'no high school diploma',
            'high school',
            'masters',
            'medical school',
            'law school',
            'other',
        ],
    } });
var jsonSchemaMinimumId$7 = '/SavvyMinimumOperator';
var jsonSchemaQuoteMinimumId$7 = '/SavvyQuoteMinimumOperator';
var jsonSchemaMinimum$7 = {
    id: jsonSchemaMinimumId$7,
    type: 'object',
    properties: schemaProperties$6,
    required: ['isPolicyHolder'],
};
var jsonSchemaQuoteMinimum$7 = {
    id: jsonSchemaQuoteMinimumId$7,
    type: 'object',
    properties: schemaProperties$6,
    required: ['isPolicyHolder', 'name', 'gender'],
    anyOf: [
        {
            required: ['dateOfBirth'],
        },
        {
            required: ['age'],
        },
    ],
};

var schemaProperties$5 = {
    name: {
        $ref: jsonSchemaMinimumId$9,
    },
    phoneNumber: {
        type: 'string',
    },
    email: {
        type: 'string',
    },
};
var jsonSchemaMinimumId$6 = '/SavvyMinimumBasicPolicyHolder';
var jsonSchemaQuoteMinimumId$6 = '/SavvyQuoteMinimumBasicPolicyHolder';
var jsonSchemaMinimum$6 = {
    id: jsonSchemaMinimumId$6,
    type: 'object',
    properties: __assign(__assign({}, schemaProperties$5), { address: {
            $ref: jsonSchemaMinimumId$d,
        } }),
};
var jsonSchemaQuoteMinimum$6 = {
    id: jsonSchemaQuoteMinimumId$6,
    type: 'object',
    properties: __assign(__assign({}, schemaProperties$5), { address: {
            $ref: jsonSchemaQuoteMinimumId$9,
        } }),
    required: ['name', 'address', 'email', 'phoneNumber'],
};

var SavvyResidenceStatus;
(function (SavvyResidenceStatus) {
    SavvyResidenceStatus["OwnSingleFamily"] = "OwnSingleFamily";
    SavvyResidenceStatus["OwnCondo"] = "OwnCondo";
    SavvyResidenceStatus["OwnMobileHome"] = "OwnMobileHome";
    SavvyResidenceStatus["LiveWithParents"] = "LiveWithParents";
    SavvyResidenceStatus["Rent"] = "Rent";
    SavvyResidenceStatus["Other"] = "Other";
})(SavvyResidenceStatus || (SavvyResidenceStatus = {}));
var schemaProperties$4 = __assign(__assign({}, schemaProperties$5), { monthsInsured: {
        type: 'integer',
    }, isHomeOwner: {
        type: 'boolean',
    }, residenceStatus: {
        enum: ['OwnSingleFamily', 'OwnCondo', 'OwnMobileHome', 'LiveWithParents', 'Rent', 'Other'],
    }, monthsAtCurrentResidence: {
        type: 'integer',
    }, isMilitary: {
        type: 'boolean',
    } });
var jsonSchemaMinimumId$5 = '/SavvyMinimumPolicyHolder';
var jsonSchemaQuoteMinimumId$5 = '/SavvyQuoteMinimumPolicyHolder';
var jsonSchemaMinimum$5 = {
    id: jsonSchemaMinimumId$5,
    type: 'object',
    properties: __assign(__assign({}, schemaProperties$4), { address: {
            $ref: jsonSchemaMinimumId$c,
        } }),
};
var jsonSchemaQuoteMinimum$5 = {
    id: jsonSchemaQuoteMinimumId$5,
    type: 'object',
    properties: __assign(__assign({}, schemaProperties$4), { address: {
            $ref: jsonSchemaQuoteMinimumId$8,
        } }),
    required: ['name', 'address', 'email', 'phoneNumber'],
};

var SavvyOwnershipStatus;
(function (SavvyOwnershipStatus) {
    SavvyOwnershipStatus["Owned"] = "owned";
    SavvyOwnershipStatus["Financed"] = "financed";
    SavvyOwnershipStatus["Leased"] = "leased";
})(SavvyOwnershipStatus || (SavvyOwnershipStatus = {}));
var SavvyVehicleType;
(function (SavvyVehicleType) {
    SavvyVehicleType["Automobile"] = "automobile";
    SavvyVehicleType["Trailer"] = "trailer";
    SavvyVehicleType["Motorcycle"] = "motorcycle";
    SavvyVehicleType["Boat"] = "boat";
    SavvyVehicleType["Rv"] = "rv";
    SavvyVehicleType["Other"] = "other";
})(SavvyVehicleType || (SavvyVehicleType = {}));
var SavvyVehicleUse;
(function (SavvyVehicleUse) {
    SavvyVehicleUse["Pleasure"] = "pleasure";
    SavvyVehicleUse["Commute"] = "commute";
    SavvyVehicleUse["Business"] = "business";
    SavvyVehicleUse["Other"] = "other";
})(SavvyVehicleUse || (SavvyVehicleUse = {}));
var schemaProperties$3 = {
    primaryOperator: {
        type: 'integer',
    },
    year: {
        type: 'integer',
    },
    vin: {
        type: 'string',
        minLength: 10,
        maxLength: 17,
    },
    type: {
        enum: ['automobile', 'trailer', 'motorcycle', 'boat', 'rv', 'other'],
    },
    primaryUse: {
        enum: ['pleasure', 'commute', 'business', 'other'],
    },
    annualMileage: {
        type: 'integer',
    },
    ownershipStatus: {
        enum: ['owned', 'financed', 'leased'],
    },
    lienHolder: {
        type: 'string',
    },
    lienHolderAddress: {
        $ref: jsonSchemaMinimumId$c,
    },
    purchaseDate: {
        type: 'string',
        format: 'date',
    },
    purchasedNew: {
        type: 'boolean',
    },
    purchaseNewCostCents: {
        type: 'integer',
    },
    inStorage: {
        type: 'boolean',
    },
    garagingAddress: {
        $ref: jsonSchemaMinimumId$c,
    },
    hasAntiTheftDevices: {
        type: 'boolean',
    },
    isRideSharing: {
        type: 'boolean',
    },
    discounts: {
        type: 'array',
        items: {
            $ref: jsonSchemaMinimumId$a,
        },
    },
    coverages: {
        type: 'array',
        items: {
            $ref: jsonSchemaMinimumId$b,
        },
    },
};
var jsonSchemaMinimumId$4 = '/SavvyMinimumVehicle';
var jsonSchemaQuoteMinimumId$4 = '/SavvyQuoteMinimumVehicle';
var jsonSchemaMinimum$4 = {
    id: jsonSchemaMinimumId$4,
    type: 'object',
    properties: schemaProperties$3,
};
var jsonSchemaQuoteMinimum$4 = {
    id: jsonSchemaQuoteMinimumId$4,
    type: 'object',
    properties: schemaProperties$3,
    required: ['vin'],
};

var SAVVY_POLICY_TYPE;
(function (SAVVY_POLICY_TYPE) {
    SAVVY_POLICY_TYPE["AUTO_POLICY"] = "AUTO_POLICY";
    SAVVY_POLICY_TYPE["HOMEOWNERS_POLICY"] = "HOMEOWNERS_POLICY";
})(SAVVY_POLICY_TYPE || (SAVVY_POLICY_TYPE = {}));
var tinyPremiumCents = 2500;
var largeSixMonthPremiumCents = 599400;
var jsonSchemaMinimumId$3 = '/SavvyMinimumAutoPolicy';
var jsonSchemaQuoteMinimumId$3 = '/SavvyQuoteMinimumAutoPolicy';
var policySchemaPropertiesBase = {
    isActive: {
        type: 'boolean',
    },
    policyTermMonths: {
        type: 'integer',
    },
    numberOfPayments: {
        type: 'integer',
    },
    premiumCents: {
        type: 'integer',
    },
    issueDate: {
        type: 'string',
        format: 'date',
    },
    renewalDate: {
        type: 'string',
        format: 'date',
    },
    canceledDate: {
        type: 'string',
        format: 'date',
    },
};
var schemaProperties$2 = __assign(__assign({}, policySchemaPropertiesBase), { policyType: {
        enum: ['AUTO_POLICY'],
    }, currentIssuer: {
        enum: Object.values(AllIssuers),
    }, operators: {
        type: 'array',
        items: {
            $ref: jsonSchemaMinimumId$7,
        },
    }, vehicles: {
        type: 'array',
        items: {
            $ref: jsonSchemaMinimumId$4,
        },
    }, discounts: {
        type: 'array',
        items: {
            $ref: jsonSchemaMinimumId$a,
        },
    }, incidents: {
        type: 'array',
        items: {
            $ref: jsonSchemaMinimumId$8,
        },
    } });
var jsonSchemaMinimum$3 = {
    id: jsonSchemaMinimumId$3,
    type: 'object',
    properties: __assign(__assign({}, schemaProperties$2), { policyHolder: {
            $ref: jsonSchemaMinimumId$5,
        } }),
    required: ['policyType'],
};
var jsonSchemaQuoteMinimum$3 = {
    id: jsonSchemaQuoteMinimumId$3,
    type: 'object',
    properties: __assign(__assign({}, schemaProperties$2), { premiumCents: {
            type: 'integer',
            minimum: tinyPremiumCents,
        }, policyHolder: {
            $ref: jsonSchemaQuoteMinimumId$5,
        }, operators: {
            type: 'array',
            items: {
                $ref: jsonSchemaQuoteMinimumId$7,
            },
            minItems: 1,
        }, vehicles: {
            type: 'array',
            items: {
                $ref: jsonSchemaQuoteMinimumId$4,
            },
            minItems: 1,
        } }),
    required: ['policyType', 'policyHolder', 'operators', 'vehicles'],
};
Validator_1.prototype.customFormats.emptyString = function (input) {
    return input !== '';
};
var validateMinimumAutoPolicy = function (autoPolicy) {
    var validator = new Validator_1();
    validator.addSchema(jsonSchemaMinimum$c);
    validator.addSchema(jsonSchemaMinimum$b);
    validator.addSchema(jsonSchemaMinimum$a);
    validator.addSchema(jsonSchemaMinimum$8);
    validator.addSchema(jsonSchemaMinimum$9);
    validator.addSchema(jsonSchemaMinimum$7);
    validator.addSchema(jsonSchemaMinimum$5);
    validator.addSchema(jsonSchemaMinimum$4);
    return validator.validate(autoPolicy, jsonSchemaMinimum$3, { required: true });
};
var validateQuoteMinimumAutoPolicy = function (autoPolicy) {
    var validator = new Validator_1();
    validator.addSchema(jsonSchemaMinimum$c);
    validator.addSchema(jsonSchemaQuoteMinimum$8);
    validator.addSchema(jsonSchemaMinimum$b);
    validator.addSchema(jsonSchemaMinimum$a);
    validator.addSchema(jsonSchemaMinimum$8);
    validator.addSchema(jsonSchemaMinimum$9);
    validator.addSchema(jsonSchemaQuoteMinimum$7);
    validator.addSchema(jsonSchemaQuoteMinimum$5);
    validator.addSchema(jsonSchemaQuoteMinimum$4);
    return validator.validate(autoPolicy, jsonSchemaQuoteMinimum$3, { required: true });
};

var toSavvyDiscount = function (_a) {
    var name = _a.name, discountCents = _a.discountCents;
    return ({
        // Enums are the same, but we want to explicitly decouple them.
        name: name,
        discountCents: discountCents,
    });
};

var toSavvyIncident = function (_a) {
    var atFault = _a.atFault, date = _a.date, driver = _a.driver, paidAmountCents = _a.paidAmountCents, state = _a.state, type = _a.type, typeDetails = _a.typeDetails;
    return ({
        date: date,
        operator: driver,
        paidAmountCents: paidAmountCents,
        policyHolderAtFault: atFault,
        state: state,
        subType: typeDetails,
        type: type, // TO-DO fix this and refer to this follow up ticket https://trellisconnect.atlassian.net/browse/SAV-2161
    });
};

var toSavvyOperator = function (_a) {
    var ageLicensed = _a.ageLicensed, birthday = _a.birthday, driversLicenseState = _a.driversLicenseState, driversLicenseStatus = _a.driversLicenseStatus, driversLicenseNumber = _a.driversLicenseNumber, experienceYears = _a.experienceYears, gender = _a.gender, isPrimary = _a.isPrimary, maritalStatus = _a.maritalStatus, name = _a.name, education = _a.education, relationship = _a.relationship;
    return ({
        name: name,
        isPolicyHolder: !!isPrimary,
        gender: gender,
        dateOfBirth: birthday,
        ageLicensed: ageLicensed,
        driversLicenseState: driversLicenseState,
        driversLicenseStatus: driversLicenseStatus,
        driversLicenseNumber: driversLicenseNumber,
        maritalStatus: maritalStatus,
        relationship: relationship,
        monthsAtCurrentEmployer: isNil$1(experienceYears) ? undefined : experienceYears * 12,
        education: education,
    });
};

var toSavvyAddress = function (_a) {
    var number = _a.number, street = _a.street, type = _a.type, sec_unit_num = _a.sec_unit_num, sec_unit_type = _a.sec_unit_type, city = _a.city, state = _a.state, zip = _a.zip, plus4 = _a.plus4, prefix = _a.prefix;
    return ({
        city: city,
        number: number,
        plus4: plus4,
        secUnitNum: sec_unit_num,
        secUnitType: sec_unit_type,
        state: state,
        street: street,
        type: type,
        zip: zip,
        prefix: prefix,
    });
};

function nullToUndefined(val) {
    return val !== null && val !== void 0 ? val : undefined;
}
var toSavvyPolicyHolder = function (_a) {
    var name = _a.name, address = _a.address, email = _a.email, phoneNumber = _a.phoneNumber, tenureInYears = _a.tenureInYears, isHomeOwner = _a.isHomeOwner, residenceStatus = _a.residenceStatus, monthsAtCurrentResidence = _a.monthsAtCurrentResidence, isMilitary = _a.isMilitary, tenureWithLatestIssuerInMonths = _a.tenureWithLatestIssuerInMonths, longestLapseDurationInSixMonthsInDays = _a.longestLapseDurationInSixMonthsInDays, continuouslyInsuredDuration = _a.continuouslyInsuredDuration;
    return (__assign(__assign(__assign({ name: nullToUndefined(name), address: isNil$1(address) ? undefined : toSavvyAddress(address), email: nullToUndefined(email), isHomeOwner: nullToUndefined(isHomeOwner), isMilitary: nullToUndefined(isMilitary), residenceStatus: residenceStatus, phoneNumber: nullToUndefined(phoneNumber), monthsInsured: isNil$1(tenureInYears) ? undefined : (tenureInYears || 0) * 12, monthsAtCurrentResidence: monthsAtCurrentResidence }, (tenureWithLatestIssuerInMonths && { tenureWithLatestIssuerInMonths: tenureWithLatestIssuerInMonths })), (longestLapseDurationInSixMonthsInDays && { longestLapseDurationInSixMonthsInDays: longestLapseDurationInSixMonthsInDays })), (continuouslyInsuredDuration !== undefined && { continuouslyInsuredDuration: continuouslyInsuredDuration })));
};

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear$1;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq$2(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq$2;

var eq$1 = eq_1;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$4(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf$4;

var assocIndexOf$3 = _assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$1(key) {
  var data = this.__data__,
      index = assocIndexOf$3(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete$1;

var assocIndexOf$2 = _assocIndexOf;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$1(key) {
  var data = this.__data__,
      index = assocIndexOf$2(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet$1;

var assocIndexOf$1 = _assocIndexOf;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas$1;

var assocIndexOf = _assocIndexOf;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$1(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet$1;

var listCacheClear = _listCacheClear,
    listCacheDelete = _listCacheDelete,
    listCacheGet = _listCacheGet,
    listCacheHas = _listCacheHas,
    listCacheSet = _listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$4(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype['delete'] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;

var _ListCache = ListCache$4;

var ListCache$3 = _ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear$1() {
  this.__data__ = new ListCache$3;
  this.size = 0;
}

var _stackClear = stackClear$1;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function stackDelete$1(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete$1;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function stackGet$1(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet$1;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function stackHas$1(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas$1;

var getNative = _getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate$4 = getNative(Object, 'create');

var _nativeCreate = nativeCreate$4;

var nativeCreate$3 = _nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}

var _hashClear = hashClear$1;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete$1;

var nativeCreate$2 = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? undefined : result;
  }
  return hasOwnProperty$4.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet$1;

var nativeCreate$1 = _nativeCreate;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? (data[key] !== undefined) : hasOwnProperty$3.call(data, key);
}

var _hashHas = hashHas$1;

var nativeCreate = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet$1;

var hashClear = _hashClear,
    hashDelete = _hashDelete,
    hashGet = _hashGet,
    hashHas = _hashHas,
    hashSet = _hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$1(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$1.prototype.clear = hashClear;
Hash$1.prototype['delete'] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;

var _Hash = Hash$1;

var Hash = _Hash,
    ListCache$2 = _ListCache,
    Map$1 = _Map;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map$1 || ListCache$2),
    'string': new Hash
  };
}

var _mapCacheClear = mapCacheClear$1;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */

function isKeyable$1(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable$1;

var isKeyable = _isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData$4;

var getMapData$3 = _getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete$1;

var getMapData$2 = _getMapData;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}

var _mapCacheGet = mapCacheGet$1;

var getMapData$1 = _getMapData;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}

var _mapCacheHas = mapCacheHas$1;

var getMapData = _getMapData;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet$1;

var mapCacheClear = _mapCacheClear,
    mapCacheDelete = _mapCacheDelete,
    mapCacheGet = _mapCacheGet,
    mapCacheHas = _mapCacheHas,
    mapCacheSet = _mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$2(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$2.prototype.clear = mapCacheClear;
MapCache$2.prototype['delete'] = mapCacheDelete;
MapCache$2.prototype.get = mapCacheGet;
MapCache$2.prototype.has = mapCacheHas;
MapCache$2.prototype.set = mapCacheSet;

var _MapCache = MapCache$2;

var ListCache$1 = _ListCache,
    Map = _Map,
    MapCache$1 = _MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$1(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet$1;

var ListCache = _ListCache,
    stackClear = _stackClear,
    stackDelete = _stackDelete,
    stackGet = _stackGet,
    stackHas = _stackHas,
    stackSet = _stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack$1(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack$1.prototype.clear = stackClear;
Stack$1.prototype['delete'] = stackDelete;
Stack$1.prototype.get = stackGet;
Stack$1.prototype.has = stackHas;
Stack$1.prototype.set = stackSet;

var _Stack = Stack$1;

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

var _setCacheAdd = setCacheAdd$1;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */

function setCacheHas$1(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas$1;

var MapCache = _MapCache,
    setCacheAdd = _setCacheAdd,
    setCacheHas = _setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache$1(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache$1.prototype.add = SetCache$1.prototype.push = setCacheAdd;
SetCache$1.prototype.has = setCacheHas;

var _SetCache = SetCache$1;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */

function arraySome$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

var _arraySome = arraySome$1;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function cacheHas$1(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas$1;

var SetCache = _SetCache,
    arraySome = _arraySome,
    cacheHas = _cacheHas;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG$1) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays$2;

var root = _root;

/** Built-in value references. */
var Uint8Array$2 = root.Uint8Array;

var _Uint8Array = Uint8Array$2;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */

function mapToArray$1(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray$1;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */

function setToArray$1(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray$1;

var Symbol = _Symbol,
    Uint8Array$1 = _Uint8Array,
    eq = eq_1,
    equalArrays$1 = _equalArrays,
    mapToArray = _mapToArray,
    setToArray = _setToArray;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array$1(object), new Uint8Array$1(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag$1:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

var _equalByTag = equalByTag$1;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */

function arrayPush$1(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush$1;

var arrayPush = _arrayPush,
    isArray$2 = isArray_1;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys$1(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$2(object) ? result : arrayPush(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys$1;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

function arrayFilter$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter$1;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */

function stubArray$1() {
  return [];
}

var stubArray_1 = stubArray$1;

var arrayFilter = _arrayFilter,
    stubArray = stubArray_1;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols$1 = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

var _getSymbols = getSymbols$1;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */

function baseTimes$1(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes$1;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$1(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex$1;

var baseTimes = _baseTimes,
    isArguments = isArguments_1,
    isArray$1 = isArray_1,
    isBuffer$1 = isBufferExports,
    isIndex = _isIndex,
    isTypedArray$1 = isTypedArray_1;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys$1(value, inherited) {
  var isArr = isArray$1(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer$1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray$1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$2.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys$1;

var arrayLikeKeys = _arrayLikeKeys,
    baseKeys = _baseKeys,
    isArrayLike = isArrayLike_1;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$1(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

var keys_1 = keys$1;

var baseGetAllKeys = _baseGetAllKeys,
    getSymbols = _getSymbols,
    keys = keys_1;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys$1(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

var _getAllKeys = getAllKeys$1;

var getAllKeys = _getAllKeys;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$1.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects$1;

var Stack = _Stack,
    equalArrays = _equalArrays,
    equalByTag = _equalByTag,
    equalObjects = _equalObjects,
    getTag = _getTag,
    isArray = isArray_1,
    isBuffer = isBufferExports,
    isTypedArray = isTypedArray_1;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep$1;

var baseIsEqualDeep = _baseIsEqualDeep,
    isObjectLike$1 = isObjectLike_1;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual$1(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike$1(value) && !isObjectLike$1(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$1, stack);
}

var _baseIsEqual = baseIsEqual$1;

var baseIsEqual = _baseIsEqual;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

var isEqual_1 = isEqual;

var isEqual$1 = /*@__PURE__*/getDefaultExportFromCjs(isEqual_1);

var toSavvyCoverage = function (_a) {
    var deductibleCents = _a.deductibleCents, glassDeductibleCents = _a.glassDeductibleCents, isDeclined = _a.isDeclined, isImputed = _a.isImputed, name = _a.name, perAccidentLimitCents = _a.perAccidentLimitCents, perDayLimitCents = _a.perDayLimitCents, perWeekLimitCents = _a.perWeekLimitCents, perMonthLimitCents = _a.perMonthLimitCents, perPersonLimitCents = _a.perPersonLimitCents, premiumCents = _a.premiumCents;
    return (__assign(__assign({ deductibleCents: deductibleCents, glassDeductibleCents: glassDeductibleCents, isDeclined: isDeclined }, (isImputed && { isImputed: isImputed })), { 
        //these are the same enum, but we want to explicitly decouple them.
        name: name, perAccidentLimitCents: perAccidentLimitCents, perDayLimitCents: perDayLimitCents, perWeekLimitCents: perWeekLimitCents, perMonthLimitCents: perMonthLimitCents, perPersonLimitCents: perPersonLimitCents, premiumCents: premiumCents }));
};

var getOperatorName$1 = function (operators, operatorName) {
    if (isNil$1(operators) || isNil$1(operatorName)) {
        return undefined;
    }
    var index = operators.findIndex(function (operator) { return isEqual$1(operator.name, operatorName); });
    //if operator name is not found, index will be -1.
    return index < 0 ? undefined : index;
};
var toSavvyVehicle = function (_a, operators) {
    var annualMileage = _a.annualMileage, coverages = _a.coverages, discounts = _a.discounts, driver = _a.driver, garagingLocation = _a.garagingLocation, antiTheftDevices = _a.antiTheftDevices, inStorage = _a.inStorage, isRideSharing = _a.isRideSharing, lienHolder = _a.lienHolder, lienHolderAddress = _a.lienHolderAddress, ownershipStatus = _a.ownershipStatus, use = _a.use, purchaseDate = _a.purchaseDate, type = _a.type, vin = _a.vin, year = _a.year, make = _a.make, model = _a.model;
    return ({
        annualMileage: annualMileage,
        hasAntiTheftDevices: antiTheftDevices,
        coverages: isNil$1(coverages) ? [] : coverages.map(toSavvyCoverage),
        discounts: isNil$1(discounts) ? [] : discounts.map(toSavvyDiscount),
        primaryOperator: getOperatorName$1(operators, driver),
        garagingAddress: isNil$1(garagingLocation) ? undefined : toSavvyAddress(garagingLocation),
        inStorage: inStorage,
        isRideSharing: isRideSharing,
        lienHolder: lienHolder,
        lienHolderAddress: isNil$1(lienHolderAddress) ? undefined : toSavvyAddress(lienHolderAddress),
        // Enums are the same, but we want to explicitly decouple them.
        ownershipStatus: ownershipStatus,
        purchaseDate: purchaseDate,
        purchasedNew: undefined,
        purchaseNewCostCents: undefined,
        // Enums are the same, but we want to explicitly decouple them.
        type: type,
        // Enums are the same, but we want to explicitly decouple them.
        primaryUse: use,
        vin: vin,
        year: isNil$1(year) ? undefined : Number(year),
        make: make,
        model: model,
    });
};

var getDiscountTotalCents = function (discounts) {
    return discounts.reduce(function (totalDiscount, _a) {
        var discountCents = _a.discountCents;
        return totalDiscount + (isNil$1(discountCents) ? 0 : discountCents);
    }, 0);
};
var toTrellisDiscount = function (_a) {
    var name = _a.name, discountCents = _a.discountCents;
    return ({
        // Enums are the same, but we want to explicitly decouple them.
        name: name,
        discountCents: discountCents,
        rawName: name,
    });
};

var isIncidentType = function (incidentType) {
    return function (_a) {
        var type = _a.type;
        return type === incidentType;
    };
};
var isClaim = isIncidentType(SavvyIncidentType.Claim);
var isAccident = isIncidentType(SavvyIncidentType.Accident);
var isAtFault = function (_a) {
    var policyHolderAtFault = _a.policyHolderAtFault;
    return policyHolderAtFault === AtFault.Yes;
};
var hasAtFaultClaim = function (incidents) { return incidents.filter(isClaim).some(isAtFault); };
var hasAtFaultAccident = function (incidents) {
    return incidents.filter(isAccident).some(isAtFault);
};
var toTrellisIncident = function (_a) {
    var date = _a.date, operator = _a.operator, paidAmountCents = _a.paidAmountCents, policyHolderAtFault = _a.policyHolderAtFault, state = _a.state, subType = _a.subType, type = _a.type;
    return ({
        atFault: policyHolderAtFault,
        date: date,
        descriptionRaw: '',
        driver: operator,
        driverNameRaw: undefined,
        id: '',
        liabilityMedicalPaidAmountCents: undefined,
        paidAmountCents: paidAmountCents,
        state: state,
        type: type,
        typeDetails: subType,
    });
};

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */

function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  date.setDate(date.getDate() + amount);
  return date;
}

/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */

function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.

  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();

  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  return !isNaN(date);
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

/**
 * @name formatISO
 * @category Common Helpers
 * @summary Format the date according to the ISO 8601 standard (http://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
 *
 * @description
 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {'extended'|'basic'} [options.format='extended'] - if 'basic', hide delimiters between date and time values.
 * @param {'complete'|'date'|'time'} [options.representation='complete'] - format date, time with time zone, or both.
 * @returns {String} the formatted date string
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.format` must be 'extended' or 'basic'
 * @throws {RangeError} `options.represenation` must be 'date', 'time' or 'complete'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format (UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601, short format (UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918T190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, date only:
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, time only (UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52Z'
 */

function formatISO(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
  }

  var originalDate = toDate(dirtyDate);

  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  var options = dirtyOptions || {};
  var format = options.format == null ? 'extended' : String(options.format);
  var representation = options.representation == null ? 'complete' : String(options.representation);

  if (format !== 'extended' && format !== 'basic') {
    throw new RangeError("format must be 'extended' or 'basic'");
  }

  if (representation !== 'date' && representation !== 'time' && representation !== 'complete') {
    throw new RangeError("representation must be 'date', 'time', or 'complete'");
  }

  var result = '';
  var tzOffset = '';
  var dateDelimiter = format === 'extended' ? '-' : '';
  var timeDelimiter = format === 'extended' ? ':' : ''; // Representation is either 'date' or 'complete'

  if (representation !== 'time') {
    var day = addLeadingZeros(originalDate.getDate(), 2);
    var month = addLeadingZeros(originalDate.getMonth() + 1, 2);
    var year = addLeadingZeros(originalDate.getFullYear(), 4); // yyyyMMdd or yyyy-MM-dd.

    result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
  } // Representation is either 'time' or 'complete'


  if (representation !== 'date') {
    // Add the timezone.
    var offset = originalDate.getTimezoneOffset();

    if (offset !== 0) {
      var absoluteOffset = Math.abs(offset);
      var hourOffset = addLeadingZeros(Math.floor(absoluteOffset / 60), 2);
      var minuteOffset = addLeadingZeros(absoluteOffset % 60, 2); // If less than 0, the sign is +, because it is ahead of time.

      var sign = offset < 0 ? '+' : '-';
      tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
    } else {
      tzOffset = 'Z';
    }

    var hour = addLeadingZeros(originalDate.getHours(), 2);
    var minute = addLeadingZeros(originalDate.getMinutes(), 2);
    var second = addLeadingZeros(originalDate.getSeconds(), 2); // If there's also date, separate it with time with 'T'

    var separator = result === '' ? '' : 'T'; // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.

    var time = [hour, minute, second].join(timeDelimiter); // HHmmss or HH:mm:ss.

    result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
  }

  return result;
}

/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */

function subDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addDays(dirtyDate, -amount);
}

/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */

function subMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, -amount);
}

/**
 * @name sub
 * @category Common Helpers
 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @description
 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be subtracted
 *
 * | Key     | Description                        |
 * |---------|------------------------------------|
 * | years   | Amount of years to be subtracted   |
 * | months  | Amount of months to be subtracted  |
 * | weeks   | Amount of weeks to be subtracted   |
 * | days    | Amount of days to be subtracted    |
 * | hours   | Amount of hours to be subtracted   |
 * | minutes | Amount of minutes to be subtracted |
 * | seconds | Amount of seconds to be subtracted |
 *
 * All values default to 0
 *
 * @returns {Date} the new date with the seconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract the following duration from 15 June 2017 15:29:20
 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> Mon Sep 1 2014 10:19:50
 */

function sub(dirtyDate, duration) {
  requiredArgs(2, arguments);
  if (!duration || typeof duration !== 'object') return new Date(NaN);
  var years = duration.years ? toInteger(duration.years) : 0;
  var months = duration.months ? toInteger(duration.months) : 0;
  var weeks = duration.weeks ? toInteger(duration.weeks) : 0;
  var days = duration.days ? toInteger(duration.days) : 0;
  var hours = duration.hours ? toInteger(duration.hours) : 0;
  var minutes = duration.minutes ? toInteger(duration.minutes) : 0;
  var seconds = duration.seconds ? toInteger(duration.seconds) : 0; // Subtract years and months

  var dateWithoutMonths = subMonths(toDate(dirtyDate), months + years * 12); // Subtract weeks and days

  var dateWithoutDays = subDays(dateWithoutMonths, days + weeks * 7); // Subtract hours, minutes and seconds

  var minutestoSub = minutes + hours * 60;
  var secondstoSub = seconds + minutestoSub * 60;
  var mstoSub = secondstoSub * 1000;
  var finalDate = new Date(dateWithoutDays.getTime() - mstoSub);
  return finalDate;
}

var toTrellisOperator = function (_a) {
    var age = _a.age, name = _a.name, isPolicyHolder = _a.isPolicyHolder, gender = _a.gender, dateOfBirth = _a.dateOfBirth, ageLicensed = _a.ageLicensed, driversLicenseState = _a.driversLicenseState, driversLicenseStatus = _a.driversLicenseStatus, driversLicenseNumber = _a.driversLicenseNumber, maritalStatus = _a.maritalStatus, relationship = _a.relationship, monthsAtCurrentEmployer = _a.monthsAtCurrentEmployer, education = _a.education;
    return ({
        address: undefined,
        addressRaw: undefined,
        ageLicensed: ageLicensed,
        ageLicensedInternationally: undefined,
        birthday: isNil$1(dateOfBirth) ? undefined : dateOfBirth,
        birthdayRange: isNil$1(dateOfBirth)
            ? isNil$1(age)
                ? undefined
                : {
                    start: formatISO(sub(Date.now(), { years: age }), { representation: 'date' }),
                    end: formatISO(sub(Date.now(), { years: age - 1, days: 1 }), { representation: 'date' }),
                }
            : { start: dateOfBirth, end: dateOfBirth },
        driversLicenseNumber: driversLicenseNumber,
        driversLicenseState: driversLicenseState,
        driversLicenseStatus: driversLicenseStatus,
        // Enums are the same, but we want to explicitly decouple them.
        education: education,
        email: undefined,
        experienceYears: isNil$1(monthsAtCurrentEmployer) ? undefined : Math.ceil(monthsAtCurrentEmployer / 12),
        // Enums are the same, but we want to explicitly decouple them.
        gender: gender,
        isPrimary: isPolicyHolder,
        // Enums are the same, but we want to explicitly decouple them.
        maritalStatus: maritalStatus,
        name: name,
        occupation: undefined,
        rawEducation: education,
        relationship: relationship,
    });
};

var toBirthdayRange = function (input) {
    return { start: input, end: input };
};

var baseGetTag = _baseGetTag,
    isObjectLike = isObjectLike_1;

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

var isNumber_1 = isNumber;

var isNumber$1 = /*@__PURE__*/getDefaultExportFromCjs(isNumber_1);

var toTrellisAddress$1 = function (_a) {
    var number = _a.number, street = _a.street, type = _a.type, secUnitType = _a.secUnitType, secUnitNum = _a.secUnitNum, city = _a.city, state = _a.state, zip = _a.zip, plus4 = _a.plus4, prefix = _a.prefix;
    return ({
        city: city,
        number: isNil$1(number) ? undefined : String(number),
        plus4: isNil$1(plus4) ? undefined : String(plus4),
        sec_unit_num: isNumber$1(secUnitNum) ? String(secUnitNum) : secUnitNum,
        sec_unit_type: secUnitType,
        state: state,
        street: street,
        type: type,
        zip: String(zip),
        prefix: prefix,
    });
};

var toTrellisPolicyHolder$1 = function (_a) {
    var name = _a.name, address = _a.address, email = _a.email, phoneNumber = _a.phoneNumber, monthsInsured = _a.monthsInsured, isHomeOwner = _a.isHomeOwner, residenceStatus = _a.residenceStatus, monthsAtCurrentResidence = _a.monthsAtCurrentResidence, isMilitary = _a.isMilitary, dateOfBirth = _a.dateOfBirth, tenureWithLatestIssuerInMonths = _a.tenureWithLatestIssuerInMonths, longestLapseDurationInSixMonthsInDays = _a.longestLapseDurationInSixMonthsInDays, continuouslyInsuredDuration = _a.continuouslyInsuredDuration;
    return (__assign(__assign(__assign({ name: name, address: isNil$1(address) ? undefined : toTrellisAddress$1(address), addressRaw: undefined, email: email, isHomeOwner: isHomeOwner, isMilitary: isMilitary, residenceStatus: residenceStatus, phoneNumber: phoneNumber, tenureInYears: isNil$1(monthsInsured) ? undefined : Math.ceil((monthsInsured || 0) / 12), monthsAtCurrentResidence: monthsAtCurrentResidence, birthday: dateOfBirth !== null && dateOfBirth !== void 0 ? dateOfBirth : null, birthdayRange: dateOfBirth ? toBirthdayRange(dateOfBirth) : null }, (tenureWithLatestIssuerInMonths && { tenureWithLatestIssuerInMonths: tenureWithLatestIssuerInMonths })), (longestLapseDurationInSixMonthsInDays && { longestLapseDurationInSixMonthsInDays: longestLapseDurationInSixMonthsInDays })), (continuouslyInsuredDuration !== undefined && { continuouslyInsuredDuration: continuouslyInsuredDuration })));
};

var toTrellisCoverage = function (_a) {
    var deductibleCents = _a.deductibleCents, glassDeductibleCents = _a.glassDeductibleCents, isDeclined = _a.isDeclined, name = _a.name, perAccidentLimitCents = _a.perAccidentLimitCents, perDayLimitCents = _a.perDayLimitCents, perWeekLimitCents = _a.perWeekLimitCents, perMonthLimitCents = _a.perMonthLimitCents, perPersonLimitCents = _a.perPersonLimitCents, premiumCents = _a.premiumCents;
    return ({
        deductibleCents: deductibleCents,
        glassDeductibleCents: glassDeductibleCents,
        isDeclined: isDeclined,
        name: name,
        perAccidentLimitCents: perAccidentLimitCents,
        perDayLimitCents: perDayLimitCents,
        perWeekLimitCents: perWeekLimitCents,
        perMonthLimitCents: perMonthLimitCents,
        perPersonLimitCents: perPersonLimitCents,
        premiumCents: premiumCents,
    });
};

var getOperatorName = function (operators, operatorIndex) {
    var _a;
    return isNil$1(operators) || isNil$1(operatorIndex) || operators.length <= operatorIndex
        ? undefined
        : (_a = operators[operatorIndex]) === null || _a === void 0 ? void 0 : _a.name;
};
var toTrellisVehicle = function (_a, operators) {
    var annualMileage = _a.annualMileage, coverages = _a.coverages, discounts = _a.discounts, garagingAddress = _a.garagingAddress, hasAntiTheftDevices = _a.hasAntiTheftDevices, inStorage = _a.inStorage, isRideSharing = _a.isRideSharing, lienHolder = _a.lienHolder, lienHolderAddress = _a.lienHolderAddress, make = _a.make, model = _a.model, ownershipStatus = _a.ownershipStatus, primaryOperator = _a.primaryOperator, primaryUse = _a.primaryUse, purchaseDate = _a.purchaseDate, 
    // purchaseNewCostCents,
    // purchasedNew,
    type = _a.type, vin = _a.vin, year = _a.year;
    return ({
        annualMileage: annualMileage,
        antiTheftDevices: hasAntiTheftDevices,
        bodyStyle: undefined,
        coverages: isNil$1(coverages) ? [] : coverages.map(toTrellisCoverage),
        discountTotalCents: isNil$1(discounts)
            ? 0
            : discounts.reduce(function (sum, _a) {
                var discountCents = _a.discountCents;
                return sum + (discountCents !== null && discountCents !== void 0 ? discountCents : 0) || 0;
            }, 0),
        discounts: isNil$1(discounts) ? [] : discounts.map(toTrellisDiscount),
        driver: getOperatorName(operators, primaryOperator),
        garagingLocation: isNil$1(garagingAddress) ? undefined : toTrellisAddress$1(garagingAddress),
        garagingLocationRaw: undefined,
        inStorage: inStorage,
        isRideSharing: isRideSharing,
        lienHolder: lienHolder,
        lienHolderAddress: isNil$1(lienHolderAddress) ? undefined : toTrellisAddress$1(lienHolderAddress),
        lienHolderAddressRaw: undefined,
        // Enums are the same, but we want to explicitly decouple them.
        make: make,
        model: model,
        ownershipStatus: ownershipStatus,
        premiumCents: undefined,
        purchaseDate: purchaseDate,
        // Enums are the same, but we want to explicitly decouple them.
        type: type,
        // Enums are the same, but we want to explicitly decouple them.
        use: primaryUse,
        vin: vin,
        year: isNil$1(year) ? undefined : String(year),
    });
};

var TrellisPolicyTypes;
(function (TrellisPolicyTypes) {
    TrellisPolicyTypes["HOMEOWNERS"] = "HOMEOWNERS";
    TrellisPolicyTypes["PERSONAL_AUTO"] = "PERSONAL_AUTO";
    TrellisPolicyTypes["RENTERS"] = "RENTERS";
})(TrellisPolicyTypes || (TrellisPolicyTypes = {}));
var TrellisDiscountType;
(function (TrellisDiscountType) {
    TrellisDiscountType["antiTheft"] = "Anti-Theft";
    TrellisDiscountType["audibleAlarm"] = "Audible Alarm";
    TrellisDiscountType["autoPay"] = "AutoPay";
    TrellisDiscountType["autoSafetyEquipment"] = "Auto Safety Equipment";
    TrellisDiscountType["automaticDisabling"] = "Automatic Disabling";
    TrellisDiscountType["customerLoyalty"] = "Customer Loyalty";
    TrellisDiscountType["electricVehicle"] = "Electric Vehicle";
    TrellisDiscountType["goodDriver"] = "Good Driver";
    TrellisDiscountType["homeowner"] = "Homeowner";
    TrellisDiscountType["lowMileage"] = "Low Mileage";
    TrellisDiscountType["manualDisabling"] = "Manual Disabling";
    TrellisDiscountType["multiProduct"] = "Multi-Product";
    TrellisDiscountType["multiVehicle"] = "Multi-Vehicle";
    TrellisDiscountType["newCar"] = "New Car";
    TrellisDiscountType["onStar"] = "OnStar";
    TrellisDiscountType["other"] = "Other";
    TrellisDiscountType["professional"] = "Professional";
    TrellisDiscountType["vehicleRecoveryDevice"] = "Vehicle Recovery Device";
    TrellisDiscountType["vinEtching"] = "VIN Etching";
    TrellisDiscountType["paidInFull"] = "Paid in Full";
})(TrellisDiscountType || (TrellisDiscountType = {}));
var TrellisFinancialResponsibilityTypes;
(function (TrellisFinancialResponsibilityTypes) {
    TrellisFinancialResponsibilityTypes["SR21"] = "SR-21";
    TrellisFinancialResponsibilityTypes["SR22"] = "SR-22";
    TrellisFinancialResponsibilityTypes["SR22A"] = "SR-22A";
    TrellisFinancialResponsibilityTypes["FR44"] = "FR-44";
    TrellisFinancialResponsibilityTypes["SR50"] = "SR-50";
})(TrellisFinancialResponsibilityTypes || (TrellisFinancialResponsibilityTypes = {}));
var TrellisEducation;
(function (TrellisEducation) {
    TrellisEducation["associates"] = "associates";
    TrellisEducation["bachelors"] = "bachelors";
    TrellisEducation["doctorate"] = "doctorate";
    TrellisEducation["highSchool"] = "high school";
    TrellisEducation["lawSchool"] = "law school";
    TrellisEducation["masters"] = "masters";
    TrellisEducation["medicalSchool"] = "medical school";
    TrellisEducation["noHighSchool"] = "no high school diploma";
    TrellisEducation["other"] = "other";
})(TrellisEducation || (TrellisEducation = {}));
var TrellisGender;
(function (TrellisGender) {
    TrellisGender["female"] = "female";
    TrellisGender["male"] = "male";
    TrellisGender["nonbinary"] = "nonbinary";
})(TrellisGender || (TrellisGender = {}));
var TrellisMaritalStatus;
(function (TrellisMaritalStatus) {
    TrellisMaritalStatus["married"] = "married";
    TrellisMaritalStatus["other"] = "other";
    TrellisMaritalStatus["single"] = "single";
    TrellisMaritalStatus["divorced"] = "divorced";
    TrellisMaritalStatus["separated"] = "separated";
    TrellisMaritalStatus["civil_union"] = "civil union";
    TrellisMaritalStatus["domestic_partnership"] = "domestic partnership";
    TrellisMaritalStatus["widowed"] = "widowed";
})(TrellisMaritalStatus || (TrellisMaritalStatus = {}));
var TrellisVehicleType;
(function (TrellisVehicleType) {
    TrellisVehicleType["automobile"] = "automobile";
    TrellisVehicleType["boat"] = "boat";
    TrellisVehicleType["motorcycle"] = "motorcycle";
    TrellisVehicleType["other"] = "other";
    TrellisVehicleType["rv"] = "rv";
    TrellisVehicleType["trailer"] = "trailer";
    TrellisVehicleType["invalid"] = "invalid";
})(TrellisVehicleType || (TrellisVehicleType = {}));
var TrellisVehicleUse;
(function (TrellisVehicleUse) {
    TrellisVehicleUse["business"] = "business";
    TrellisVehicleUse["commute"] = "commute";
    TrellisVehicleUse["other"] = "other";
    TrellisVehicleUse["pleasure"] = "pleasure";
})(TrellisVehicleUse || (TrellisVehicleUse = {}));
var TrellisOwnershipStatus;
(function (TrellisOwnershipStatus) {
    TrellisOwnershipStatus["financed"] = "financed";
    TrellisOwnershipStatus["leased"] = "leased";
    TrellisOwnershipStatus["owned"] = "owned";
})(TrellisOwnershipStatus || (TrellisOwnershipStatus = {}));
var PersonalAutoIncidentTypes;
(function (PersonalAutoIncidentTypes) {
    PersonalAutoIncidentTypes["TICKET"] = "TICKET";
    PersonalAutoIncidentTypes["DUI"] = "DUI";
    PersonalAutoIncidentTypes["ACCIDENT"] = "ACCIDENT";
    PersonalAutoIncidentTypes["CLAIM"] = "CLAIM";
    PersonalAutoIncidentTypes["SUSPENSION"] = "SUSPENSION";
    PersonalAutoIncidentTypes["UNKNOWN"] = "UNKNOWN";
})(PersonalAutoIncidentTypes || (PersonalAutoIncidentTypes = {}));
var TicketTypeDetails;
(function (TicketTypeDetails) {
    TicketTypeDetails["TICKET_CARELESS_DRIVING"] = "Careless driving";
    TicketTypeDetails["TICKET_CARPOOL_LANE_VIOLATION"] = "Carpool lane violation";
    TicketTypeDetails["TICKET_CHILD_NOT_IN_CAR_SEAT"] = "Child not in car seat";
    TicketTypeDetails["TICKET_DEFECTIVE_EQUIPMENT"] = "Defective equipment";
    TicketTypeDetails["TICKET_DEFECTIVE_VEHICLE"] = "Defective vehicle (reduced violation)";
    TicketTypeDetails["TICKET_DRIVING_TOO_FAST"] = "Driving too fast for conditions";
    TicketTypeDetails["TICKET_DRIVING_WITHOUT_LICENSE"] = "Driving without a license";
    TicketTypeDetails["TICKET_DRUG_POSSESION"] = "Drug possession";
    TicketTypeDetails["TICKET_DUI_DWAI"] = "DUI/DWAI";
    TicketTypeDetails["TICKET_EXCESSIVE_NOISE"] = "Excessive noise";
    TicketTypeDetails["TICKET_EXHIBITION_DRIVING"] = "Exhibition driving";
    TicketTypeDetails["TICKET_EXPIRED_DRIVERS_LICENCE"] = "Expired drivers license";
    TicketTypeDetails["TICKET_EXPIRED_EMISSIONS"] = "Expired emissions";
    TicketTypeDetails["TICKET_EXPIRED_REGISTRATION"] = "Expired registration";
    TicketTypeDetails["TICKET_FAILURE_TO_OBEY_TRAFFIC_SIGNAL"] = "Failure to obey traffic signal";
    TicketTypeDetails["TICKET_FAILURE_TO_SIGNAL"] = "Failure to signal";
    TicketTypeDetails["TICKET_FAILURE_TO_STOP"] = "Failure to stop";
    TicketTypeDetails["TICKET_FAILURE_TO_YIELD"] = "Failure to yield";
    TicketTypeDetails["TICKET_FOLLOWING_TOO_CLOSE"] = "Following too close";
    TicketTypeDetails["TICKET_ILLEGAL_LANE_CHANGE"] = "Illegal lane change";
    TicketTypeDetails["TICKET_ILLEGAL_PASSING"] = "Illegal passing";
    TicketTypeDetails["TICKET_ILLEGAL_TURN_ON_RED"] = "Illegal turn on red";
    TicketTypeDetails["TICKET_ILLEGAL_TURN"] = "Illegal turn";
    TicketTypeDetails["TICKET_ILLEGAL_U_TURN"] = "Illegal u turn";
    TicketTypeDetails["TICKET_INATTENTIVE_DRIVING"] = "Inattentive driving";
    TicketTypeDetails["TICKET_LESS_THAN_10MPH_OVER"] = "Less than 10 mph over";
    TicketTypeDetails["TICKET_MINOR_IN_POSSESSION"] = "Minor in possession";
    TicketTypeDetails["TICKET_MORE_THAN_1OMPH_OVER"] = "More than 10 mph over";
    TicketTypeDetails["TICKET_MORE_THAN_2OMPH_OVER"] = "More than 20 mph over";
    TicketTypeDetails["TICKET_NO_INSURANCE"] = "No insurance";
    TicketTypeDetails["TICKET_NO_SEATBELT"] = "No seatbelt";
    TicketTypeDetails["TICKET_OPEN_CONTAINER"] = "Open container";
    TicketTypeDetails["TICKET_OTHER_UNLISTED_MOVING_VIOLATION"] = "Other unlisted moving violation";
    TicketTypeDetails["TICKET_PASSING_A_SCHOOL_BUS"] = "Passing a school bus";
    TicketTypeDetails["TICKET_PASSING_IN_A_NO_PASSING_ZONE"] = "Passing in a no-passing zone";
    TicketTypeDetails["TICKET_PASSING_ON_SHOULDER"] = "Passing on shoulder";
    TicketTypeDetails["TICKET_RAN_A_RED_LIGHT"] = "Ran a red light";
    TicketTypeDetails["TICKET_RAN_A_STOP_SIGN"] = "Ran a stop sign";
    TicketTypeDetails["TICKET_RECKLESS_DRIVING"] = "Reckless driving";
    TicketTypeDetails["TICKET_RECKLESS_ENDANGERMENT"] = "Reckless endangerment";
    TicketTypeDetails["TICKET_WRONG_WAY_ON_ONE_WAY"] = "Wrong way on a one way";
})(TicketTypeDetails || (TicketTypeDetails = {}));
var DUITypeDetails;
(function (DUITypeDetails) {
    DUITypeDetails["DUI_DRUGS"] = "DRUGS";
    DUITypeDetails["DUI_ALCOHOL"] = "ALCOHOL";
    DUITypeDetails["DUI_UNKNOWN"] = "UNKNOWN";
})(DUITypeDetails || (DUITypeDetails = {}));
var AccidentTypeDetails;
(function (AccidentTypeDetails) {
    AccidentTypeDetails["ACCIDENT_COLLIDED_WITH_ANOTHER_VEHICLE"] = "Collided with another vehicle";
    AccidentTypeDetails["ACCIDENT_HIT_WHILE_STOPPED"] = "Hit while stopped";
    AccidentTypeDetails["ACCIDENT_HIT_BY_ANOTHER_PERSON"] = "Hit by another person";
    AccidentTypeDetails["ACCIDENT_REARENDED_BY_ANOTHER_PERSON"] = "Rearended by another person";
    AccidentTypeDetails["ACCIDENT_HIT_AN_OBSTRUCTION"] = "Hit an obstruction";
    AccidentTypeDetails["ACCIDENT_OTHER"] = "Other";
})(AccidentTypeDetails || (AccidentTypeDetails = {}));
var ClaimTypeDetails;
(function (ClaimTypeDetails) {
    ClaimTypeDetails["CLAIM_ACT_OF_NATURE"] = "Act of nature";
    ClaimTypeDetails["CLAIM_CAR_FIRE"] = "Car fire";
    ClaimTypeDetails["CLAIM_FLOOD_DAMAGE"] = "Flood damage";
    ClaimTypeDetails["CLAIM_HAIL_DAMAGE"] = "Hail damage";
    ClaimTypeDetails["CLAIM_HIT_AN_ANIMAL"] = "Hit an animal";
    ClaimTypeDetails["CLAIM_THEFT_OF_STEREO"] = "Theft of stereo";
    ClaimTypeDetails["CLAIM_THEFT_OF_VEHICLE"] = "Theft of vehicle";
    ClaimTypeDetails["CLAIM_TOWING_SERVICE"] = "Towing service";
    ClaimTypeDetails["CLAIM_VANDALISM"] = "Vandalism";
    ClaimTypeDetails["CLAIM_WINDSHIELD_REPLACEMENT"] = "Windshield replacement";
    ClaimTypeDetails["CLAIM_OTHER"] = "Other";
})(ClaimTypeDetails || (ClaimTypeDetails = {}));

var SavvyHomeownersCoverageName;
(function (SavvyHomeownersCoverageName) {
    SavvyHomeownersCoverageName["Dwelling"] = "Dwelling";
    SavvyHomeownersCoverageName["OtherStructures"] = "Other Structures";
    SavvyHomeownersCoverageName["ExtendedReplacementCost"] = "Extended Replacement Cost";
    SavvyHomeownersCoverageName["ExtendedReplacementCostRoof"] = "Extended Replacement Cost - Roof";
    SavvyHomeownersCoverageName["PersonalProperty"] = "Personal Property";
    SavvyHomeownersCoverageName["AdditionalLivingExpense"] = "Additional Living Expense";
    SavvyHomeownersCoverageName["LegalLiability"] = "Legal Liability";
    SavvyHomeownersCoverageName["GuestMedicalLimit"] = "Guest Medical Limit";
    SavvyHomeownersCoverageName["WaterBackup"] = "Water Backup";
    SavvyHomeownersCoverageName["HailWindExclusion"] = "Hail/Wind Exclusion";
    SavvyHomeownersCoverageName["BuildingCode"] = "Building Code";
    SavvyHomeownersCoverageName["LossAssessment"] = "Loss Assessment";
    SavvyHomeownersCoverageName["ExtendedPremises"] = "Extended Premises";
    SavvyHomeownersCoverageName["FireDepartmentCharges"] = "Fire Department Charges";
    SavvyHomeownersCoverageName["BuildingMaterialsTheft"] = "Building Materials Theft";
    SavvyHomeownersCoverageName["CourseOfConstruction"] = "Course of Construction";
    SavvyHomeownersCoverageName["ElectronicDataRecovery"] = "Electronic Data Recovery";
    SavvyHomeownersCoverageName["FairRental"] = "Fair Rental";
    SavvyHomeownersCoverageName["HomeSharingHostProtection"] = "Home Sharing Host Protection";
    SavvyHomeownersCoverageName["PetBite"] = "Pet Bite";
    SavvyHomeownersCoverageName["CameraProperty"] = "Camera Property";
    SavvyHomeownersCoverageName["Jewelry"] = "Jewelry";
    SavvyHomeownersCoverageName["MusicalInstruments"] = "Musical Instruments";
    SavvyHomeownersCoverageName["MineSubsidenceCoverage"] = "Mine Subsidence Coverage";
    SavvyHomeownersCoverageName["MineSubsidenceAdditionalLivingExpenses"] = "Mine Subsidence Additional Living Expenses";
    SavvyHomeownersCoverageName["SportsEquipment"] = "Sports Equipment";
    SavvyHomeownersCoverageName["SilverwareTheft"] = "Silverware Theft";
    SavvyHomeownersCoverageName["YardAndGarden"] = "Yard and Garden";
})(SavvyHomeownersCoverageName || (SavvyHomeownersCoverageName = {}));
var SavvyHomeownersDeductibleName;
(function (SavvyHomeownersDeductibleName) {
    SavvyHomeownersDeductibleName["Hurricane"] = "Hurricane";
    SavvyHomeownersDeductibleName["WindAndHail"] = "Wind & Hail";
    SavvyHomeownersDeductibleName["AllOtherPerils"] = "All Other Perils";
    SavvyHomeownersDeductibleName["Earthquake"] = "Earthquake";
    SavvyHomeownersDeductibleName["WaterBackup"] = "Water Backup";
})(SavvyHomeownersDeductibleName || (SavvyHomeownersDeductibleName = {}));

var schemaProperties$1 = {
    dwelling: {
        enum: [
            'Single Family Home',
            'Duplex',
            'Triplex',
            'Quadruplex',
            'Condominium',
            'Apartment',
            'Multi Family 5+',
            'Unknown',
            'Townhouse / Rowhouse',
            'Mobile',
        ],
    },
    architecturalStyle: {
        type: 'string',
    },
    squareFeet: {
        type: 'integer',
    },
    usage: {
        type: 'string',
    },
    yearBuilt: {
        type: 'integer',
    },
    estimatedReplacementCost: {
        type: 'integer',
    },
    numberOfStories: {
        type: 'integer',
    },
    purchaseDate: {
        type: 'string',
    },
    wallType: {
        type: 'string',
    },
};
var jsonSchemaMinimumId$2 = '/SavvyMinimumProperty';
var jsonSchemaQuoteMinimumId$2 = '/SavvyQuoteMinimumProperty';
var jsonSchemaMinimum$2 = {
    id: jsonSchemaMinimumId$2,
    type: 'object',
    properties: __assign(__assign({}, schemaProperties$1), { address: {
            $ref: jsonSchemaMinimumId$d,
        } }),
};
var jsonSchemaQuoteMinimum$2 = {
    id: jsonSchemaQuoteMinimumId$2,
    type: 'object',
    properties: __assign(__assign({}, schemaProperties$1), { address: {
            $ref: jsonSchemaQuoteMinimumId$9,
        } }),
    required: ['dwelling', 'squareFeet', 'usage', 'yearBuilt', 'address'],
};

var jsonSchemaMinimumId$1 = '/SavvyMinimumHouseholdMember';
var jsonSchemaQuoteMinimumId$1 = '/SavvyQuoteMinimumHouseholdMember';
var jsonSchemaMinimum$1 = {
    id: jsonSchemaMinimumId$1,
    type: 'object',
    properties: policySchemaPersonBase,
};
var jsonSchemaQuoteMinimum$1 = {
    id: jsonSchemaQuoteMinimumId$1,
    type: 'object',
    properties: policySchemaPersonBase,
    required: ['name', 'dateOfBirth'],
};

var schemaProperties = __assign(__assign({}, policySchemaPropertiesBase), { policyType: {
        enum: ['HOMEOWNERS_POLICY'],
    }, currentIssuer: {
        enum: Object.values(AllIssuers),
    } });
var jsonSchemaMinimumId = '/SavvyMinimumHomeownersPolicy';
var jsonSchemaQuoteMinimumId = '/SavvyQuoteMinimumHomeownersPolicy';
var jsonSchemaMinimum = {
    id: jsonSchemaMinimumId,
    type: 'object',
    properties: __assign(__assign({}, schemaProperties), { policyHolder: {
            $ref: jsonSchemaMinimumId$6,
        }, householdMembers: {
            type: 'array',
            items: {
                $ref: jsonSchemaMinimumId$1,
            },
        }, property: {
            $ref: jsonSchemaMinimumId$2,
        } }),
    required: ['policyType'],
};
var jsonSchemaQuoteMinimum = {
    id: jsonSchemaQuoteMinimumId,
    type: 'object',
    properties: __assign(__assign({}, schemaProperties), { policyHolder: {
            $ref: jsonSchemaQuoteMinimumId$6,
        }, householdMembers: {
            type: 'array',
            items: {
                $ref: jsonSchemaQuoteMinimumId$1,
            },
            minItems: 1,
        }, property: {
            $ref: jsonSchemaQuoteMinimumId$2,
        } }),
    required: ['policyType', 'policyHolder', 'householdMembers', 'property'],
};
var validateMinimumHomeownersPolicy = function (homeownersPolicy) {
    var validator = new Validator_1();
    validator.addSchema(jsonSchemaMinimum$d);
    validator.addSchema(jsonSchemaMinimum$9);
    validator.addSchema(jsonSchemaMinimum$6);
    validator.addSchema(jsonSchemaMinimum$1);
    validator.addSchema(jsonSchemaMinimum$2);
    return validator.validate(homeownersPolicy, jsonSchemaMinimum, { required: true });
};
var validateQuoteMinimumHomeownersPolicy = function (homeownersPolicy) {
    var validator = new Validator_1();
    validator.addSchema(jsonSchemaQuoteMinimum$9);
    validator.addSchema(jsonSchemaMinimum$9);
    validator.addSchema(jsonSchemaQuoteMinimum$6);
    validator.addSchema(jsonSchemaQuoteMinimum$1);
    validator.addSchema(jsonSchemaQuoteMinimum$2);
    return validator.validate(homeownersPolicy, jsonSchemaQuoteMinimum, { required: true });
};

var lib = {};

var ad = {};

var result$1 = {};

var util = {};

Object.defineProperty(util, "__esModule", { value: true });
util.Util = void 0;
const AAA_ISSUERS = [
    {
        id: 'aaa_northern_new_england',
        name: 'Northern New England',
    },
    {
        id: 'aaa_northeast',
        name: 'Northeast',
    },
    {
        id: 'aaa_allied_group_greater_hartford_region',
        name: 'Allied Group Greater Hartford Region',
    },
    {
        id: 'aaa_pioneer_valley',
        name: 'Pioneer Valley',
    },
    {
        id: 'aaa_merrimack_valley',
        name: 'Merrimack Valley',
    },
    {
        id: 'aaa_hudson_valley',
        name: 'Hudson Valley',
    },
    {
        id: 'aaa_northway',
        name: 'Northway',
    },
    {
        id: 'aaa_western_and_central_new_york',
        name: 'Western and Central New York',
    },
    {
        id: 'aaa_south_jersey',
        name: 'South Jersey',
    },
    {
        id: 'aaa_east_central_east_penn_region',
        name: 'East Central East Penn Region',
    },
    {
        id: 'aaa_northampton_county',
        name: 'Northampton County',
    },
    {
        id: 'aaa_reading-berks',
        name: 'Reading-Berks',
    },
    {
        id: 'aaa_north_penn',
        name: 'North Penn',
    },
    {
        id: 'aaa_central_penn',
        name: 'Central Penn',
    },
    {
        id: 'aaa_southern_pennsylvania',
        name: 'Southern Pennsylvania',
    },
    {
        id: 'aaa_schuylkill_county',
        name: 'Schuylkill County',
    },
    {
        id: 'aaa_mid-atlantic',
        name: 'Mid-Atlantic',
    },
    {
        id: 'aaa_tidewater_virginia',
        name: 'Tidewater Virginia',
    },
    {
        id: 'aaa_carolinas',
        name: 'Carolinas',
    },
    {
        id: 'auto_club_group_florida',
        name: 'Florida',
    },
    {
        id: 'aaa_alabama',
        name: 'Alabama',
    },
    {
        id: 'auto_club_group_tennessee',
        name: 'Tennessee',
    },
    {
        id: 'aaa_allied_group_bluefield_region',
        name: 'Allied Group Bluefield Region',
    },
    {
        id: 'aaa_allied_group_bluegrass_region',
        name: 'Allied Group Bluegrass Region',
    },
    {
        id: 'aaa_east_central_kentucky_region',
        name: 'East Central Kentucky Region',
    },
    {
        id: 'aaa_allied_group_southern_west_virginia',
        name: 'Allied Group Southern West Virginia',
    },
    {
        id: 'aaa_east_central',
        name: 'East Central',
    },
    {
        id: 'akron_auto_club',
        name: 'Akron Auto Club',
    },
    {
        id: 'ohio_auto_club',
        name: 'Ohio Auto Club',
    },
    {
        id: 'aaa_allied_group_cincinnati_tristate_region',
        name: 'Allied Group Cincinnati TriState Region',
    },
    {
        id: 'aaa_allied_group_miami_valley_region',
        name: 'Allied Group Miami Valley Region',
    },
    {
        id: 'aaa_allied_group_miami_county_oh_region',
        name: 'Allied Group Miami County OH Region',
    },
    {
        id: 'findlay_automobile_club',
        name: 'Findlay Automobile Club',
    },
    {
        id: 'aaa_allied_group_northwest_ohio_region',
        name: 'Allied Group Northwest Ohio Region',
    },
    {
        id: 'aaa_shelby_county',
        name: 'Shelby County',
    },
    {
        id: 'auto_club_group_michigan',
        name: 'Michigan',
    },
    {
        id: 'hoosier_motor_club',
        name: 'Hoosier Motor Club',
    },
    {
        id: 'auto_club_group_chicago',
        name: 'Chicago',
    },
    {
        id: 'auto_club_group_wisconsin',
        name: 'Wisconsin',
    },
    {
        id: 'auto_club_group_minnesota',
        name: 'Minnesota',
    },
    {
        id: 'auto_club_group_minneapolis',
        name: 'Minneapolis',
    },
    {
        id: 'auto_club_group_nebraska',
        name: 'Nebraska',
    },
    {
        id: 'aaa_missouri',
        name: 'Missouri',
    },
    {
        id: 'aaa_allied_group_kansas_region',
        name: 'Allied Group Kansas Region',
    },
    {
        id: 'aaa_south_dakota',
        name: 'South Dakota',
    },
    {
        id: 'auto_club_group_north_dakota',
        name: 'Auto Club Group North Dakota',
    },
    {
        id: 'aaa_oklahoma',
        name: 'Oklahoma',
    },
    {
        id: 'aaa_texas',
        name: 'Texas',
    },
    {
        id: 'aaa_northern_california_nevada_utah',
        name: 'Northern California Nevada Utah',
    },
    {
        id: 'automobile_club_of_southern_california',
        name: 'Automobile Club of Southern California',
    },
    {
        id: 'aaa_arizona',
        name: 'Arizona',
    },
    {
        id: 'aaa_new_mexico',
        name: 'New Mexico',
    },
    {
        id: 'aaa_colorado',
        name: 'Colorado',
    },
    {
        id: 'aaa_mountainwest',
        name: 'MountainWest',
    },
    {
        id: 'aaa_oregon/idaho',
        name: 'Oregon/Idaho',
    },
    {
        id: 'aaa_washington',
        name: 'Washington',
    },
    {
        id: 'aaa_hawaii',
        name: 'Hawaii',
    },
];
const HARDCODED_ISSUERS = [
    {
        id: 'demo',
        name: 'Trellis Demo',
    },
    {
        id: 'statefarm',
        name: 'State Farm',
    },
    {
        id: 'geico',
        name: 'GEICO',
    },
    {
        id: 'allstate',
        name: 'Allstate',
    },
    {
        id: 'usaa',
        name: 'USAA',
    },
    {
        id: 'libertymutual',
        name: 'Liberty Mutual',
    },
    {
        id: 'mercury',
        name: 'Mercury',
    },
    {
        name: 'Progressive',
        id: 'progressive',
    },
    {
        name: 'ASI / Progressive',
        id: 'asiprogressive',
    },
    {
        id: 'metromile',
        name: 'Metromile',
    },
    {
        name: 'Esurance',
        id: 'esurance',
    },
    {
        name: 'Travelers',
        id: 'travelers',
    },
    {
        name: 'Sentry Insurance',
        id: 'sentry',
    },
    {
        name: 'Erie Insurance',
        id: 'erie',
    },
    {
        name: 'Kemper Insurance',
        id: 'kemper',
    },
    {
        name: 'Auto Owners Insurance',
        id: 'autoowners',
    },
    {
        name: 'The Hartford',
        id: 'thehartford',
    },
    {
        name: 'Root Insurance',
        id: 'root',
    },
    {
        name: 'Texas County Mutual',
        id: 'texascountymutual',
    },
    {
        name: 'Viking Insurance',
        id: 'viking',
    },
    {
        name: 'Farmers',
        id: 'farmers',
    },
    {
        name: 'Falls Lake',
        id: 'fallslake',
    },
    {
        name: 'Clearcover',
        id: 'clearcover',
    },
    {
        name: 'Infinity Insurance',
        id: 'infinity',
        matches: passedName => /^infinity\b/i.test(passedName),
    },
    {
        name: 'Founders Insurance',
        id: 'founders',
    },
    {
        name: 'Northbrook Insurance',
        id: 'northbrook',
    },
    {
        name: 'Mga Insurance',
        id: 'mgainsurance',
    },
    {
        name: 'Wawanesa General',
        id: 'wawanesa',
    },
    {
        name: 'Home State County Mutual',
        id: 'homestatecounty',
    },
    {
        name: 'Garrison Property & Casualty',
        id: 'garrison',
    },
    {
        name: 'Go',
        id: 'goinsurance',
    },
    {
        name: 'Knightbrook',
        id: 'knightbrook',
    },
    {
        name: 'Colonial County Mutual',
        id: 'colonialcounty',
    },
    {
        name: 'Metropolitan Insurance Group',
        id: 'metropolitangroup',
    },
    {
        name: 'Great Texas County Mutual',
        id: 'greattexascounty',
    },
    {
        name: 'Bristol West',
        id: 'bristolwestinsurance',
    },
    {
        name: 'Mid-Century Insurance ',
        id: 'midcenturyinsurance',
    },
    {
        name: 'West Bend Mutual',
        id: 'westbendinsurance',
    },
    {
        name: 'Elephant Insurance',
        id: 'elephant',
    },
    {
        name: '21St Century Insurance',
        id: '21stcentury',
    },
    {
        name: 'Wisconsin Mutual Insurance',
        id: 'wisconsinmutual',
    },
    {
        name: 'California Automobile',
        id: 'caautomobile',
    },
    {
        name: 'American Family',
        id: 'americanfamily',
    },
    {
        name: 'Integrity P&C',
        id: 'integritypc',
    },
    {
        name: 'Coast National Insurance',
        id: 'coastnational',
    },
    {
        name: 'Nationwide',
        id: 'nationwide',
    },
    {
        name: 'Nationwide Express',
        id: 'nationwideexpress',
    },
    {
        name: 'Nationally Known Brand Carrier',
        id: 'nkbc',
    },
    {
        name: 'Unitrin County Mutual',
        id: 'unitrin',
    },
    {
        name: 'Safeco Insurance',
        id: 'safeco',
    },
    {
        name: 'Alpha Property & Casualty',
        id: 'alphaproperty',
    },
    {
        name: 'Meemic Insurance',
        id: 'meemic',
    },
    {
        name: 'Dairyland',
        id: 'dairyland',
    },
    {
        name: 'Old American County Mutual',
        id: 'oldamericancounty',
    },
    {
        name: 'Redpoint County Mutual',
        id: 'redpoint',
    },
    {
        name: 'National General',
        id: 'national',
    },
    {
        name: 'Integon',
        id: 'integon',
    },
    {
        name: 'Foremost County Mutu',
        id: 'foremost',
    },
    {
        name: 'The General',
        id: 'thegeneral',
    },
    {
        name: 'Alliance United',
        id: 'alliance',
    },
    {
        name: 'Afb',
        id: 'afb',
    },
    {
        name: 'Amco Insurance Co',
        id: 'amco',
    },
    {
        name: 'Cem Insurance Co',
        id: 'cem',
    },
    {
        name: 'MetLife',
        id: 'metlife',
    },
    {
        name: 'Hastings Mutual Insurance',
        id: 'hastings',
    },
    {
        name: 'Hanover',
        id: 'hanover',
    },
    {
        name: 'Wadena Insurance',
        id: 'wadena',
    },
    {
        name: 'Fred Loya Insurance',
        id: 'fredloya',
    },
    {
        name: 'Shelter Insurance',
        id: 'shelter',
    },
    {
        name: 'AAA Insurance',
        id: 'aaa',
        subIssuers: AAA_ISSUERS,
    },
    {
        name: "Workmen's Auto Insurance",
        id: 'workmen',
    },
    {
        name: 'Gainsco Auto Insurance',
        id: 'gainsco',
    },
    {
        name: 'Acceptance Insurance',
        id: 'acceptance',
    },
    {
        name: 'Direct Auto Insurance',
        id: 'directauto',
    },
    {
        name: 'State Auto Insurance',
        id: 'stateauto',
    },
    {
        name: 'StillWater',
        id: 'stillwater',
    },
    {
        name: 'Safe Auto Insurance',
        id: 'safeauto',
    },
    {
        name: 'Plymouth Rock Assurance',
        id: 'plymouthrock',
    },
    {
        name: 'Sun Coast',
        id: 'suncoast',
    },
    {
        name: 'Acuity Insurance',
        id: 'acuity',
    },
    {
        name: 'Connect',
        id: 'connect',
    },
    {
        name: 'GoAuto Insurance',
        id: 'goauto',
    },
    {
        name: 'Good2Go Insurance',
        id: 'good2go',
    },
    {
        name: 'Horace Mann',
        id: 'horacemann',
    },
    {
        name: 'MAPFRE Insurance Company',
        id: 'mapfre',
    },
    {
        name: 'Ohio Mutual Insurance Group',
        id: 'ohiomutual',
    },
    {
        name: 'Pronto Insurance',
        id: 'pronto',
    },
    {
        name: 'United Security Health and Casualty Insurance',
        id: 'unitedsecurity',
    },
    {
        name: 'Verti Insurance',
        id: 'verti',
    },
    {
        name: 'Aspire General Insurance',
        id: 'aspire',
        matches: name => /^aspire/i.test(name),
    },
    {
        name: 'Encompass Insurance',
        id: 'encompass',
    },
    {
        name: 'First Chicago Insurance Company',
        id: 'firstchicago',
    },
    {
        name: 'Jupiter Auto Insurance',
        id: 'jupiter',
    },
    {
        name: `Workmen's Auto Insurance Company`,
        id: 'workmens',
    },
    {
        name: 'Amica Mutual Insurance',
        id: 'amica',
    },
    {
        name: 'Grange Insurance',
        id: 'grange',
    },
    {
        name: 'NJM (New Jersey Manufacturers)',
        id: 'njm',
    },
    {
        name: 'Apparent',
        id: 'apparent',
    },
    {
        name: 'TSC>Direct',
        id: 'tscd',
    },
    {
        name: 'Motion Auto',
        id: 'motion',
    },
    {
        name: 'Farm Bureau',
        id: 'farmbureau',
    },
    {
        name: 'Alfa Insurance',
        id: 'alfa',
    },
    {
        name: 'Dasher Insurance',
        id: 'dasher',
        matches: name => /^dasher/i.test(name),
    },
    {
        name: 'Anchor General Insurance',
        id: 'anchor',
        matches: name => /^anchor/i.test(name),
    },
    {
        name: 'NYCM Insurance',
        id: 'nycm',
    },
    {
        name: 'Chubb Insurance',
        id: 'chubb',
        matches: name => /chubb/i.test(name),
    },
    {
        name: 'Haven Life',
        id: 'havenlife',
        matches: name => /^havenlife/i.test(name.replace(/\s/g, '')),
    },
    {
        name: 'Harmonic',
        id: 'harmonic',
    },
    {
        name: 'Velocity Risk',
        id: 'velocityrisk',
    },
    {
        name: 'Mile Auto',
        id: 'mileauto',
    },
    {
        name: 'Arrowhead Falls Lake',
        id: 'arrowhead',
    },
    {
        name: 'Personal Service Insurance',
        id: 'personal',
    },
];
class Util {
    static getIssuerByName(issuerName) {
        const issuerNameMatch = new RegExp(issuerName, 'gi');
        const issuerNameNoSpacePattern = new RegExp(issuerName.replace(/\s/g, ''), 'gi');
        const issuer = HARDCODED_ISSUERS.find(({ name }) => issuerNameMatch.test(name + ' Insurance')) ||
            HARDCODED_ISSUERS.find(({ name }) => issuerNameMatch.test(name.replace(/\s/g, '') + ' Insurance')) ||
            HARDCODED_ISSUERS.find(({ name }) => issuerNameNoSpacePattern.test(name + 'Insurance')) ||
            HARDCODED_ISSUERS.find(({ matches }) => !!matches && matches(issuerName)) ||
            HARDCODED_ISSUERS.find(({ subIssuers = [{ id: '' }] }) => subIssuers.findIndex(({ id }) => issuerNameMatch.test(id)) !== -1) || { id: '', name: '' };
        return issuer;
    }
}
util.Util = Util;

Object.defineProperty(result$1, "__esModule", { value: true });
result$1.ResultBase = void 0;
const util_1 = util;
class ResultBase {
    // accessors
    getId() {
        return this._id;
    }
    getClickUrl() {
        return this._clickUrl;
    }
    getIssuerId() {
        return this._issuerId;
    }
    getIssuerName() {
        return this._issuerName;
    }
    getProviderName() {
        return this._providerName;
    }
    getProviderRank() {
        return this._providerRank;
    }
    getSavvyData() {
        return {
            id: this._id,
            clickUrl: this._clickUrl,
            issuerName: this._issuerName,
            issuerId: this._issuerId,
            providerName: this._providerName,
            providerRank: this._providerRank,
            type: this.getResultType(),
        };
    }
    getSanitizedData() {
        return {
            id: this._id,
            clickUrl: this._clickUrl,
        };
    }
    getResultType() {
        return this._resultType;
    }
    // mutators
    setIssuerNameAndId(name) {
        this._issuerName = name;
        this._issuerId = util_1.Util.getIssuerByName(name).id; // empty when unmatched
    }
    setProviderRank(rank) {
        this._providerRank = rank;
    }
    setClickUrl(url) {
        this._clickUrl = url;
    }
    isFromIssuer(targetIssuerId) {
        return this.getIssuerId() === targetIssuerId;
    }
}
result$1.ResultBase = ResultBase;

Object.defineProperty(ad, "__esModule", { value: true });
ad.AdBase = void 0;
const result_1$3 = result$1;
class AdBase extends result_1$3.ResultBase {
    getClickRedirectData() {
        return { redirectUrl: this._redirectUrl };
    }
    getDisplayName() {
        return this._displayName;
    }
    getRPC() {
        return this._rpc;
    }
    getProviderImpressionUrl() {
        return this._providerImpressionUrl;
    }
    getResultType() {
        return this._resultType;
    }
    getSanitizedData() {
        return {
            id: this.getId(),
            clickUrl: this.getClickUrl(),
            logo: this._logo,
            advertiserName: this._displayName,
            title: this._title,
            clickText: this._clickText,
        };
    }
    getSavvyData() {
        return {
            id: this.getId(),
            clickUrl: this.getClickUrl(),
            issuerName: this.getIssuerName(),
            issuerId: this.getIssuerId(),
            providerName: this.getProviderName(),
            providerRank: this.getProviderRank(),
            type: this.getResultType(),
            adsRank: this._adsRank,
            clickText: this._clickText,
            displayName: this.getDisplayName(),
            logo: this._logo,
            pixel: this._pixel,
            rawLogo: this._rawLogo,
            rpc: this.getRPC(),
            redirectUrl: this._redirectUrl,
            siteHost: this._siteHost,
            title: this._title,
            providerImpressionUrl: this._providerImpressionUrl,
        };
    }
    getSiteHost() {
        return this._siteHost;
    }
    setSavvyData({ adsRank, clickText, clickUrl, displayName, issuerName, logo, pixel, providerRank, rawLogo, redirectUrl, rpc, siteHost, title, providerImpressionUrl, }) {
        this.setAdsRank(adsRank);
        this.setClickText(clickText);
        this.setClickUrl(clickUrl);
        this.setDisplayName(displayName);
        this.setIssuerNameAndId(issuerName);
        this.setLogo(logo);
        this.setPixel(pixel);
        this.setProviderRank(providerRank);
        this.setRawLogo(rawLogo);
        this.setRedirectUrl(redirectUrl);
        this.setRpc(rpc);
        this.setSiteHost(siteHost);
        this.setTitle(title);
        this.setProviderImpressionUrl(providerImpressionUrl);
    }
    setAdsRank(rank) {
        this._adsRank = rank;
    }
    setClickText(text) {
        this._clickText = text;
    }
    setDisplayName(name) {
        this._displayName = name;
    }
    setLogo(logo) {
        this._logo = logo;
    }
    setPixel(pixel) {
        this._pixel = pixel;
    }
    setRawLogo(rawLogo) {
        this._rawLogo = rawLogo;
    }
    setRedirectUrl(url) {
        this._redirectUrl = url;
    }
    setRpc(cents) {
        this._rpc = cents;
    }
    setSiteHost(siteHost) {
        this._siteHost = siteHost;
    }
    setTitle(title) {
        this._title = title;
    }
    setProviderImpressionUrl(url) {
        this._providerImpressionUrl = url;
    }
}
ad.AdBase = AdBase;

var autoLoanRefiQuote = {};

Object.defineProperty(autoLoanRefiQuote, "__esModule", { value: true });
autoLoanRefiQuote.AutoLoanRefiQuoteBase = void 0;
const result_1$2 = result$1;
class AutoLoanRefiQuoteBase extends result_1$2.ResultBase {
    // accessors
    getAmount() {
        return this._amount;
    }
    getInterestRate() {
        return this._interestRate;
    }
    getTerm() {
        return this._term;
    }
    getMonthlyPayment() {
        return this._monthlyPayment;
    }
    getAprDecimal() {
        return this._aprDecimal;
    }
    getRedirectUrl() {
        return this._redirectUrl;
    }
    getClickRedirectData() {
        return { redirectUrl: this._redirectUrl };
    }
    getClickText() {
        return this._clickText;
    }
    getResultType() {
        return this._resultType;
    }
    getSavvyData() {
        return {
            id: this.getId(),
            clickUrl: this.getClickUrl(),
            issuerName: this.getIssuerName(),
            issuerId: this._issuerId,
            providerName: this._providerName,
            providerRank: this._providerRank,
            type: this.getResultType(),
            amount: this.getAmount(),
            interestRate: this.getInterestRate(),
            term: this.getTerm(),
            monthlyPayment: this.getMonthlyPayment(),
            apr: this.getAprDecimal(),
            redirectUrl: this.getRedirectUrl(),
        };
    }
    getSanitizedData() {
        return {
            id: this.getId(),
            clickUrl: this.getClickUrl(),
            amount: this.getAmount(),
            interestRate: this.getInterestRate(),
            term: this.getTerm(),
            monthlyPayment: this.getMonthlyPayment(),
            apr: this.getAprDecimal(),
            redirectUrl: this.getRedirectUrl(),
        };
    }
    // mutators
    setAmount(amount) {
        this._amount = amount;
    }
    setInterestRate(interestRate) {
        this._interestRate = interestRate;
    }
    setTerm(term) {
        this._term = term;
    }
    setMonthlyPayment(monthlyPayment) {
        this._monthlyPayment = monthlyPayment;
    }
    setAprDecimal(apr) {
        this._aprDecimal = apr;
    }
    setRedirectUrl(redirectUrl) {
        this._redirectUrl = redirectUrl;
    }
    setClickText(clickText) {
        this._clickText = clickText;
    }
    setSavvyData({ amount, interestRate, term, monthlyPayment, apr, redirectUrl, clickUrl, issuerName, providerRank, }) {
        this.setClickUrl(clickUrl);
        this.setIssuerNameAndId(issuerName);
        this.setProviderRank(providerRank);
        this.setAmount(amount);
        this.setInterestRate(interestRate);
        this.setTerm(term);
        this.setMonthlyPayment(monthlyPayment);
        this.setAprDecimal(apr);
        this.setRedirectUrl(redirectUrl);
    }
}
autoLoanRefiQuote.AutoLoanRefiQuoteBase = AutoLoanRefiQuoteBase;

var lifeQuote$1 = {};

Object.defineProperty(lifeQuote$1, "__esModule", { value: true });
lifeQuote$1.LifeQuoteBase = void 0;
const result_1$1 = result$1;
class LifeQuoteBase extends result_1$1.ResultBase {
    // accessors
    getBindUrl() {
        return this._bindUrl;
    }
    getClickRedirectData() {
        return {
            redirectUrl: this._bindUrl,
            suppressRedirect: true,
        };
    }
    getClickText() {
        return this._clickText;
    }
    getDisclosures() {
        return this._disclosures;
    }
    getProductIdentifier() {
        return this._productIdentifier;
    }
    getTermLength() {
        return this._termLengthYears;
    }
    getSavvyData() {
        return {
            id: this.getId(),
            clickUrl: this.getClickUrl(),
            issuerName: this.getIssuerName(),
            issuerId: this._issuerId,
            providerName: this._providerName,
            providerRank: this._providerRank,
            type: this.getResultType(),
            bindUrl: this.getBindUrl(),
            clickText: this.getClickText(),
            clickForm: this.getClickForm(),
            insuredPerson: this.getInsuredPerson(),
            quoteOptions: this.getQuoteOptions(),
            defaultDisplay: this.getDefaultDisplay(),
            productIdentifier: this.getProductIdentifier(),
            termLengthYears: this.getTermLength(),
            assumptions: this.getAssumptions(),
            disclosures: this.getDisclosures(),
        };
    }
    getSanitizedData() {
        return {
            id: this.getId(),
            clickUrl: this.getClickUrl(),
            clickText: this.getClickText(),
            clickForm: this.getClickForm(),
            insuredPerson: this.getInsuredPerson(),
            quoteOptions: this.getQuoteOptions(),
            defaultDisplay: this.getDefaultDisplay(),
            productIdentifier: this.getProductIdentifier(),
            termLengthYears: this.getTermLength(),
            assumptions: this.getAssumptions(),
            disclosures: this.getDisclosures(),
            issuerId: this.getIssuerId(),
            issuerName: this.getIssuerName(),
        };
    }
    getResultType() {
        return this._resultType;
    }
    getClickForm() {
        return this._clickForm;
    }
    getInsuredPerson() {
        return this._insuredPerson;
    }
    getQuoteOptions() {
        return this._quoteOptions;
    }
    getDefaultDisplay() {
        return this._defaultDisplay;
    }
    getAssumptions() {
        return this._assumptions;
    }
    // mutators
    setBindUrl(url) {
        this._bindUrl = url;
    }
    setClickText(text) {
        this._clickText = text;
    }
    setDisclosures(disclosures) {
        this._disclosures = disclosures;
    }
    setProductIdentifier(productId) {
        this._productIdentifier = productId;
    }
    setTermLength(years) {
        this._termLengthYears = years;
    }
    setClickForm(form) {
        this._clickForm = form;
    }
    setInsuredPerson(person) {
        this._insuredPerson = person;
    }
    setQuoteOptions(options) {
        this._quoteOptions = options;
    }
    setDefaultDisplay(defaultDisplay) {
        this._defaultDisplay = defaultDisplay;
    }
    setAssumptions(assumptions) {
        this._assumptions = assumptions;
    }
    setSavvyData({ clickUrl, issuerName, bindUrl, clickText, clickForm, insuredPerson, quoteOptions, defaultDisplay, productIdentifier, termLengthYears, assumptions, disclosures, }) {
        this.setClickUrl(clickUrl);
        this.setIssuerNameAndId(issuerName);
        this.setBindUrl(bindUrl);
        this.setClickText(clickText);
        this.setClickForm(clickForm);
        this.setInsuredPerson(insuredPerson);
        this.setQuoteOptions(quoteOptions);
        this.setDefaultDisplay(defaultDisplay);
        this.setProductIdentifier(productIdentifier);
        this.setTermLength(termLengthYears);
        this.setAssumptions(assumptions);
        this.setDisclosures(disclosures);
    }
}
lifeQuote$1.LifeQuoteBase = LifeQuoteBase;

var quote = {};

Object.defineProperty(quote, "__esModule", { value: true });
quote.QuoteBase = void 0;
const result_1 = result$1;
class QuoteBase extends result_1.ResultBase {
    constructor() {
        super(...arguments);
        this._clickUrl = '';
        this._providerRank = 1;
        this._averageMonthlyCostCents = 0;
        this._averageMonthlySavingsCents = 0;
        this._downPaymentCents = 0;
        this._installmentCents = 0;
        this._numberOfPayments = 0;
        this._quoteRank = 1;
        this._termLengthMonths = 0;
        this._totalPremiumCents = 0;
        this._totalSavingsCents = 0;
    }
    // accessor
    getAverageMonthlyCost() {
        if (!this._averageMonthlyCostCents) {
            if (this.getTotalPremium() === 0 || this.getTotalPremium() === 0 || !this.getTermLength()) {
                return 0;
            }
            this.setAverageMonthlyCost(Math.floor(this.getTotalPremium() / this.getTermLength()));
        }
        return this._averageMonthlyCostCents;
    }
    getAverageMonthlySavings() {
        return this._averageMonthlySavingsCents;
    }
    getBindPhoneNumber() {
        return this._bindPhoneNumber;
    }
    getBindUrl() {
        return this._bindUrl;
    }
    getClickRedirectData() {
        return { redirectUrl: this._bindUrl };
    }
    getClickText() {
        return this._clickText;
    }
    getDownPayment() {
        return this._downPaymentCents;
    }
    getInstallmentCents() {
        return this._installmentCents;
    }
    getIssuerId() {
        return this._issuerId;
    }
    getNumberOfPayments() {
        return this._numberOfPayments;
    }
    getPhoneUrl() {
        return this._phoneUrl;
    }
    getReferenceNumber() {
        return this._referenceNumber;
    }
    getQuoteRank() {
        return this._quoteRank;
    }
    getTermLength() {
        return this._termLengthMonths;
    }
    getTotalPremium() {
        return this._totalPremiumCents;
    }
    getTotalSavings() {
        return this._totalSavingsCents;
    }
    getSavvyData() {
        return {
            id: this.getId(),
            clickUrl: this.getClickUrl(),
            issuerName: this.getIssuerName(),
            issuerId: this.getIssuerId(),
            providerName: this.getProviderName(),
            providerRank: this.getProviderRank(),
            type: this.getResultType(),
            averageMonthlySavingsCents: this.getAverageMonthlySavings(),
            bindPhoneNumber: this.getBindPhoneNumber(),
            bindUrl: this.getBindUrl(),
            clickText: this.getClickText(),
            downPaymentCents: this.getDownPayment(),
            installmentCents: this.getInstallmentCents(),
            numberOfPayments: this.getNumberOfPayments(),
            phoneUrl: this.getPhoneUrl(),
            quoteMonthlyCents: this.getAverageMonthlyCost(),
            quoteRank: this.getQuoteRank(),
            referenceNumber: this.getReferenceNumber(),
            termLengthMonths: this.getTermLength(),
            totalPremiumCents: this.getTotalPremium(),
            totalSavingsCents: this.getTotalSavings(),
        };
    }
    getSanitizedData() {
        return {
            id: this.getId(),
            clickUrl: this.getClickUrl(),
            averageMonthlySavingsCents: this.getAverageMonthlySavings(),
            clickText: this.getClickText(),
            downPaymentCents: this.getDownPayment(),
            issuerId: this.getIssuerId(),
            issuerName: this.getIssuerName(),
            quoteMonthlyCents: this.getAverageMonthlyCost(),
            termLengthMonths: this.getTermLength(),
            totalPremiumCents: this.getTotalPremium(),
            totalSavingsCents: this.getTotalSavings(),
            referenceNumber: this.getReferenceNumber(),
            bindPhoneNumber: this.getBindPhoneNumber(),
        };
    }
    getResultType() {
        return this._resultType;
    }
    // mutator
    setAverageMonthlyCost(monthlyCostCents) {
        this._averageMonthlyCostCents = monthlyCostCents;
    }
    setAverageMonthlySavings(amount) {
        this._averageMonthlySavingsCents = amount;
    }
    setBindPhoneNumber(phoneNumber) {
        this._bindPhoneNumber = phoneNumber;
    }
    setBindUrl(url) {
        this._bindUrl = url;
    }
    setClickText(text) {
        this._clickText = text;
    }
    setDownPayment(downPayment) {
        this._downPaymentCents = downPayment;
    }
    setInstallmentCents(installmentCents) {
        this._installmentCents = installmentCents;
    }
    setNumberOfPayments(numberOfPayments) {
        this._numberOfPayments = numberOfPayments;
    }
    setPhoneUrl(url) {
        this._phoneUrl = url;
    }
    setQuoteRank(rank) {
        this._quoteRank = rank;
    }
    setReferenceNumber(referenceNumber) {
        this._referenceNumber = referenceNumber;
    }
    setTermLength(termLength) {
        this._termLengthMonths = termLength;
    }
    setTotalPremium(premium) {
        this._totalPremiumCents = premium;
    }
    setTotalSavings(amount) {
        this._totalSavingsCents = amount;
    }
    calculateSavings(policy) {
        const policyMonthlyCost = Math.floor(policy.premiumCents / policy.policyTermMonths);
        const quoteMonthlyCost = this.getAverageMonthlyCost();
        // Sometimes the target plan is 12 months while the quote is for a 6 month quote. To account for this,
        // we want to make sure we are comparing total cost for the same term length and not the total cost of
        // a 12 month quote compared to a 6 month quote.
        this.setTotalSavings(Math.floor(policy.premiumCents - (this.getTotalPremium() * policy.policyTermMonths) / this.getTermLength()));
        this.setAverageMonthlySavings(policyMonthlyCost - quoteMonthlyCost);
        this.setClickText(this.getAverageMonthlySavings() > 0
            ? `Save $${(this.getAverageMonthlySavings() / 100).toFixed(2)} avg/month`
            : 'Review This Deal');
    }
    setSavvyData({ averageMonthlySavingsCents, bindPhoneNumber, bindUrl, clickText, clickUrl, downPaymentCents, installmentCents, issuerName, numberOfPayments, phoneUrl, quoteRank, referenceNumber, termLengthMonths, totalPremiumCents, totalSavingsCents, }) {
        this.setAverageMonthlySavings(averageMonthlySavingsCents);
        this.setBindPhoneNumber(bindPhoneNumber);
        this.setBindUrl(bindUrl);
        this.setClickText(clickText);
        this.setClickUrl(clickUrl);
        this.setDownPayment(downPaymentCents);
        this.setInstallmentCents(installmentCents);
        this.setIssuerNameAndId(issuerName);
        this.setNumberOfPayments(numberOfPayments);
        this.setPhoneUrl(phoneUrl);
        this.setQuoteRank(quoteRank);
        this.setReferenceNumber(referenceNumber);
        this.setTermLength(termLengthMonths);
        this.setTotalPremium(totalPremiumCents);
        this.setTotalSavings(totalSavingsCents);
    }
}
quote.QuoteBase = QuoteBase;

var types = {};

var lifeQuote = {};

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.LifeQuoteAssumption = void 0;
	(function (LifeQuoteAssumption) {
	    LifeQuoteAssumption["EXCELLENT_HEALTH"] = "EXCELLENT_HEALTH";
	    LifeQuoteAssumption["NO_NICOTINE_USE"] = "NO_NICOTINE_USE";
	    LifeQuoteAssumption["TERM_10"] = "TERM_10";
	    LifeQuoteAssumption["AGE_35"] = "AGE_35";
	    LifeQuoteAssumption["GENDER_MALE"] = "GENDER_MALE";
	})(exports.LifeQuoteAssumption || (exports.LifeQuoteAssumption = {}));
	
} (lifeQuote));

var result = {};

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ResultType = void 0;
	(function (ResultType) {
	    ResultType["Quote"] = "QUOTE";
	    ResultType["LifeQuote"] = "LIFE_QUOTE";
	    ResultType["Ad"] = "AD";
	    ResultType["AUTO_LOAN_REFI_QUOTE"] = "AUTO_LOAN_REFI_QUOTE";
	})(exports.ResultType || (exports.ResultType = {}));
	
} (result));

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(lifeQuote, exports);
	__exportStar(result, exports);
	
} (types));

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(ad, exports);
	__exportStar(autoLoanRefiQuote, exports);
	__exportStar(lifeQuote$1, exports);
	__exportStar(quote, exports);
	__exportStar(result$1, exports);
	__exportStar(types, exports);
	
} (lib));

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

var REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

function validate(uuid) {
  return typeof uuid === 'string' && REGEX.test(uuid);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return stringify(rnds);
}

/** @class */ ((function (_super) {
    __extends(Ad, _super);
    // Concrete class must implement constructor
    function Ad(providerName, id) {
        var _this = _super.call(this) || this;
        _this._adsRank = 1;
        _this._clickUrl = '';
        _this._id = id || v4();
        _this._providerName = providerName;
        _this._resultType = lib.ResultType.Ad;
        return _this;
    }
    // concrete must implement clone
    Ad.prototype.clone = function () {
        var adToReturn = new Ad(this.getProviderName(), this.getId());
        adToReturn.setSavvyData(this.getSavvyData());
        return adToReturn;
    };
    return Ad;
})(lib.AdBase));
/** @class */ ((function (_super) {
    __extends(Quote, _super);
    // Concrete class must implement constructor
    function Quote(providerName, id) {
        var _this = _super.call(this) || this;
        _this._id = id || v4();
        _this._providerName = providerName;
        _this._resultType = lib.ResultType.Quote;
        return _this;
    }
    return Quote;
})(lib.QuoteBase));
var genericDataStructFactory = function (defaults) {
    return function (overrides) {
        if (overrides === void 0) { overrides = {}; }
        return (__assign(__assign({}, defaults), overrides));
    };
};

var buildSavvyBasicAddress = genericDataStructFactory({
    address1: '123 Main St',
    address2: 'Apt 2',
    city: 'San Francisco',
    zip: '94129',
    state: 'CA',
});
var buildSavvyAddress = genericDataStructFactory({
    number: '123',
    street: 'Main',
    type: 'St',
    secUnitType: 'Apt',
    secUnitNum: '2',
    city: 'San Francisco',
    zip: '94129',
    plus4: '2233',
    suffix: 'Ave',
    prefix: 'W',
    state: 'CA',
});
var buildSavvyCoverage = genericDataStructFactory({
    name: SavvyCoverageName.BodilyInjuryLiability,
    premiumCents: 7400,
    isDeclined: false,
    perPersonLimitCents: 20000,
    perAccidentLimitCents: 40000,
    deductibleCents: 1000,
    glassDeductibleCents: 500,
    perDayLimitCents: 40000,
    perWeekLimitCents: 40000,
    perMonthLimitCents: 45000,
});
var buildSavvyDiscount = genericDataStructFactory({
    name: SavvyDiscountName.GoodDriver,
    discountCents: 1000,
});
var buildSavvyName = genericDataStructFactory({
    firstName: 'foo',
    lastName: 'bar',
});
var buildSavvyIncident = genericDataStructFactory({
    operator: 0,
    operatorName: buildSavvyName(),
    type: SavvyIncidentType.Claim,
    subType: SavvyIncidentSubType.CarelessDriving,
    date: '2019-01-01',
    state: 'CA',
    policyHolderAtFault: AtFault.Yes,
    paidAmountCents: 229670,
});
var buildSavvyOperator = genericDataStructFactory({
    isPolicyHolder: true,
    name: buildSavvyName(),
    gender: SavvyGender.Female,
    dateOfBirth: '1985-08-29',
    age: 105,
    ageLicensed: 16,
    driversLicenseState: 'CA',
    driversLicenseStatus: SavvyDriversLicenseStatus.ValidUSLicense,
    driversLicenseNumber: 'S22229999',
    maritalStatus: SavvyMaritalStatus.Married,
    relationship: SavvyRelationship.PrimaryInsured,
    monthsAtCurrentEmployer: 60,
    education: SavvyEducation.Associates,
});
var buildSavvyBasicPolicyHolder = genericDataStructFactory({
    name: buildSavvyName(),
    address: buildSavvyBasicAddress(),
    email: 'foo@bar.baz',
    phoneNumber: '(222) 222-2222',
    dateOfBirth: '2019-04-01',
});
var buildSavvyPolicyHolder = genericDataStructFactory(__assign(__assign({}, buildSavvyBasicPolicyHolder()), { address: buildSavvyAddress(), monthsInsured: 12, isHomeOwner: true, residenceStatus: SavvyResidenceStatus.OwnSingleFamily, monthsAtCurrentResidence: 12, isMilitary: false, dateOfBirth: '2019-04-01' }));
var buildSavvyVehicle = genericDataStructFactory({
    primaryOperator: 0,
    year: 2015,
    vin: 'WBA2F7C55FVX55555',
    type: SavvyVehicleType.Automobile,
    primaryUse: SavvyVehicleUse.Commute,
    annualMileage: 5000,
    ownershipStatus: SavvyOwnershipStatus.Owned,
    lienHolder: 'TD Auto Finance',
    lienHolderAddress: buildSavvyAddress(),
    purchaseDate: '1999-04-12',
    purchasedNew: true,
    purchaseNewCostCents: 3200000,
    inStorage: true,
    garagingAddress: buildSavvyAddress(),
    hasAntiTheftDevices: true,
    isRideSharing: true,
    discounts: [buildSavvyDiscount()],
    coverages: [buildSavvyCoverage()],
});
var buildSavvyAutoPolicy = function (overrides, useExpectedPremium) {
    var policyData = __assign(__assign(__assign({ policyType: SAVVY_POLICY_TYPE.AUTO_POLICY, isActive: true, policyTermMonths: 6, numberOfPayments: 5 }, (useExpectedPremium ? { expectedPremiumCents: 82500 } : { premiumCents: 94200 })), { currentIssuer: 'demo', issueDate: '2019-01-01', renewalDate: '2019-07-01', canceledDate: '2019-04-01', policyHolder: buildSavvyPolicyHolder(), operators: [buildSavvyOperator()], vehicles: [buildSavvyVehicle()], discounts: [buildSavvyDiscount()], incidents: [buildSavvyIncident()] }), overrides);
    return genericDataStructFactory(policyData)();
};

var buildSavvyProperty = genericDataStructFactory({
    address: buildSavvyBasicAddress(),
    architecturalStyle: 'BUNGALOW',
    dwelling: 'Single Family Home',
    estimatedReplacementCost: 250000,
    numberOfStories: 1,
    purchaseDate: '2023-02-28',
    squareFeet: 2000,
    usage: 'unknown',
    wallType: 'FRAME/VINYL',
    yearBuilt: 2004,
});
var buildSavvyHouseholdMember = genericDataStructFactory({
    name: buildSavvyName(),
    dateOfBirth: '2019-04-01',
});
var buildSavvyHomeownersPolicy = genericDataStructFactory({
    policyType: SAVVY_POLICY_TYPE.HOMEOWNERS_POLICY,
    policyHolder: buildSavvyBasicPolicyHolder(),
    householdMembers: [buildSavvyHouseholdMember()],
    property: buildSavvyProperty(),
    currentIssuer: 'demo',
});

var buildTrellisAddress = genericDataStructFactory({
    number: '123',
    street: 'Main',
    type: 'St',
    sec_unit_type: 'Apt',
    sec_unit_num: '2',
    city: 'San Francisco',
    zip: '94129',
    plus4: '2233',
    prefix: 'W',
    state: 'CA',
});
var buildTrellisCoverage = genericDataStructFactory({
    name: 'Bodily Injury Liability',
    premiumCents: 7400,
    isDeclined: false,
    perPersonLimitCents: 20000,
    perAccidentLimitCents: 40000,
    deductibleCents: 1000,
    glassDeductibleCents: 500,
    perDayLimitCents: 40000,
    perWeekLimitCents: 40000,
    perMonthLimitCents: 45000,
});
var buildTrellisDiscount = genericDataStructFactory({
    name: TrellisDiscountType.goodDriver,
    rawName: TrellisDiscountType.goodDriver,
    discountCents: 1000,
});
var buildTrellisName = genericDataStructFactory({
    firstName: 'foo',
    lastName: 'bar',
});
var buildTrellisIncident = genericDataStructFactory({
    id: '',
    atFault: 'yes',
    driver: 0,
    driverNameRaw: '',
    descriptionRaw: '',
    liabilityMedicalPaidAmountCents: 0,
    type: 'CLAIM',
    typeDetails: 'Careless driving',
    date: '2019-01-01',
    state: 'CA',
    paidAmountCents: 229670,
});
var buildTrellisOperator = genericDataStructFactory({
    address: buildTrellisAddress(),
    isPrimary: true,
    name: buildTrellisName(),
    gender: TrellisGender.female,
    birthday: '1985-08-29',
    ageLicensed: 16,
    driversLicenseState: 'CA',
    driversLicenseStatus: 'ValidUSLicense',
    driversLicenseNumber: 'S22229999',
    maritalStatus: TrellisMaritalStatus.married,
    relationship: 'primary insured',
    experienceYears: 5,
    education: TrellisEducation.associates,
});
var buildTrellisPolicyHolder = genericDataStructFactory({
    name: buildTrellisName(),
    address: buildTrellisAddress(),
    email: 'foo@bar.baz',
    phoneNumber: '(222) 222-2222',
    tenureInYears: 1,
    isHomeOwner: true,
    residenceStatus: 'OwnSingleFamily',
    monthsAtCurrentResidence: 12,
    isMilitary: false,
});
var buildTrellisVehicle = genericDataStructFactory({
    year: '2015',
    make: 'NISSAN',
    model: 'SENTRA 4DR',
    vin: 'WBA2F7C55FVX55555',
    type: TrellisVehicleType.automobile,
    use: TrellisVehicleUse.commute,
    annualMileage: 5000,
    ownershipStatus: TrellisOwnershipStatus.owned,
    lienHolder: 'TD Auto Finance',
    lienHolderAddress: buildTrellisAddress(),
    purchaseDate: '1999-04-12',
    inStorage: true,
    garagingLocation: buildTrellisAddress(),
    antiTheftDevices: true,
    isRideSharing: true,
    discounts: [buildTrellisDiscount()],
    coverages: [buildTrellisCoverage()],
    driver: buildTrellisName(),
});
var buildTrellisPaymentHistory = genericDataStructFactory({
    amount: 1000,
    date: '2019-01-01',
    purpose: 'Other',
});
var buildTrellisAutoPolicy = function (overrides, useExpectedPremium) {
    var policyData = __assign(__assign(__assign({ id: '', dateRetrieved: '2019-01-01', policyType: TrellisPolicyTypes.PERSONAL_AUTO, active: true, policyTermMonths: 6, numberOfPayments: 5 }, (useExpectedPremium ? { expectedPremiumCents: 82500 } : { premiumCents: 94200 })), { issuer: 'demo', issueDate: '2019-01-01', renewalDate: '2019-07-01', canceledDate: '2019-04-01', policyHolder: buildTrellisPolicyHolder(), operators: [buildTrellisOperator()], vehicles: [buildTrellisVehicle()], discounts: [buildTrellisDiscount()], incidents: [buildTrellisIncident()], hasAtFaultAccident: 'no', hasAtFaultClaim: 'no', paymentHistory: [buildTrellisPaymentHistory()] }), overrides);
    return genericDataStructFactory(policyData)();
};

var getExpectedTrellisDiscount = function (overrides) {
    if (overrides === void 0) { overrides = {}; }
    return (__assign({ discountCents: 1000, name: TrellisDiscountType.goodDriver, rawName: 'Good Driver' }, overrides));
};
var getExpectedTrellisOperator = function (overrides) {
    if (overrides === void 0) { overrides = {}; }
    return (__assign({ address: undefined, addressRaw: undefined, ageLicensed: 16, ageLicensedInternationally: undefined, birthday: '1985-08-29', birthdayRange: { start: '1985-08-29', end: '1985-08-29' }, driversLicenseNumber: 'S22229999', driversLicenseState: 'CA', driversLicenseStatus: 'ValidUSLicense', education: TrellisEducation.associates, email: undefined, experienceYears: 5, gender: TrellisGender.female, isPrimary: true, maritalStatus: TrellisMaritalStatus.married, name: {
            firstName: 'foo',
            lastName: 'bar',
        }, occupation: undefined, rawEducation: 'associates', relationship: 'primary insured' }, overrides));
};
var getExpectedTrellisPolicyHolder = function (overrides) {
    if (overrides === void 0) { overrides = {}; }
    return (__assign({ address: {
            city: 'San Francisco',
            number: '123',
            plus4: '2233',
            prefix: 'W',
            sec_unit_num: '2',
            sec_unit_type: 'Apt',
            state: 'CA',
            street: 'Main',
            type: 'St',
            zip: '94129',
        }, addressRaw: undefined, email: 'foo@bar.baz', isHomeOwner: true, isMilitary: false, monthsAtCurrentResidence: 12, name: {
            firstName: 'foo',
            lastName: 'bar',
        }, phoneNumber: '(222) 222-2222', residenceStatus: 'OwnSingleFamily', tenureInYears: 1, birthday: '2019-04-01', birthdayRange: { end: '2019-04-01', start: '2019-04-01' } }, overrides));
};
var getExpectedTrellisPolicy = function (overrides, useExpectedPremium) {
    if (overrides === void 0) { overrides = {}; }
    return (__assign(__assign(__assign({ active: true, canceledDate: '2019-04-01', dateRetrieved: undefined, discountTotalCents: 1000, discounts: [getExpectedTrellisDiscount()], hasAtFaultAccident: 'no', hasAtFaultClaim: 'yes', id: undefined, incidents: [
            {
                atFault: 'yes',
                date: '2019-01-01',
                descriptionRaw: '',
                driver: 0,
                driverNameRaw: undefined,
                id: '',
                liabilityMedicalPaidAmountCents: undefined,
                paidAmountCents: 229670,
                state: 'CA',
                type: 'CLAIM',
                typeDetails: 'Careless driving',
            },
        ], issueDate: '2019-01-01', issuer: 'demo', issuerId: 'demo', numberOfPayments: 5, operators: [getExpectedTrellisOperator()], paymentHistory: [], paymentScheduleMonths: undefined, policyHolder: getExpectedTrellisPolicyHolder(overrides === null || overrides === void 0 ? void 0 : overrides.policyHolder), policyNumber: undefined, policyTermMonths: 6, policyType: TrellisPolicyTypes.PERSONAL_AUTO }, (useExpectedPremium
        ? { expectedPremiumCents: 82500, premiumCents: undefined }
        : { premiumCents: 94200, expectedPremiumCents: undefined })), { renewalDate: '2019-07-01', vehicles: [getExpectedTrellisVehicle()] }), overrides));
};
var getExpectedTrellisVehicle = function (overrides) {
    if (overrides === void 0) { overrides = {}; }
    return (__assign({ annualMileage: 5000, antiTheftDevices: true, bodyStyle: undefined, coverages: [
            {
                deductibleCents: 1000,
                glassDeductibleCents: 500,
                isDeclined: false,
                name: 'Bodily Injury Liability',
                perAccidentLimitCents: 40000,
                perDayLimitCents: 40000,
                perWeekLimitCents: 40000,
                perMonthLimitCents: 45000,
                perPersonLimitCents: 20000,
                premiumCents: 7400,
            },
        ], discountTotalCents: 1000, discounts: [
            {
                discountCents: 1000,
                name: TrellisDiscountType.goodDriver,
                rawName: 'Good Driver',
            },
        ], driver: {
            firstName: 'foo',
            lastName: 'bar',
        }, garagingLocation: {
            city: 'San Francisco',
            number: '123',
            plus4: '2233',
            prefix: 'W',
            sec_unit_num: '2',
            sec_unit_type: 'Apt',
            state: 'CA',
            street: 'Main',
            type: 'St',
            zip: '94129',
        }, garagingLocationRaw: undefined, inStorage: true, isRideSharing: true, lienHolder: 'TD Auto Finance', lienHolderAddress: {
            city: 'San Francisco',
            number: '123',
            plus4: '2233',
            prefix: 'W',
            sec_unit_num: '2',
            sec_unit_type: 'Apt',
            state: 'CA',
            street: 'Main',
            type: 'St',
            zip: '94129',
        }, lienHolderAddressRaw: undefined, make: undefined, model: undefined, ownershipStatus: TrellisOwnershipStatus.owned, premiumCents: undefined, purchaseDate: '1999-04-12', type: TrellisVehicleType.automobile, use: TrellisVehicleUse.commute, vin: 'WBA2F7C55FVX55555', year: '2015' }, overrides));
};

var isSupportedIssuer = function (input) {
    return Object.values(SupportedIssuers).includes(input);
};
var toTrellisIssuer = function (currentIssuer) {
    return currentIssuer && isSupportedIssuer(currentIssuer) ? currentIssuer : undefined;
};

var toTrellisPolicyTermMonths = function (input) {
    return input === 6 || input === 12 ? input : undefined;
};

function commonjsRequire(path) {
	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

var address = {};

/*!
 * XRegExp 3.2.0
 * <xregexp.com>
 * Steven Levithan (c) 2007-2017 MIT License
 */

var xregexp;
var hasRequiredXregexp;

function requireXregexp () {
	if (hasRequiredXregexp) return xregexp;
	hasRequiredXregexp = 1;

	/**
	 * XRegExp provides augmented, extensible regular expressions. You get additional regex syntax and
	 * flags, beyond what browsers support natively. XRegExp is also a regex utility belt with tools to
	 * make your client-side grepping simpler and more powerful, while freeing you from related
	 * cross-browser inconsistencies.
	 */

	// ==--------------------------==
	// Private stuff
	// ==--------------------------==

	// Property name used for extended regex instance data
	var REGEX_DATA = 'xregexp';
	// Optional features that can be installed and uninstalled
	var features = {
	    astral: false,
	    natives: false
	};
	// Native methods to use and restore ('native' is an ES3 reserved keyword)
	var nativ = {
	    exec: RegExp.prototype.exec,
	    test: RegExp.prototype.test,
	    match: String.prototype.match,
	    replace: String.prototype.replace,
	    split: String.prototype.split
	};
	// Storage for fixed/extended native methods
	var fixed = {};
	// Storage for regexes cached by `XRegExp.cache`
	var regexCache = {};
	// Storage for pattern details cached by the `XRegExp` constructor
	var patternCache = {};
	// Storage for regex syntax tokens added internally or by `XRegExp.addToken`
	var tokens = [];
	// Token scopes
	var defaultScope = 'default';
	var classScope = 'class';
	// Regexes that match native regex syntax, including octals
	var nativeTokens = {
	    // Any native multicharacter token in default scope, or any single character
	    'default': /\\(?:0(?:[0-3][0-7]{0,2}|[4-7][0-7]?)?|[1-9]\d*|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|\(\?(?:[:=!]|<[=!])|[?*+]\?|{\d+(?:,\d*)?}\??|[\s\S]/,
	    // Any native multicharacter token in character class scope, or any single character
	    'class': /\\(?:[0-3][0-7]{0,2}|[4-7][0-7]?|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|[\s\S]/
	};
	// Any backreference or dollar-prefixed character in replacement strings
	var replacementToken = /\$(?:{([\w$]+)}|(\d\d?|[\s\S]))/g;
	// Check for correct `exec` handling of nonparticipating capturing groups
	var correctExecNpcg = nativ.exec.call(/()??/, '')[1] === undefined;
	// Check for ES6 `flags` prop support
	var hasFlagsProp = /x/.flags !== undefined;
	// Shortcut to `Object.prototype.toString`
	var toString = {}.toString;

	function hasNativeFlag(flag) {
	    // Can't check based on the presence of properties/getters since browsers might support such
	    // properties even when they don't support the corresponding flag in regex construction (tested
	    // in Chrome 48, where `'unicode' in /x/` is true but trying to construct a regex with flag `u`
	    // throws an error)
	    var isSupported = true;
	    try {
	        // Can't use regex literals for testing even in a `try` because regex literals with
	        // unsupported flags cause a compilation error in IE
	        new RegExp('', flag);
	    } catch (exception) {
	        isSupported = false;
	    }
	    return isSupported;
	}
	// Check for ES6 `u` flag support
	var hasNativeU = hasNativeFlag('u');
	// Check for ES6 `y` flag support
	var hasNativeY = hasNativeFlag('y');
	// Tracker for known flags, including addon flags
	var registeredFlags = {
	    g: true,
	    i: true,
	    m: true,
	    u: hasNativeU,
	    y: hasNativeY
	};

	/**
	 * Attaches extended data and `XRegExp.prototype` properties to a regex object.
	 *
	 * @private
	 * @param {RegExp} regex Regex to augment.
	 * @param {Array} captureNames Array with capture names, or `null`.
	 * @param {String} xSource XRegExp pattern used to generate `regex`, or `null` if N/A.
	 * @param {String} xFlags XRegExp flags used to generate `regex`, or `null` if N/A.
	 * @param {Boolean} [isInternalOnly=false] Whether the regex will be used only for internal
	 *   operations, and never exposed to users. For internal-only regexes, we can improve perf by
	 *   skipping some operations like attaching `XRegExp.prototype` properties.
	 * @returns {RegExp} Augmented regex.
	 */
	function augment(regex, captureNames, xSource, xFlags, isInternalOnly) {
	    var p;

	    regex[REGEX_DATA] = {
	        captureNames: captureNames
	    };

	    if (isInternalOnly) {
	        return regex;
	    }

	    // Can't auto-inherit these since the XRegExp constructor returns a nonprimitive value
	    if (regex.__proto__) {
	        regex.__proto__ = XRegExp.prototype;
	    } else {
	        for (p in XRegExp.prototype) {
	            // An `XRegExp.prototype.hasOwnProperty(p)` check wouldn't be worth it here, since this
	            // is performance sensitive, and enumerable `Object.prototype` or `RegExp.prototype`
	            // extensions exist on `regex.prototype` anyway
	            regex[p] = XRegExp.prototype[p];
	        }
	    }

	    regex[REGEX_DATA].source = xSource;
	    // Emulate the ES6 `flags` prop by ensuring flags are in alphabetical order
	    regex[REGEX_DATA].flags = xFlags ? xFlags.split('').sort().join('') : xFlags;

	    return regex;
	}

	/**
	 * Removes any duplicate characters from the provided string.
	 *
	 * @private
	 * @param {String} str String to remove duplicate characters from.
	 * @returns {String} String with any duplicate characters removed.
	 */
	function clipDuplicates(str) {
	    return nativ.replace.call(str, /([\s\S])(?=[\s\S]*\1)/g, '');
	}

	/**
	 * Copies a regex object while preserving extended data and augmenting with `XRegExp.prototype`
	 * properties. The copy has a fresh `lastIndex` property (set to zero). Allows adding and removing
	 * flags g and y while copying the regex.
	 *
	 * @private
	 * @param {RegExp} regex Regex to copy.
	 * @param {Object} [options] Options object with optional properties:
	 *   - `addG` {Boolean} Add flag g while copying the regex.
	 *   - `addY` {Boolean} Add flag y while copying the regex.
	 *   - `removeG` {Boolean} Remove flag g while copying the regex.
	 *   - `removeY` {Boolean} Remove flag y while copying the regex.
	 *   - `isInternalOnly` {Boolean} Whether the copied regex will be used only for internal
	 *     operations, and never exposed to users. For internal-only regexes, we can improve perf by
	 *     skipping some operations like attaching `XRegExp.prototype` properties.
	 *   - `source` {String} Overrides `<regex>.source`, for special cases.
	 * @returns {RegExp} Copy of the provided regex, possibly with modified flags.
	 */
	function copyRegex(regex, options) {
	    if (!XRegExp.isRegExp(regex)) {
	        throw new TypeError('Type RegExp expected');
	    }

	    var xData = regex[REGEX_DATA] || {};
	    var flags = getNativeFlags(regex);
	    var flagsToAdd = '';
	    var flagsToRemove = '';
	    var xregexpSource = null;
	    var xregexpFlags = null;

	    options = options || {};

	    if (options.removeG) {flagsToRemove += 'g';}
	    if (options.removeY) {flagsToRemove += 'y';}
	    if (flagsToRemove) {
	        flags = nativ.replace.call(flags, new RegExp('[' + flagsToRemove + ']+', 'g'), '');
	    }

	    if (options.addG) {flagsToAdd += 'g';}
	    if (options.addY) {flagsToAdd += 'y';}
	    if (flagsToAdd) {
	        flags = clipDuplicates(flags + flagsToAdd);
	    }

	    if (!options.isInternalOnly) {
	        if (xData.source !== undefined) {
	            xregexpSource = xData.source;
	        }
	        // null or undefined; don't want to add to `flags` if the previous value was null, since
	        // that indicates we're not tracking original precompilation flags
	        if (xData.flags != null) {
	            // Flags are only added for non-internal regexes by `XRegExp.globalize`. Flags are never
	            // removed for non-internal regexes, so don't need to handle it
	            xregexpFlags = flagsToAdd ? clipDuplicates(xData.flags + flagsToAdd) : xData.flags;
	        }
	    }

	    // Augment with `XRegExp.prototype` properties, but use the native `RegExp` constructor to avoid
	    // searching for special tokens. That would be wrong for regexes constructed by `RegExp`, and
	    // unnecessary for regexes constructed by `XRegExp` because the regex has already undergone the
	    // translation to native regex syntax
	    regex = augment(
	        new RegExp(options.source || regex.source, flags),
	        hasNamedCapture(regex) ? xData.captureNames.slice(0) : null,
	        xregexpSource,
	        xregexpFlags,
	        options.isInternalOnly
	    );

	    return regex;
	}

	/**
	 * Converts hexadecimal to decimal.
	 *
	 * @private
	 * @param {String} hex
	 * @returns {Number}
	 */
	function dec(hex) {
	    return parseInt(hex, 16);
	}

	/**
	 * Returns a pattern that can be used in a native RegExp in place of an ignorable token such as an
	 * inline comment or whitespace with flag x. This is used directly as a token handler function
	 * passed to `XRegExp.addToken`.
	 *
	 * @private
	 * @param {String} match Match arg of `XRegExp.addToken` handler
	 * @param {String} scope Scope arg of `XRegExp.addToken` handler
	 * @param {String} flags Flags arg of `XRegExp.addToken` handler
	 * @returns {String} Either '' or '(?:)', depending on which is needed in the context of the match.
	 */
	function getContextualTokenSeparator(match, scope, flags) {
	    if (
	        // No need to separate tokens if at the beginning or end of a group
	        match.input.charAt(match.index - 1) === '(' ||
	        match.input.charAt(match.index + match[0].length) === ')' ||
	        // Avoid separating tokens when the following token is a quantifier
	        isPatternNext(match.input, match.index + match[0].length, flags, '[?*+]|{\\d+(?:,\\d*)?}')
	    ) {
	        return '';
	    }
	    // Keep tokens separated. This avoids e.g. inadvertedly changing `\1 1` or `\1(?#)1` to `\11`.
	    // This also ensures all tokens remain as discrete atoms, e.g. it avoids converting the syntax
	    // error `(? :` into `(?:`.
	    return '(?:)';
	}

	/**
	 * Returns native `RegExp` flags used by a regex object.
	 *
	 * @private
	 * @param {RegExp} regex Regex to check.
	 * @returns {String} Native flags in use.
	 */
	function getNativeFlags(regex) {
	    return hasFlagsProp ?
	        regex.flags :
	        // Explicitly using `RegExp.prototype.toString` (rather than e.g. `String` or concatenation
	        // with an empty string) allows this to continue working predictably when
	        // `XRegExp.proptotype.toString` is overridden
	        nativ.exec.call(/\/([a-z]*)$/i, RegExp.prototype.toString.call(regex))[1];
	}

	/**
	 * Determines whether a regex has extended instance data used to track capture names.
	 *
	 * @private
	 * @param {RegExp} regex Regex to check.
	 * @returns {Boolean} Whether the regex uses named capture.
	 */
	function hasNamedCapture(regex) {
	    return !!(regex[REGEX_DATA] && regex[REGEX_DATA].captureNames);
	}

	/**
	 * Converts decimal to hexadecimal.
	 *
	 * @private
	 * @param {Number|String} dec
	 * @returns {String}
	 */
	function hex(dec) {
	    return parseInt(dec, 10).toString(16);
	}

	/**
	 * Returns the first index at which a given value can be found in an array.
	 *
	 * @private
	 * @param {Array} array Array to search.
	 * @param {*} value Value to locate in the array.
	 * @returns {Number} Zero-based index at which the item is found, or -1.
	 */
	function indexOf(array, value) {
	    var len = array.length;
	    var i;

	    for (i = 0; i < len; ++i) {
	        if (array[i] === value) {
	            return i;
	        }
	    }

	    return -1;
	}

	/**
	 * Checks whether the next nonignorable token after the specified position matches the
	 * `needlePattern`
	 *
	 * @private
	 * @param {String} pattern Pattern to search within.
	 * @param {Number} pos Index in `pattern` to search at.
	 * @param {String} flags Flags used by the pattern.
	 * @param {String} needlePattern Pattern to match the next token against.
	 * @returns {Boolean} Whether the next nonignorable token matches `needlePattern`
	 */
	function isPatternNext(pattern, pos, flags, needlePattern) {
	    var inlineCommentPattern = '\\(\\?#[^)]*\\)';
	    var lineCommentPattern = '#[^#\\n]*';
	    var patternsToIgnore = flags.indexOf('x') > -1 ?
	        // Ignore any leading whitespace, line comments, and inline comments
	        ['\\s', lineCommentPattern, inlineCommentPattern] :
	        // Ignore any leading inline comments
	        [inlineCommentPattern];
	    return nativ.test.call(
	        new RegExp('^(?:' + patternsToIgnore.join('|') + ')*(?:' + needlePattern + ')'),
	        pattern.slice(pos)
	    );
	}

	/**
	 * Determines whether a value is of the specified type, by resolving its internal [[Class]].
	 *
	 * @private
	 * @param {*} value Object to check.
	 * @param {String} type Type to check for, in TitleCase.
	 * @returns {Boolean} Whether the object matches the type.
	 */
	function isType(value, type) {
	    return toString.call(value) === '[object ' + type + ']';
	}

	/**
	 * Adds leading zeros if shorter than four characters. Used for fixed-length hexadecimal values.
	 *
	 * @private
	 * @param {String} str
	 * @returns {String}
	 */
	function pad4(str) {
	    while (str.length < 4) {
	        str = '0' + str;
	    }
	    return str;
	}

	/**
	 * Checks for flag-related errors, and strips/applies flags in a leading mode modifier. Offloads
	 * the flag preparation logic from the `XRegExp` constructor.
	 *
	 * @private
	 * @param {String} pattern Regex pattern, possibly with a leading mode modifier.
	 * @param {String} flags Any combination of flags.
	 * @returns {Object} Object with properties `pattern` and `flags`.
	 */
	function prepareFlags(pattern, flags) {
	    var i;

	    // Recent browsers throw on duplicate flags, so copy this behavior for nonnative flags
	    if (clipDuplicates(flags) !== flags) {
	        throw new SyntaxError('Invalid duplicate regex flag ' + flags);
	    }

	    // Strip and apply a leading mode modifier with any combination of flags except g or y
	    pattern = nativ.replace.call(pattern, /^\(\?([\w$]+)\)/, function($0, $1) {
	        if (nativ.test.call(/[gy]/, $1)) {
	            throw new SyntaxError('Cannot use flag g or y in mode modifier ' + $0);
	        }
	        // Allow duplicate flags within the mode modifier
	        flags = clipDuplicates(flags + $1);
	        return '';
	    });

	    // Throw on unknown native or nonnative flags
	    for (i = 0; i < flags.length; ++i) {
	        if (!registeredFlags[flags.charAt(i)]) {
	            throw new SyntaxError('Unknown regex flag ' + flags.charAt(i));
	        }
	    }

	    return {
	        pattern: pattern,
	        flags: flags
	    };
	}

	/**
	 * Prepares an options object from the given value.
	 *
	 * @private
	 * @param {String|Object} value Value to convert to an options object.
	 * @returns {Object} Options object.
	 */
	function prepareOptions(value) {
	    var options = {};

	    if (isType(value, 'String')) {
	        XRegExp.forEach(value, /[^\s,]+/, function(match) {
	            options[match] = true;
	        });

	        return options;
	    }

	    return value;
	}

	/**
	 * Registers a flag so it doesn't throw an 'unknown flag' error.
	 *
	 * @private
	 * @param {String} flag Single-character flag to register.
	 */
	function registerFlag(flag) {
	    if (!/^[\w$]$/.test(flag)) {
	        throw new Error('Flag must be a single character A-Za-z0-9_$');
	    }

	    registeredFlags[flag] = true;
	}

	/**
	 * Runs built-in and custom regex syntax tokens in reverse insertion order at the specified
	 * position, until a match is found.
	 *
	 * @private
	 * @param {String} pattern Original pattern from which an XRegExp object is being built.
	 * @param {String} flags Flags being used to construct the regex.
	 * @param {Number} pos Position to search for tokens within `pattern`.
	 * @param {Number} scope Regex scope to apply: 'default' or 'class'.
	 * @param {Object} context Context object to use for token handler functions.
	 * @returns {Object} Object with properties `matchLength`, `output`, and `reparse`; or `null`.
	 */
	function runTokens(pattern, flags, pos, scope, context) {
	    var i = tokens.length;
	    var leadChar = pattern.charAt(pos);
	    var result = null;
	    var match;
	    var t;

	    // Run in reverse insertion order
	    while (i--) {
	        t = tokens[i];
	        if (
	            (t.leadChar && t.leadChar !== leadChar) ||
	            (t.scope !== scope && t.scope !== 'all') ||
	            (t.flag && flags.indexOf(t.flag) === -1)
	        ) {
	            continue;
	        }

	        match = XRegExp.exec(pattern, t.regex, pos, 'sticky');
	        if (match) {
	            result = {
	                matchLength: match[0].length,
	                output: t.handler.call(context, match, scope, flags),
	                reparse: t.reparse
	            };
	            // Finished with token tests
	            break;
	        }
	    }

	    return result;
	}

	/**
	 * Enables or disables implicit astral mode opt-in. When enabled, flag A is automatically added to
	 * all new regexes created by XRegExp. This causes an error to be thrown when creating regexes if
	 * the Unicode Base addon is not available, since flag A is registered by that addon.
	 *
	 * @private
	 * @param {Boolean} on `true` to enable; `false` to disable.
	 */
	function setAstral(on) {
	    features.astral = on;
	}

	/**
	 * Enables or disables native method overrides.
	 *
	 * @private
	 * @param {Boolean} on `true` to enable; `false` to disable.
	 */
	function setNatives(on) {
	    RegExp.prototype.exec = (on ? fixed : nativ).exec;
	    RegExp.prototype.test = (on ? fixed : nativ).test;
	    String.prototype.match = (on ? fixed : nativ).match;
	    String.prototype.replace = (on ? fixed : nativ).replace;
	    String.prototype.split = (on ? fixed : nativ).split;

	    features.natives = on;
	}

	/**
	 * Returns the object, or throws an error if it is `null` or `undefined`. This is used to follow
	 * the ES5 abstract operation `ToObject`.
	 *
	 * @private
	 * @param {*} value Object to check and return.
	 * @returns {*} The provided object.
	 */
	function toObject(value) {
	    // null or undefined
	    if (value == null) {
	        throw new TypeError('Cannot convert null or undefined to object');
	    }

	    return value;
	}

	// ==--------------------------==
	// Constructor
	// ==--------------------------==

	/**
	 * Creates an extended regular expression object for matching text with a pattern. Differs from a
	 * native regular expression in that additional syntax and flags are supported. The returned object
	 * is in fact a native `RegExp` and works with all native methods.
	 *
	 * @class XRegExp
	 * @constructor
	 * @param {String|RegExp} pattern Regex pattern string, or an existing regex object to copy.
	 * @param {String} [flags] Any combination of flags.
	 *   Native flags:
	 *     - `g` - global
	 *     - `i` - ignore case
	 *     - `m` - multiline anchors
	 *     - `u` - unicode (ES6)
	 *     - `y` - sticky (Firefox 3+, ES6)
	 *   Additional XRegExp flags:
	 *     - `n` - explicit capture
	 *     - `s` - dot matches all (aka singleline)
	 *     - `x` - free-spacing and line comments (aka extended)
	 *     - `A` - astral (requires the Unicode Base addon)
	 *   Flags cannot be provided when constructing one `RegExp` from another.
	 * @returns {RegExp} Extended regular expression object.
	 * @example
	 *
	 * // With named capture and flag x
	 * XRegExp('(?<year>  [0-9]{4} ) -?  # year  \n\
	 *          (?<month> [0-9]{2} ) -?  # month \n\
	 *          (?<day>   [0-9]{2} )     # day   ', 'x');
	 *
	 * // Providing a regex object copies it. Native regexes are recompiled using native (not XRegExp)
	 * // syntax. Copies maintain extended data, are augmented with `XRegExp.prototype` properties, and
	 * // have fresh `lastIndex` properties (set to zero).
	 * XRegExp(/regex/);
	 */
	function XRegExp(pattern, flags) {
	    if (XRegExp.isRegExp(pattern)) {
	        if (flags !== undefined) {
	            throw new TypeError('Cannot supply flags when copying a RegExp');
	        }
	        return copyRegex(pattern);
	    }

	    // Copy the argument behavior of `RegExp`
	    pattern = pattern === undefined ? '' : String(pattern);
	    flags = flags === undefined ? '' : String(flags);

	    if (XRegExp.isInstalled('astral') && flags.indexOf('A') === -1) {
	        // This causes an error to be thrown if the Unicode Base addon is not available
	        flags += 'A';
	    }

	    if (!patternCache[pattern]) {
	        patternCache[pattern] = {};
	    }

	    if (!patternCache[pattern][flags]) {
	        var context = {
	            hasNamedCapture: false,
	            captureNames: []
	        };
	        var scope = defaultScope;
	        var output = '';
	        var pos = 0;
	        var result;

	        // Check for flag-related errors, and strip/apply flags in a leading mode modifier
	        var applied = prepareFlags(pattern, flags);
	        var appliedPattern = applied.pattern;
	        var appliedFlags = applied.flags;

	        // Use XRegExp's tokens to translate the pattern to a native regex pattern.
	        // `appliedPattern.length` may change on each iteration if tokens use `reparse`
	        while (pos < appliedPattern.length) {
	            do {
	                // Check for custom tokens at the current position
	                result = runTokens(appliedPattern, appliedFlags, pos, scope, context);
	                // If the matched token used the `reparse` option, splice its output into the
	                // pattern before running tokens again at the same position
	                if (result && result.reparse) {
	                    appliedPattern = appliedPattern.slice(0, pos) +
	                        result.output +
	                        appliedPattern.slice(pos + result.matchLength);
	                }
	            } while (result && result.reparse);

	            if (result) {
	                output += result.output;
	                pos += (result.matchLength || 1);
	            } else {
	                // Get the native token at the current position
	                var token = XRegExp.exec(appliedPattern, nativeTokens[scope], pos, 'sticky')[0];
	                output += token;
	                pos += token.length;
	                if (token === '[' && scope === defaultScope) {
	                    scope = classScope;
	                } else if (token === ']' && scope === classScope) {
	                    scope = defaultScope;
	                }
	            }
	        }

	        patternCache[pattern][flags] = {
	            // Use basic cleanup to collapse repeated empty groups like `(?:)(?:)` to `(?:)`. Empty
	            // groups are sometimes inserted during regex transpilation in order to keep tokens
	            // separated. However, more than one empty group in a row is never needed.
	            pattern: nativ.replace.call(output, /(?:\(\?:\))+/g, '(?:)'),
	            // Strip all but native flags
	            flags: nativ.replace.call(appliedFlags, /[^gimuy]+/g, ''),
	            // `context.captureNames` has an item for each capturing group, even if unnamed
	            captures: context.hasNamedCapture ? context.captureNames : null
	        };
	    }

	    var generated = patternCache[pattern][flags];
	    return augment(
	        new RegExp(generated.pattern, generated.flags),
	        generated.captures,
	        pattern,
	        flags
	    );
	}

	// Add `RegExp.prototype` to the prototype chain
	XRegExp.prototype = new RegExp();

	// ==--------------------------==
	// Public properties
	// ==--------------------------==

	/**
	 * The XRegExp version number as a string containing three dot-separated parts. For example,
	 * '2.0.0-beta-3'.
	 *
	 * @static
	 * @memberOf XRegExp
	 * @type String
	 */
	XRegExp.version = '3.2.0';

	// ==--------------------------==
	// Public methods
	// ==--------------------------==

	// Intentionally undocumented; used in tests and addons
	XRegExp._clipDuplicates = clipDuplicates;
	XRegExp._hasNativeFlag = hasNativeFlag;
	XRegExp._dec = dec;
	XRegExp._hex = hex;
	XRegExp._pad4 = pad4;

	/**
	 * Extends XRegExp syntax and allows custom flags. This is used internally and can be used to
	 * create XRegExp addons. If more than one token can match the same string, the last added wins.
	 *
	 * @memberOf XRegExp
	 * @param {RegExp} regex Regex object that matches the new token.
	 * @param {Function} handler Function that returns a new pattern string (using native regex syntax)
	 *   to replace the matched token within all future XRegExp regexes. Has access to persistent
	 *   properties of the regex being built, through `this`. Invoked with three arguments:
	 *   - The match array, with named backreference properties.
	 *   - The regex scope where the match was found: 'default' or 'class'.
	 *   - The flags used by the regex, including any flags in a leading mode modifier.
	 *   The handler function becomes part of the XRegExp construction process, so be careful not to
	 *   construct XRegExps within the function or you will trigger infinite recursion.
	 * @param {Object} [options] Options object with optional properties:
	 *   - `scope` {String} Scope where the token applies: 'default', 'class', or 'all'.
	 *   - `flag` {String} Single-character flag that triggers the token. This also registers the
	 *     flag, which prevents XRegExp from throwing an 'unknown flag' error when the flag is used.
	 *   - `optionalFlags` {String} Any custom flags checked for within the token `handler` that are
	 *     not required to trigger the token. This registers the flags, to prevent XRegExp from
	 *     throwing an 'unknown flag' error when any of the flags are used.
	 *   - `reparse` {Boolean} Whether the `handler` function's output should not be treated as
	 *     final, and instead be reparseable by other tokens (including the current token). Allows
	 *     token chaining or deferring.
	 *   - `leadChar` {String} Single character that occurs at the beginning of any successful match
	 *     of the token (not always applicable). This doesn't change the behavior of the token unless
	 *     you provide an erroneous value. However, providing it can increase the token's performance
	 *     since the token can be skipped at any positions where this character doesn't appear.
	 * @example
	 *
	 * // Basic usage: Add \a for the ALERT control code
	 * XRegExp.addToken(
	 *   /\\a/,
	 *   function() {return '\\x07';},
	 *   {scope: 'all'}
	 * );
	 * XRegExp('\\a[\\a-\\n]+').test('\x07\n\x07'); // -> true
	 *
	 * // Add the U (ungreedy) flag from PCRE and RE2, which reverses greedy and lazy quantifiers.
	 * // Since `scope` is not specified, it uses 'default' (i.e., transformations apply outside of
	 * // character classes only)
	 * XRegExp.addToken(
	 *   /([?*+]|{\d+(?:,\d*)?})(\??)/,
	 *   function(match) {return match[1] + (match[2] ? '' : '?');},
	 *   {flag: 'U'}
	 * );
	 * XRegExp('a+', 'U').exec('aaa')[0]; // -> 'a'
	 * XRegExp('a+?', 'U').exec('aaa')[0]; // -> 'aaa'
	 */
	XRegExp.addToken = function(regex, handler, options) {
	    options = options || {};
	    var optionalFlags = options.optionalFlags;
	    var i;

	    if (options.flag) {
	        registerFlag(options.flag);
	    }

	    if (optionalFlags) {
	        optionalFlags = nativ.split.call(optionalFlags, '');
	        for (i = 0; i < optionalFlags.length; ++i) {
	            registerFlag(optionalFlags[i]);
	        }
	    }

	    // Add to the private list of syntax tokens
	    tokens.push({
	        regex: copyRegex(regex, {
	            addG: true,
	            addY: hasNativeY,
	            isInternalOnly: true
	        }),
	        handler: handler,
	        scope: options.scope || defaultScope,
	        flag: options.flag,
	        reparse: options.reparse,
	        leadChar: options.leadChar
	    });

	    // Reset the pattern cache used by the `XRegExp` constructor, since the same pattern and flags
	    // might now produce different results
	    XRegExp.cache.flush('patterns');
	};

	/**
	 * Caches and returns the result of calling `XRegExp(pattern, flags)`. On any subsequent call with
	 * the same pattern and flag combination, the cached copy of the regex is returned.
	 *
	 * @memberOf XRegExp
	 * @param {String} pattern Regex pattern string.
	 * @param {String} [flags] Any combination of XRegExp flags.
	 * @returns {RegExp} Cached XRegExp object.
	 * @example
	 *
	 * while (match = XRegExp.cache('.', 'gs').exec(str)) {
	 *   // The regex is compiled once only
	 * }
	 */
	XRegExp.cache = function(pattern, flags) {
	    if (!regexCache[pattern]) {
	        regexCache[pattern] = {};
	    }
	    return regexCache[pattern][flags] || (
	        regexCache[pattern][flags] = XRegExp(pattern, flags)
	    );
	};

	// Intentionally undocumented; used in tests
	XRegExp.cache.flush = function(cacheName) {
	    if (cacheName === 'patterns') {
	        // Flush the pattern cache used by the `XRegExp` constructor
	        patternCache = {};
	    } else {
	        // Flush the regex cache populated by `XRegExp.cache`
	        regexCache = {};
	    }
	};

	/**
	 * Escapes any regular expression metacharacters, for use when matching literal strings. The result
	 * can safely be used at any point within a regex that uses any flags.
	 *
	 * @memberOf XRegExp
	 * @param {String} str String to escape.
	 * @returns {String} String with regex metacharacters escaped.
	 * @example
	 *
	 * XRegExp.escape('Escaped? <.>');
	 * // -> 'Escaped\?\ <\.>'
	 */
	XRegExp.escape = function(str) {
	    return nativ.replace.call(toObject(str), /[-\[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
	};

	/**
	 * Executes a regex search in a specified string. Returns a match array or `null`. If the provided
	 * regex uses named capture, named backreference properties are included on the match array.
	 * Optional `pos` and `sticky` arguments specify the search start position, and whether the match
	 * must start at the specified position only. The `lastIndex` property of the provided regex is not
	 * used, but is updated for compatibility. Also fixes browser bugs compared to the native
	 * `RegExp.prototype.exec` and can be used reliably cross-browser.
	 *
	 * @memberOf XRegExp
	 * @param {String} str String to search.
	 * @param {RegExp} regex Regex to search with.
	 * @param {Number} [pos=0] Zero-based index at which to start the search.
	 * @param {Boolean|String} [sticky=false] Whether the match must start at the specified position
	 *   only. The string `'sticky'` is accepted as an alternative to `true`.
	 * @returns {Array} Match array with named backreference properties, or `null`.
	 * @example
	 *
	 * // Basic use, with named backreference
	 * var match = XRegExp.exec('U+2620', XRegExp('U\\+(?<hex>[0-9A-F]{4})'));
	 * match.hex; // -> '2620'
	 *
	 * // With pos and sticky, in a loop
	 * var pos = 2, result = [], match;
	 * while (match = XRegExp.exec('<1><2><3><4>5<6>', /<(\d)>/, pos, 'sticky')) {
	 *   result.push(match[1]);
	 *   pos = match.index + match[0].length;
	 * }
	 * // result -> ['2', '3', '4']
	 */
	XRegExp.exec = function(str, regex, pos, sticky) {
	    var cacheKey = 'g';
	    var addY = false;
	    var fakeY = false;
	    var match;
	    var r2;

	    addY = hasNativeY && !!(sticky || (regex.sticky && sticky !== false));
	    if (addY) {
	        cacheKey += 'y';
	    } else if (sticky) {
	        // Simulate sticky matching by appending an empty capture to the original regex. The
	        // resulting regex will succeed no matter what at the current index (set with `lastIndex`),
	        // and will not search the rest of the subject string. We'll know that the original regex
	        // has failed if that last capture is `''` rather than `undefined` (i.e., if that last
	        // capture participated in the match).
	        fakeY = true;
	        cacheKey += 'FakeY';
	    }

	    regex[REGEX_DATA] = regex[REGEX_DATA] || {};

	    // Shares cached copies with `XRegExp.match`/`replace`
	    r2 = regex[REGEX_DATA][cacheKey] || (
	        regex[REGEX_DATA][cacheKey] = copyRegex(regex, {
	            addG: true,
	            addY: addY,
	            source: fakeY ? regex.source + '|()' : undefined,
	            removeY: sticky === false,
	            isInternalOnly: true
	        })
	    );

	    pos = pos || 0;
	    r2.lastIndex = pos;

	    // Fixed `exec` required for `lastIndex` fix, named backreferences, etc.
	    match = fixed.exec.call(r2, str);

	    // Get rid of the capture added by the pseudo-sticky matcher if needed. An empty string means
	    // the original regexp failed (see above).
	    if (fakeY && match && match.pop() === '') {
	        match = null;
	    }

	    if (regex.global) {
	        regex.lastIndex = match ? r2.lastIndex : 0;
	    }

	    return match;
	};

	/**
	 * Executes a provided function once per regex match. Searches always start at the beginning of the
	 * string and continue until the end, regardless of the state of the regex's `global` property and
	 * initial `lastIndex`.
	 *
	 * @memberOf XRegExp
	 * @param {String} str String to search.
	 * @param {RegExp} regex Regex to search with.
	 * @param {Function} callback Function to execute for each match. Invoked with four arguments:
	 *   - The match array, with named backreference properties.
	 *   - The zero-based match index.
	 *   - The string being traversed.
	 *   - The regex object being used to traverse the string.
	 * @example
	 *
	 * // Extracts every other digit from a string
	 * var evens = [];
	 * XRegExp.forEach('1a2345', /\d/, function(match, i) {
	 *   if (i % 2) evens.push(+match[0]);
	 * });
	 * // evens -> [2, 4]
	 */
	XRegExp.forEach = function(str, regex, callback) {
	    var pos = 0;
	    var i = -1;
	    var match;

	    while ((match = XRegExp.exec(str, regex, pos))) {
	        // Because `regex` is provided to `callback`, the function could use the deprecated/
	        // nonstandard `RegExp.prototype.compile` to mutate the regex. However, since `XRegExp.exec`
	        // doesn't use `lastIndex` to set the search position, this can't lead to an infinite loop,
	        // at least. Actually, because of the way `XRegExp.exec` caches globalized versions of
	        // regexes, mutating the regex will not have any effect on the iteration or matched strings,
	        // which is a nice side effect that brings extra safety.
	        callback(match, ++i, str, regex);

	        pos = match.index + (match[0].length || 1);
	    }
	};

	/**
	 * Copies a regex object and adds flag `g`. The copy maintains extended data, is augmented with
	 * `XRegExp.prototype` properties, and has a fresh `lastIndex` property (set to zero). Native
	 * regexes are not recompiled using XRegExp syntax.
	 *
	 * @memberOf XRegExp
	 * @param {RegExp} regex Regex to globalize.
	 * @returns {RegExp} Copy of the provided regex with flag `g` added.
	 * @example
	 *
	 * var globalCopy = XRegExp.globalize(/regex/);
	 * globalCopy.global; // -> true
	 */
	XRegExp.globalize = function(regex) {
	    return copyRegex(regex, {addG: true});
	};

	/**
	 * Installs optional features according to the specified options. Can be undone using
	 * `XRegExp.uninstall`.
	 *
	 * @memberOf XRegExp
	 * @param {Object|String} options Options object or string.
	 * @example
	 *
	 * // With an options object
	 * XRegExp.install({
	 *   // Enables support for astral code points in Unicode addons (implicitly sets flag A)
	 *   astral: true,
	 *
	 *   // DEPRECATED: Overrides native regex methods with fixed/extended versions
	 *   natives: true
	 * });
	 *
	 * // With an options string
	 * XRegExp.install('astral natives');
	 */
	XRegExp.install = function(options) {
	    options = prepareOptions(options);

	    if (!features.astral && options.astral) {
	        setAstral(true);
	    }

	    if (!features.natives && options.natives) {
	        setNatives(true);
	    }
	};

	/**
	 * Checks whether an individual optional feature is installed.
	 *
	 * @memberOf XRegExp
	 * @param {String} feature Name of the feature to check. One of:
	 *   - `astral`
	 *   - `natives`
	 * @returns {Boolean} Whether the feature is installed.
	 * @example
	 *
	 * XRegExp.isInstalled('astral');
	 */
	XRegExp.isInstalled = function(feature) {
	    return !!(features[feature]);
	};

	/**
	 * Returns `true` if an object is a regex; `false` if it isn't. This works correctly for regexes
	 * created in another frame, when `instanceof` and `constructor` checks would fail.
	 *
	 * @memberOf XRegExp
	 * @param {*} value Object to check.
	 * @returns {Boolean} Whether the object is a `RegExp` object.
	 * @example
	 *
	 * XRegExp.isRegExp('string'); // -> false
	 * XRegExp.isRegExp(/regex/i); // -> true
	 * XRegExp.isRegExp(RegExp('^', 'm')); // -> true
	 * XRegExp.isRegExp(XRegExp('(?s).')); // -> true
	 */
	XRegExp.isRegExp = function(value) {
	    return toString.call(value) === '[object RegExp]';
	    //return isType(value, 'RegExp');
	};

	/**
	 * Returns the first matched string, or in global mode, an array containing all matched strings.
	 * This is essentially a more convenient re-implementation of `String.prototype.match` that gives
	 * the result types you actually want (string instead of `exec`-style array in match-first mode,
	 * and an empty array instead of `null` when no matches are found in match-all mode). It also lets
	 * you override flag g and ignore `lastIndex`, and fixes browser bugs.
	 *
	 * @memberOf XRegExp
	 * @param {String} str String to search.
	 * @param {RegExp} regex Regex to search with.
	 * @param {String} [scope='one'] Use 'one' to return the first match as a string. Use 'all' to
	 *   return an array of all matched strings. If not explicitly specified and `regex` uses flag g,
	 *   `scope` is 'all'.
	 * @returns {String|Array} In match-first mode: First match as a string, or `null`. In match-all
	 *   mode: Array of all matched strings, or an empty array.
	 * @example
	 *
	 * // Match first
	 * XRegExp.match('abc', /\w/); // -> 'a'
	 * XRegExp.match('abc', /\w/g, 'one'); // -> 'a'
	 * XRegExp.match('abc', /x/g, 'one'); // -> null
	 *
	 * // Match all
	 * XRegExp.match('abc', /\w/g); // -> ['a', 'b', 'c']
	 * XRegExp.match('abc', /\w/, 'all'); // -> ['a', 'b', 'c']
	 * XRegExp.match('abc', /x/, 'all'); // -> []
	 */
	XRegExp.match = function(str, regex, scope) {
	    var global = (regex.global && scope !== 'one') || scope === 'all';
	    var cacheKey = ((global ? 'g' : '') + (regex.sticky ? 'y' : '')) || 'noGY';
	    var result;
	    var r2;

	    regex[REGEX_DATA] = regex[REGEX_DATA] || {};

	    // Shares cached copies with `XRegExp.exec`/`replace`
	    r2 = regex[REGEX_DATA][cacheKey] || (
	        regex[REGEX_DATA][cacheKey] = copyRegex(regex, {
	            addG: !!global,
	            removeG: scope === 'one',
	            isInternalOnly: true
	        })
	    );

	    result = nativ.match.call(toObject(str), r2);

	    if (regex.global) {
	        regex.lastIndex = (
	            (scope === 'one' && result) ?
	                // Can't use `r2.lastIndex` since `r2` is nonglobal in this case
	                (result.index + result[0].length) : 0
	        );
	    }

	    return global ? (result || []) : (result && result[0]);
	};

	/**
	 * Retrieves the matches from searching a string using a chain of regexes that successively search
	 * within previous matches. The provided `chain` array can contain regexes and or objects with
	 * `regex` and `backref` properties. When a backreference is specified, the named or numbered
	 * backreference is passed forward to the next regex or returned.
	 *
	 * @memberOf XRegExp
	 * @param {String} str String to search.
	 * @param {Array} chain Regexes that each search for matches within preceding results.
	 * @returns {Array} Matches by the last regex in the chain, or an empty array.
	 * @example
	 *
	 * // Basic usage; matches numbers within <b> tags
	 * XRegExp.matchChain('1 <b>2</b> 3 <b>4 a 56</b>', [
	 *   XRegExp('(?is)<b>.*?</b>'),
	 *   /\d+/
	 * ]);
	 * // -> ['2', '4', '56']
	 *
	 * // Passing forward and returning specific backreferences
	 * html = '<a href="http://xregexp.com/api/">XRegExp</a>\
	 *         <a href="http://www.google.com/">Google</a>';
	 * XRegExp.matchChain(html, [
	 *   {regex: /<a href="([^"]+)">/i, backref: 1},
	 *   {regex: XRegExp('(?i)^https?://(?<domain>[^/?#]+)'), backref: 'domain'}
	 * ]);
	 * // -> ['xregexp.com', 'www.google.com']
	 */
	XRegExp.matchChain = function(str, chain) {
	    return (function recurseChain(values, level) {
	        var item = chain[level].regex ? chain[level] : {regex: chain[level]};
	        var matches = [];

	        function addMatch(match) {
	            if (item.backref) {
	                // Safari 4.0.5 (but not 5.0.5+) inappropriately uses sparse arrays to hold the
	                // `undefined`s for backreferences to nonparticipating capturing groups. In such
	                // cases, a `hasOwnProperty` or `in` check on its own would inappropriately throw
	                // the exception, so also check if the backreference is a number that is within the
	                // bounds of the array.
	                if (!(match.hasOwnProperty(item.backref) || +item.backref < match.length)) {
	                    throw new ReferenceError('Backreference to undefined group: ' + item.backref);
	                }

	                matches.push(match[item.backref] || '');
	            } else {
	                matches.push(match[0]);
	            }
	        }

	        for (var i = 0; i < values.length; ++i) {
	            XRegExp.forEach(values[i], item.regex, addMatch);
	        }

	        return ((level === chain.length - 1) || !matches.length) ?
	            matches :
	            recurseChain(matches, level + 1);
	    }([str], 0));
	};

	/**
	 * Returns a new string with one or all matches of a pattern replaced. The pattern can be a string
	 * or regex, and the replacement can be a string or a function to be called for each match. To
	 * perform a global search and replace, use the optional `scope` argument or include flag g if using
	 * a regex. Replacement strings can use `${n}` for named and numbered backreferences. Replacement
	 * functions can use named backreferences via `arguments[0].name`. Also fixes browser bugs compared
	 * to the native `String.prototype.replace` and can be used reliably cross-browser.
	 *
	 * @memberOf XRegExp
	 * @param {String} str String to search.
	 * @param {RegExp|String} search Search pattern to be replaced.
	 * @param {String|Function} replacement Replacement string or a function invoked to create it.
	 *   Replacement strings can include special replacement syntax:
	 *     - $$ - Inserts a literal $ character.
	 *     - $&, $0 - Inserts the matched substring.
	 *     - $` - Inserts the string that precedes the matched substring (left context).
	 *     - $' - Inserts the string that follows the matched substring (right context).
	 *     - $n, $nn - Where n/nn are digits referencing an existent capturing group, inserts
	 *       backreference n/nn.
	 *     - ${n} - Where n is a name or any number of digits that reference an existent capturing
	 *       group, inserts backreference n.
	 *   Replacement functions are invoked with three or more arguments:
	 *     - The matched substring (corresponds to $& above). Named backreferences are accessible as
	 *       properties of this first argument.
	 *     - 0..n arguments, one for each backreference (corresponding to $1, $2, etc. above).
	 *     - The zero-based index of the match within the total search string.
	 *     - The total string being searched.
	 * @param {String} [scope='one'] Use 'one' to replace the first match only, or 'all'. If not
	 *   explicitly specified and using a regex with flag g, `scope` is 'all'.
	 * @returns {String} New string with one or all matches replaced.
	 * @example
	 *
	 * // Regex search, using named backreferences in replacement string
	 * var name = XRegExp('(?<first>\\w+) (?<last>\\w+)');
	 * XRegExp.replace('John Smith', name, '${last}, ${first}');
	 * // -> 'Smith, John'
	 *
	 * // Regex search, using named backreferences in replacement function
	 * XRegExp.replace('John Smith', name, function(match) {
	 *   return match.last + ', ' + match.first;
	 * });
	 * // -> 'Smith, John'
	 *
	 * // String search, with replace-all
	 * XRegExp.replace('RegExp builds RegExps', 'RegExp', 'XRegExp', 'all');
	 * // -> 'XRegExp builds XRegExps'
	 */
	XRegExp.replace = function(str, search, replacement, scope) {
	    var isRegex = XRegExp.isRegExp(search);
	    var global = (search.global && scope !== 'one') || scope === 'all';
	    var cacheKey = ((global ? 'g' : '') + (search.sticky ? 'y' : '')) || 'noGY';
	    var s2 = search;
	    var result;

	    if (isRegex) {
	        search[REGEX_DATA] = search[REGEX_DATA] || {};

	        // Shares cached copies with `XRegExp.exec`/`match`. Since a copy is used, `search`'s
	        // `lastIndex` isn't updated *during* replacement iterations
	        s2 = search[REGEX_DATA][cacheKey] || (
	            search[REGEX_DATA][cacheKey] = copyRegex(search, {
	                addG: !!global,
	                removeG: scope === 'one',
	                isInternalOnly: true
	            })
	        );
	    } else if (global) {
	        s2 = new RegExp(XRegExp.escape(String(search)), 'g');
	    }

	    // Fixed `replace` required for named backreferences, etc.
	    result = fixed.replace.call(toObject(str), s2, replacement);

	    if (isRegex && search.global) {
	        // Fixes IE, Safari bug (last tested IE 9, Safari 5.1)
	        search.lastIndex = 0;
	    }

	    return result;
	};

	/**
	 * Performs batch processing of string replacements. Used like `XRegExp.replace`, but accepts an
	 * array of replacement details. Later replacements operate on the output of earlier replacements.
	 * Replacement details are accepted as an array with a regex or string to search for, the
	 * replacement string or function, and an optional scope of 'one' or 'all'. Uses the XRegExp
	 * replacement text syntax, which supports named backreference properties via `${name}`.
	 *
	 * @memberOf XRegExp
	 * @param {String} str String to search.
	 * @param {Array} replacements Array of replacement detail arrays.
	 * @returns {String} New string with all replacements.
	 * @example
	 *
	 * str = XRegExp.replaceEach(str, [
	 *   [XRegExp('(?<name>a)'), 'z${name}'],
	 *   [/b/gi, 'y'],
	 *   [/c/g, 'x', 'one'], // scope 'one' overrides /g
	 *   [/d/, 'w', 'all'],  // scope 'all' overrides lack of /g
	 *   ['e', 'v', 'all'],  // scope 'all' allows replace-all for strings
	 *   [/f/g, function($0) {
	 *     return $0.toUpperCase();
	 *   }]
	 * ]);
	 */
	XRegExp.replaceEach = function(str, replacements) {
	    var i;
	    var r;

	    for (i = 0; i < replacements.length; ++i) {
	        r = replacements[i];
	        str = XRegExp.replace(str, r[0], r[1], r[2]);
	    }

	    return str;
	};

	/**
	 * Splits a string into an array of strings using a regex or string separator. Matches of the
	 * separator are not included in the result array. However, if `separator` is a regex that contains
	 * capturing groups, backreferences are spliced into the result each time `separator` is matched.
	 * Fixes browser bugs compared to the native `String.prototype.split` and can be used reliably
	 * cross-browser.
	 *
	 * @memberOf XRegExp
	 * @param {String} str String to split.
	 * @param {RegExp|String} separator Regex or string to use for separating the string.
	 * @param {Number} [limit] Maximum number of items to include in the result array.
	 * @returns {Array} Array of substrings.
	 * @example
	 *
	 * // Basic use
	 * XRegExp.split('a b c', ' ');
	 * // -> ['a', 'b', 'c']
	 *
	 * // With limit
	 * XRegExp.split('a b c', ' ', 2);
	 * // -> ['a', 'b']
	 *
	 * // Backreferences in result array
	 * XRegExp.split('..word1..', /([a-z]+)(\d+)/i);
	 * // -> ['..', 'word', '1', '..']
	 */
	XRegExp.split = function(str, separator, limit) {
	    return fixed.split.call(toObject(str), separator, limit);
	};

	/**
	 * Executes a regex search in a specified string. Returns `true` or `false`. Optional `pos` and
	 * `sticky` arguments specify the search start position, and whether the match must start at the
	 * specified position only. The `lastIndex` property of the provided regex is not used, but is
	 * updated for compatibility. Also fixes browser bugs compared to the native
	 * `RegExp.prototype.test` and can be used reliably cross-browser.
	 *
	 * @memberOf XRegExp
	 * @param {String} str String to search.
	 * @param {RegExp} regex Regex to search with.
	 * @param {Number} [pos=0] Zero-based index at which to start the search.
	 * @param {Boolean|String} [sticky=false] Whether the match must start at the specified position
	 *   only. The string `'sticky'` is accepted as an alternative to `true`.
	 * @returns {Boolean} Whether the regex matched the provided value.
	 * @example
	 *
	 * // Basic use
	 * XRegExp.test('abc', /c/); // -> true
	 *
	 * // With pos and sticky
	 * XRegExp.test('abc', /c/, 0, 'sticky'); // -> false
	 * XRegExp.test('abc', /c/, 2, 'sticky'); // -> true
	 */
	XRegExp.test = function(str, regex, pos, sticky) {
	    // Do this the easy way :-)
	    return !!XRegExp.exec(str, regex, pos, sticky);
	};

	/**
	 * Uninstalls optional features according to the specified options. All optional features start out
	 * uninstalled, so this is used to undo the actions of `XRegExp.install`.
	 *
	 * @memberOf XRegExp
	 * @param {Object|String} options Options object or string.
	 * @example
	 *
	 * // With an options object
	 * XRegExp.uninstall({
	 *   // Disables support for astral code points in Unicode addons
	 *   astral: true,
	 *
	 *   // DEPRECATED: Restores native regex methods
	 *   natives: true
	 * });
	 *
	 * // With an options string
	 * XRegExp.uninstall('astral natives');
	 */
	XRegExp.uninstall = function(options) {
	    options = prepareOptions(options);

	    if (features.astral && options.astral) {
	        setAstral(false);
	    }

	    if (features.natives && options.natives) {
	        setNatives(false);
	    }
	};

	/**
	 * Returns an XRegExp object that is the union of the given patterns. Patterns can be provided as
	 * regex objects or strings. Metacharacters are escaped in patterns provided as strings.
	 * Backreferences in provided regex objects are automatically renumbered to work correctly within
	 * the larger combined pattern. Native flags used by provided regexes are ignored in favor of the
	 * `flags` argument.
	 *
	 * @memberOf XRegExp
	 * @param {Array} patterns Regexes and strings to combine.
	 * @param {String} [flags] Any combination of XRegExp flags.
	 * @param {Object} [options] Options object with optional properties:
	 *   - `conjunction` {String} Type of conjunction to use: 'or' (default) or 'none'.
	 * @returns {RegExp} Union of the provided regexes and strings.
	 * @example
	 *
	 * XRegExp.union(['a+b*c', /(dogs)\1/, /(cats)\1/], 'i');
	 * // -> /a\+b\*c|(dogs)\1|(cats)\2/i
	 *
	 * XRegExp.union([/man/, /bear/, /pig/], 'i', {conjunction: 'none'});
	 * // -> /manbearpig/i
	 */
	XRegExp.union = function(patterns, flags, options) {
	    options = options || {};
	    var conjunction = options.conjunction || 'or';
	    var numCaptures = 0;
	    var numPriorCaptures;
	    var captureNames;

	    function rewrite(match, paren, backref) {
	        var name = captureNames[numCaptures - numPriorCaptures];

	        // Capturing group
	        if (paren) {
	            ++numCaptures;
	            // If the current capture has a name, preserve the name
	            if (name) {
	                return '(?<' + name + '>';
	            }
	        // Backreference
	        } else if (backref) {
	            // Rewrite the backreference
	            return '\\' + (+backref + numPriorCaptures);
	        }

	        return match;
	    }

	    if (!(isType(patterns, 'Array') && patterns.length)) {
	        throw new TypeError('Must provide a nonempty array of patterns to merge');
	    }

	    var parts = /(\()(?!\?)|\\([1-9]\d*)|\\[\s\S]|\[(?:[^\\\]]|\\[\s\S])*\]/g;
	    var output = [];
	    var pattern;
	    for (var i = 0; i < patterns.length; ++i) {
	        pattern = patterns[i];

	        if (XRegExp.isRegExp(pattern)) {
	            numPriorCaptures = numCaptures;
	            captureNames = (pattern[REGEX_DATA] && pattern[REGEX_DATA].captureNames) || [];

	            // Rewrite backreferences. Passing to XRegExp dies on octals and ensures patterns are
	            // independently valid; helps keep this simple. Named captures are put back
	            output.push(nativ.replace.call(XRegExp(pattern.source).source, parts, rewrite));
	        } else {
	            output.push(XRegExp.escape(pattern));
	        }
	    }

	    var separator = conjunction === 'none' ? '' : '|';
	    return XRegExp(output.join(separator), flags);
	};

	// ==--------------------------==
	// Fixed/extended native methods
	// ==--------------------------==

	/**
	 * Adds named capture support (with backreferences returned as `result.name`), and fixes browser
	 * bugs in the native `RegExp.prototype.exec`. Calling `XRegExp.install('natives')` uses this to
	 * override the native method. Use via `XRegExp.exec` without overriding natives.
	 *
	 * @memberOf RegExp
	 * @param {String} str String to search.
	 * @returns {Array} Match array with named backreference properties, or `null`.
	 */
	fixed.exec = function(str) {
	    var origLastIndex = this.lastIndex;
	    var match = nativ.exec.apply(this, arguments);
	    var name;
	    var r2;
	    var i;

	    if (match) {
	        // Fix browsers whose `exec` methods don't return `undefined` for nonparticipating capturing
	        // groups. This fixes IE 5.5-8, but not IE 9's quirks mode or emulation of older IEs. IE 9
	        // in standards mode follows the spec.
	        if (!correctExecNpcg && match.length > 1 && indexOf(match, '') > -1) {
	            r2 = copyRegex(this, {
	                removeG: true,
	                isInternalOnly: true
	            });
	            // Using `str.slice(match.index)` rather than `match[0]` in case lookahead allowed
	            // matching due to characters outside the match
	            nativ.replace.call(String(str).slice(match.index), r2, function() {
	                var len = arguments.length;
	                var i;
	                // Skip index 0 and the last 2
	                for (i = 1; i < len - 2; ++i) {
	                    if (arguments[i] === undefined) {
	                        match[i] = undefined;
	                    }
	                }
	            });
	        }

	        // Attach named capture properties
	        if (this[REGEX_DATA] && this[REGEX_DATA].captureNames) {
	            // Skip index 0
	            for (i = 1; i < match.length; ++i) {
	                name = this[REGEX_DATA].captureNames[i - 1];
	                if (name) {
	                    match[name] = match[i];
	                }
	            }
	        }

	        // Fix browsers that increment `lastIndex` after zero-length matches
	        if (this.global && !match[0].length && (this.lastIndex > match.index)) {
	            this.lastIndex = match.index;
	        }
	    }

	    if (!this.global) {
	        // Fixes IE, Opera bug (last tested IE 9, Opera 11.6)
	        this.lastIndex = origLastIndex;
	    }

	    return match;
	};

	/**
	 * Fixes browser bugs in the native `RegExp.prototype.test`. Calling `XRegExp.install('natives')`
	 * uses this to override the native method.
	 *
	 * @memberOf RegExp
	 * @param {String} str String to search.
	 * @returns {Boolean} Whether the regex matched the provided value.
	 */
	fixed.test = function(str) {
	    // Do this the easy way :-)
	    return !!fixed.exec.call(this, str);
	};

	/**
	 * Adds named capture support (with backreferences returned as `result.name`), and fixes browser
	 * bugs in the native `String.prototype.match`. Calling `XRegExp.install('natives')` uses this to
	 * override the native method.
	 *
	 * @memberOf String
	 * @param {RegExp|*} regex Regex to search with. If not a regex object, it is passed to `RegExp`.
	 * @returns {Array} If `regex` uses flag g, an array of match strings or `null`. Without flag g,
	 *   the result of calling `regex.exec(this)`.
	 */
	fixed.match = function(regex) {
	    var result;

	    if (!XRegExp.isRegExp(regex)) {
	        // Use the native `RegExp` rather than `XRegExp`
	        regex = new RegExp(regex);
	    } else if (regex.global) {
	        result = nativ.match.apply(this, arguments);
	        // Fixes IE bug
	        regex.lastIndex = 0;

	        return result;
	    }

	    return fixed.exec.call(regex, toObject(this));
	};

	/**
	 * Adds support for `${n}` tokens for named and numbered backreferences in replacement text, and
	 * provides named backreferences to replacement functions as `arguments[0].name`. Also fixes browser
	 * bugs in replacement text syntax when performing a replacement using a nonregex search value, and
	 * the value of a replacement regex's `lastIndex` property during replacement iterations and upon
	 * completion. Calling `XRegExp.install('natives')` uses this to override the native method. Note
	 * that this doesn't support SpiderMonkey's proprietary third (`flags`) argument. Use via
	 * `XRegExp.replace` without overriding natives.
	 *
	 * @memberOf String
	 * @param {RegExp|String} search Search pattern to be replaced.
	 * @param {String|Function} replacement Replacement string or a function invoked to create it.
	 * @returns {String} New string with one or all matches replaced.
	 */
	fixed.replace = function(search, replacement) {
	    var isRegex = XRegExp.isRegExp(search);
	    var origLastIndex;
	    var captureNames;
	    var result;

	    if (isRegex) {
	        if (search[REGEX_DATA]) {
	            captureNames = search[REGEX_DATA].captureNames;
	        }
	        // Only needed if `search` is nonglobal
	        origLastIndex = search.lastIndex;
	    } else {
	        search += ''; // Type-convert
	    }

	    // Don't use `typeof`; some older browsers return 'function' for regex objects
	    if (isType(replacement, 'Function')) {
	        // Stringifying `this` fixes a bug in IE < 9 where the last argument in replacement
	        // functions isn't type-converted to a string
	        result = nativ.replace.call(String(this), search, function() {
	            var args = arguments;
	            var i;
	            if (captureNames) {
	                // Change the `arguments[0]` string primitive to a `String` object that can store
	                // properties. This really does need to use `String` as a constructor
	                args[0] = new String(args[0]);
	                // Store named backreferences on the first argument
	                for (i = 0; i < captureNames.length; ++i) {
	                    if (captureNames[i]) {
	                        args[0][captureNames[i]] = args[i + 1];
	                    }
	                }
	            }
	            // Update `lastIndex` before calling `replacement`. Fixes IE, Chrome, Firefox, Safari
	            // bug (last tested IE 9, Chrome 17, Firefox 11, Safari 5.1)
	            if (isRegex && search.global) {
	                search.lastIndex = args[args.length - 2] + args[0].length;
	            }
	            // ES6 specs the context for replacement functions as `undefined`
	            return replacement.apply(undefined, args);
	        });
	    } else {
	        // Ensure that the last value of `args` will be a string when given nonstring `this`,
	        // while still throwing on null or undefined context
	        result = nativ.replace.call(this == null ? this : String(this), search, function() {
	            // Keep this function's `arguments` available through closure
	            var args = arguments;
	            return nativ.replace.call(String(replacement), replacementToken, function($0, $1, $2) {
	                var n;
	                // Named or numbered backreference with curly braces
	                if ($1) {
	                    // XRegExp behavior for `${n}`:
	                    // 1. Backreference to numbered capture, if `n` is an integer. Use `0` for the
	                    //    entire match. Any number of leading zeros may be used.
	                    // 2. Backreference to named capture `n`, if it exists and is not an integer
	                    //    overridden by numbered capture. In practice, this does not overlap with
	                    //    numbered capture since XRegExp does not allow named capture to use a bare
	                    //    integer as the name.
	                    // 3. If the name or number does not refer to an existing capturing group, it's
	                    //    an error.
	                    n = +$1; // Type-convert; drop leading zeros
	                    if (n <= args.length - 3) {
	                        return args[n] || '';
	                    }
	                    // Groups with the same name is an error, else would need `lastIndexOf`
	                    n = captureNames ? indexOf(captureNames, $1) : -1;
	                    if (n < 0) {
	                        throw new SyntaxError('Backreference to undefined group ' + $0);
	                    }
	                    return args[n + 1] || '';
	                }
	                // Else, special variable or numbered backreference without curly braces
	                if ($2 === '$') { // $$
	                    return '$';
	                }
	                if ($2 === '&' || +$2 === 0) { // $&, $0 (not followed by 1-9), $00
	                    return args[0];
	                }
	                if ($2 === '`') { // $` (left context)
	                    return args[args.length - 1].slice(0, args[args.length - 2]);
	                }
	                if ($2 === "'") { // $' (right context)
	                    return args[args.length - 1].slice(args[args.length - 2] + args[0].length);
	                }
	                // Else, numbered backreference without curly braces
	                $2 = +$2; // Type-convert; drop leading zero
	                // XRegExp behavior for `$n` and `$nn`:
	                // - Backrefs end after 1 or 2 digits. Use `${..}` for more digits.
	                // - `$1` is an error if no capturing groups.
	                // - `$10` is an error if less than 10 capturing groups. Use `${1}0` instead.
	                // - `$01` is `$1` if at least one capturing group, else it's an error.
	                // - `$0` (not followed by 1-9) and `$00` are the entire match.
	                // Native behavior, for comparison:
	                // - Backrefs end after 1 or 2 digits. Cannot reference capturing group 100+.
	                // - `$1` is a literal `$1` if no capturing groups.
	                // - `$10` is `$1` followed by a literal `0` if less than 10 capturing groups.
	                // - `$01` is `$1` if at least one capturing group, else it's a literal `$01`.
	                // - `$0` is a literal `$0`.
	                if (!isNaN($2)) {
	                    if ($2 > args.length - 3) {
	                        throw new SyntaxError('Backreference to undefined group ' + $0);
	                    }
	                    return args[$2] || '';
	                }
	                // `$` followed by an unsupported char is an error, unlike native JS
	                throw new SyntaxError('Invalid token ' + $0);
	            });
	        });
	    }

	    if (isRegex) {
	        if (search.global) {
	            // Fixes IE, Safari bug (last tested IE 9, Safari 5.1)
	            search.lastIndex = 0;
	        } else {
	            // Fixes IE, Opera bug (last tested IE 9, Opera 11.6)
	            search.lastIndex = origLastIndex;
	        }
	    }

	    return result;
	};

	/**
	 * Fixes browser bugs in the native `String.prototype.split`. Calling `XRegExp.install('natives')`
	 * uses this to override the native method. Use via `XRegExp.split` without overriding natives.
	 *
	 * @memberOf String
	 * @param {RegExp|String} separator Regex or string to use for separating the string.
	 * @param {Number} [limit] Maximum number of items to include in the result array.
	 * @returns {Array} Array of substrings.
	 */
	fixed.split = function(separator, limit) {
	    if (!XRegExp.isRegExp(separator)) {
	        // Browsers handle nonregex split correctly, so use the faster native method
	        return nativ.split.apply(this, arguments);
	    }

	    var str = String(this);
	    var output = [];
	    var origLastIndex = separator.lastIndex;
	    var lastLastIndex = 0;
	    var lastLength;

	    // Values for `limit`, per the spec:
	    // If undefined: pow(2,32) - 1
	    // If 0, Infinity, or NaN: 0
	    // If positive number: limit = floor(limit); if (limit >= pow(2,32)) limit -= pow(2,32);
	    // If negative number: pow(2,32) - floor(abs(limit))
	    // If other: Type-convert, then use the above rules
	    // This line fails in very strange ways for some values of `limit` in Opera 10.5-10.63, unless
	    // Opera Dragonfly is open (go figure). It works in at least Opera 9.5-10.1 and 11+
	    limit = (limit === undefined ? -1 : limit) >>> 0;

	    XRegExp.forEach(str, separator, function(match) {
	        // This condition is not the same as `if (match[0].length)`
	        if ((match.index + match[0].length) > lastLastIndex) {
	            output.push(str.slice(lastLastIndex, match.index));
	            if (match.length > 1 && match.index < str.length) {
	                Array.prototype.push.apply(output, match.slice(1));
	            }
	            lastLength = match[0].length;
	            lastLastIndex = match.index + lastLength;
	        }
	    });

	    if (lastLastIndex === str.length) {
	        if (!nativ.test.call(separator, '') || lastLength) {
	            output.push('');
	        }
	    } else {
	        output.push(str.slice(lastLastIndex));
	    }

	    separator.lastIndex = origLastIndex;
	    return output.length > limit ? output.slice(0, limit) : output;
	};

	// ==--------------------------==
	// Built-in syntax/flag tokens
	// ==--------------------------==

	/*
	 * Letter escapes that natively match literal characters: `\a`, `\A`, etc. These should be
	 * SyntaxErrors but are allowed in web reality. XRegExp makes them errors for cross-browser
	 * consistency and to reserve their syntax, but lets them be superseded by addons.
	 */
	XRegExp.addToken(
	    /\\([ABCE-RTUVXYZaeg-mopqyz]|c(?![A-Za-z])|u(?![\dA-Fa-f]{4}|{[\dA-Fa-f]+})|x(?![\dA-Fa-f]{2}))/,
	    function(match, scope) {
	        // \B is allowed in default scope only
	        if (match[1] === 'B' && scope === defaultScope) {
	            return match[0];
	        }
	        throw new SyntaxError('Invalid escape ' + match[0]);
	    },
	    {
	        scope: 'all',
	        leadChar: '\\'
	    }
	);

	/*
	 * Unicode code point escape with curly braces: `\u{N..}`. `N..` is any one or more digit
	 * hexadecimal number from 0-10FFFF, and can include leading zeros. Requires the native ES6 `u` flag
	 * to support code points greater than U+FFFF. Avoids converting code points above U+FFFF to
	 * surrogate pairs (which could be done without flag `u`), since that could lead to broken behavior
	 * if you follow a `\u{N..}` token that references a code point above U+FFFF with a quantifier, or
	 * if you use the same in a character class.
	 */
	XRegExp.addToken(
	    /\\u{([\dA-Fa-f]+)}/,
	    function(match, scope, flags) {
	        var code = dec(match[1]);
	        if (code > 0x10FFFF) {
	            throw new SyntaxError('Invalid Unicode code point ' + match[0]);
	        }
	        if (code <= 0xFFFF) {
	            // Converting to \uNNNN avoids needing to escape the literal character and keep it
	            // separate from preceding tokens
	            return '\\u' + pad4(hex(code));
	        }
	        // If `code` is between 0xFFFF and 0x10FFFF, require and defer to native handling
	        if (hasNativeU && flags.indexOf('u') > -1) {
	            return match[0];
	        }
	        throw new SyntaxError('Cannot use Unicode code point above \\u{FFFF} without flag u');
	    },
	    {
	        scope: 'all',
	        leadChar: '\\'
	    }
	);

	/*
	 * Empty character class: `[]` or `[^]`. This fixes a critical cross-browser syntax inconsistency.
	 * Unless this is standardized (per the ES spec), regex syntax can't be accurately parsed because
	 * character class endings can't be determined.
	 */
	XRegExp.addToken(
	    /\[(\^?)\]/,
	    function(match) {
	        // For cross-browser compatibility with ES3, convert [] to \b\B and [^] to [\s\S].
	        // (?!) should work like \b\B, but is unreliable in some versions of Firefox
	        return match[1] ? '[\\s\\S]' : '\\b\\B';
	    },
	    {leadChar: '['}
	);

	/*
	 * Comment pattern: `(?# )`. Inline comments are an alternative to the line comments allowed in
	 * free-spacing mode (flag x).
	 */
	XRegExp.addToken(
	    /\(\?#[^)]*\)/,
	    getContextualTokenSeparator,
	    {leadChar: '('}
	);

	/*
	 * Whitespace and line comments, in free-spacing mode (aka extended mode, flag x) only.
	 */
	XRegExp.addToken(
	    /\s+|#[^\n]*\n?/,
	    getContextualTokenSeparator,
	    {flag: 'x'}
	);

	/*
	 * Dot, in dotall mode (aka singleline mode, flag s) only.
	 */
	XRegExp.addToken(
	    /\./,
	    function() {
	        return '[\\s\\S]';
	    },
	    {
	        flag: 's',
	        leadChar: '.'
	    }
	);

	/*
	 * Named backreference: `\k<name>`. Backreference names can use the characters A-Z, a-z, 0-9, _,
	 * and $ only. Also allows numbered backreferences as `\k<n>`.
	 */
	XRegExp.addToken(
	    /\\k<([\w$]+)>/,
	    function(match) {
	        // Groups with the same name is an error, else would need `lastIndexOf`
	        var index = isNaN(match[1]) ? (indexOf(this.captureNames, match[1]) + 1) : +match[1];
	        var endIndex = match.index + match[0].length;
	        if (!index || index > this.captureNames.length) {
	            throw new SyntaxError('Backreference to undefined group ' + match[0]);
	        }
	        // Keep backreferences separate from subsequent literal numbers. This avoids e.g.
	        // inadvertedly changing `(?<n>)\k<n>1` to `()\11`.
	        return '\\' + index + (
	            endIndex === match.input.length || isNaN(match.input.charAt(endIndex)) ?
	                '' : '(?:)'
	        );
	    },
	    {leadChar: '\\'}
	);

	/*
	 * Numbered backreference or octal, plus any following digits: `\0`, `\11`, etc. Octals except `\0`
	 * not followed by 0-9 and backreferences to unopened capture groups throw an error. Other matches
	 * are returned unaltered. IE < 9 doesn't support backreferences above `\99` in regex syntax.
	 */
	XRegExp.addToken(
	    /\\(\d+)/,
	    function(match, scope) {
	        if (
	            !(
	                scope === defaultScope &&
	                /^[1-9]/.test(match[1]) &&
	                +match[1] <= this.captureNames.length
	            ) &&
	            match[1] !== '0'
	        ) {
	            throw new SyntaxError('Cannot use octal escape or backreference to undefined group ' +
	                match[0]);
	        }
	        return match[0];
	    },
	    {
	        scope: 'all',
	        leadChar: '\\'
	    }
	);

	/*
	 * Named capturing group; match the opening delimiter only: `(?<name>`. Capture names can use the
	 * characters A-Z, a-z, 0-9, _, and $ only. Names can't be integers. Supports Python-style
	 * `(?P<name>` as an alternate syntax to avoid issues in some older versions of Opera which natively
	 * supported the Python-style syntax. Otherwise, XRegExp might treat numbered backreferences to
	 * Python-style named capture as octals.
	 */
	XRegExp.addToken(
	    /\(\?P?<([\w$]+)>/,
	    function(match) {
	        // Disallow bare integers as names because named backreferences are added to match arrays
	        // and therefore numeric properties may lead to incorrect lookups
	        if (!isNaN(match[1])) {
	            throw new SyntaxError('Cannot use integer as capture name ' + match[0]);
	        }
	        if (match[1] === 'length' || match[1] === '__proto__') {
	            throw new SyntaxError('Cannot use reserved word as capture name ' + match[0]);
	        }
	        if (indexOf(this.captureNames, match[1]) > -1) {
	            throw new SyntaxError('Cannot use same name for multiple groups ' + match[0]);
	        }
	        this.captureNames.push(match[1]);
	        this.hasNamedCapture = true;
	        return '(';
	    },
	    {leadChar: '('}
	);

	/*
	 * Capturing group; match the opening parenthesis only. Required for support of named capturing
	 * groups. Also adds explicit capture mode (flag n).
	 */
	XRegExp.addToken(
	    /\((?!\?)/,
	    function(match, scope, flags) {
	        if (flags.indexOf('n') > -1) {
	            return '(?:';
	        }
	        this.captureNames.push(null);
	        return '(';
	    },
	    {
	        optionalFlags: 'n',
	        leadChar: '('
	    }
	);

	xregexp = XRegExp;
	return xregexp;
}

(function (exports) {

	(function(){
	  var root;
	  root = this;
	  var XRegExp;

	  if (typeof commonjsRequire !== "undefined"){
	     XRegExp = requireXregexp();
	  }
	  else
	    XRegExp = root.XRegExp;

	  var parser = {};
	  var Addr_Match = {};

	  var Directional = {
	    north       : "N",
	    northeast   : "NE",
	    east        : "E",
	    southeast   : "SE",
	    south       : "S",
	    southwest   : "SW",
	    west        : "W",
	    northwest   : "NW",
	  };

	  var Street_Type = {
	    allee       : "aly",
	    alley       : "aly",
	    ally        : "aly",
	    anex        : "anx",
	    annex       : "anx",
	    annx        : "anx",
	    arcade      : "arc",
	    av          : "ave",
	    aven        : "ave",
	    avenu       : "ave",
	    avenue      : "ave",
	    avn         : "ave",
	    avnue       : "ave",
	    bayoo       : "byu",
	    bayou       : "byu",
	    beach       : "bch",
	    bend        : "bnd",
	    bluf        : "blf",
	    bluff       : "blf",
	    bluffs      : "blfs",
	    bot         : "btm",
	    bottm       : "btm",
	    bottom      : "btm",
	    boul        : "blvd",
	    boulevard   : "blvd",
	    boulv       : "blvd",
	    branch      : "br",
	    brdge       : "brg",
	    bridge      : "brg",
	    brnch       : "br",
	    brook       : "brk",
	    brooks      : "brks",
	    burg        : "bg",
	    burgs       : "bgs",
	    bypa        : "byp",
	    bypas       : "byp",
	    bypass      : "byp",
	    byps        : "byp",
	    camp        : "cp",
	    canyn       : "cyn",
	    canyon      : "cyn",
	    cape        : "cpe",
	    causeway    : "cswy",
	    causway     : "cswy",
	    causwa      : "cswy",
	    cen         : "ctr",
	    cent        : "ctr",
	    center      : "ctr",
	    centers     : "ctrs",
	    centr       : "ctr",
	    centre      : "ctr",
	    circ        : "cir",
	    circl       : "cir",
	    circle      : "cir",
	    circles     : "cirs",
	    ck          : "crk",
	    cliff       : "clf",
	    cliffs      : "clfs",
	    club        : "clb",
	    cmp         : "cp",
	    cnter       : "ctr",
	    cntr        : "ctr",
	    cnyn        : "cyn",
	    common      : "cmn",
	    commons     : "cmns",
	    corner      : "cor",
	    corners     : "cors",
	    course      : "crse",
	    court       : "ct",
	    courts      : "cts",
	    cove        : "cv",
	    coves       : "cvs",
	    cr          : "crk",
	    crcl        : "cir",
	    crcle       : "cir",
	    crecent     : "cres",
	    creek       : "crk",
	    crescent    : "cres",
	    cresent     : "cres",
	    crest       : "crst",
	    crossing    : "xing",
	    crossroad   : "xrd",
	    crossroads  : "xrds",
	    crscnt      : "cres",
	    crsent      : "cres",
	    crsnt       : "cres",
	    crssing     : "xing",
	    crssng      : "xing",
	    crt         : "ct",
	    curve       : "curv",
	    dale        : "dl",
	    dam         : "dm",
	    div         : "dv",
	    divide      : "dv",
	    driv        : "dr",
	    drive       : "dr",
	    drives      : "drs",
	    drv         : "dr",
	    dvd         : "dv",
	    estate      : "est",
	    estates     : "ests",
	    exp         : "expy",
	    expr        : "expy",
	    express     : "expy",
	    expressway  : "expy",
	    expw        : "expy",
	    extension   : "ext",
	    extensions  : "exts",
	    extn        : "ext",
	    extnsn      : "ext",
	    fall        : "fall",
	    falls       : "fls",
	    ferry       : "fry",
	    field       : "fld",
	    fields      : "flds",
	    flat        : "flt",
	    flats       : "flts",
	    ford        : "frd",
	    fords       : "frds",
	    forest      : "frst",
	    forests     : "frst",
	    forg        : "frg",
	    forge       : "frg",
	    forges      : "frgs",
	    fork        : "frk",
	    forks       : "frks",
	    fort        : "ft",
	    freeway     : "fwy",
	    freewy      : "fwy",
	    frry        : "fry",
	    frt         : "ft",
	    frway       : "fwy",
	    frwy        : "fwy",
	    garden      : "gdn",
	    gardens     : "gdns",
	    gardn       : "gdn",
	    gateway     : "gtwy",
	    gatewy      : "gtwy",
	    gatway      : "gtwy",
	    glen        : "gln",
	    glens       : "glns",
	    grden       : "gdn",
	    grdn        : "gdn",
	    grdns       : "gdns",
	    green       : "grn",
	    greens      : "grns",
	    grov        : "grv",
	    grove       : "grv",
	    groves      : "grvs",
	    gtway       : "gtwy",
	    harb        : "hbr",
	    harbor      : "hbr",
	    harbors     : "hbrs",
	    harbr       : "hbr",
	    haven       : "hvn",
	    havn        : "hvn",
	    height      : "hts",
	    heights     : "hts",
	    hgts        : "hts",
	    highway     : "hwy",
	    highwy      : "hwy",
	    hill        : "hl",
	    hills       : "hls",
	    hiway       : "hwy",
	    hiwy        : "hwy",
	    hllw        : "holw",
	    hollow      : "holw",
	    hollows     : "holw",
	    holws       : "holw",
	    hrbor       : "hbr",
	    ht          : "hts",
	    hway        : "hwy",
	    inlet       : "inlt",
	    island      : "is",
	    islands     : "iss",
	    isles       : "isle",
	    islnd       : "is",
	    islnds      : "iss",
	    jction      : "jct",
	    jctn        : "jct",
	    jctns       : "jcts",
	    junction    : "jct",
	    junctions   : "jcts",
	    junctn      : "jct",
	    juncton     : "jct",
	    key         : "ky",
	    keys        : "kys",
	    knol        : "knl",
	    knoll       : "knl",
	    knolls      : "knls",
	    la          : "ln",
	    lake        : "lk",
	    lakes       : "lks",
	    land        : "land",
	    landing     : "lndg",
	    lane        : "ln",
	    lanes       : "ln",
	    ldge        : "ldg",
	    light       : "lgt",
	    lights      : "lgts",
	    lndng       : "lndg",
	    loaf        : "lf",
	    lock        : "lck",
	    locks       : "lcks",
	    lodg        : "ldg",
	    lodge       : "ldg",
	    loops       : "loop",
	    mall        : "mall",
	    manor       : "mnr",
	    manors      : "mnrs",
	    meadow      : "mdw",
	    meadows     : "mdws",
	    medows      : "mdws",
	    mews        : "mews",
	    mill        : "ml",
	    mills       : "mls",
	    mission     : "msn",
	    missn       : "msn",
	    mnt         : "mt",
	    mntain      : "mtn",
	    mntn        : "mtn",
	    mntns       : "mtns",
	    motorway    : "mtwy",
	    mount       : "mt",
	    mountain    : "mtn",
	    mountains   : "mtns",
	    mountin     : "mtn",
	    mssn        : "msn",
	    mtin        : "mtn",
	    neck        : "nck",
	    orchard     : "orch",
	    orchrd      : "orch",
	    overpass    : "opas",
	    ovl         : "oval",
	    parks       : "park",
	    parkway     : "pkwy",
	    parkways    : "pkwy",
	    parkwy      : "pkwy",
	    pass        : "pass",
	    passage     : "psge",
	    paths       : "path",
	    pikes       : "pike",
	    pine        : "pne",
	    pines       : "pnes",
	    pk          : "park",
	    pkway       : "pkwy",
	    pkwys       : "pkwy",
	    pky         : "pkwy",
	    place       : "pl",
	    plain       : "pln",
	    plaines     : "plns",
	    plains      : "plns",
	    plaza       : "plz",
	    plza        : "plz",
	    point       : "pt",
	    points      : "pts",
	    port        : "prt",
	    ports       : "prts",
	    prairie     : "pr",
	    prarie      : "pr",
	    prk         : "park",
	    prr         : "pr",
	    rad         : "radl",
	    radial      : "radl",
	    radiel      : "radl",
	    ranch       : "rnch",
	    ranches     : "rnch",
	    rapid       : "rpd",
	    rapids      : "rpds",
	    rdge        : "rdg",
	    rest        : "rst",
	    ridge       : "rdg",
	    ridges      : "rdgs",
	    river       : "riv",
	    rivr        : "riv",
	    rnchs       : "rnch",
	    road        : "rd",
	    roads       : "rds",
	    route       : "rte",
	    rvr         : "riv",
	    row         : "row",
	    rue         : "rue",
	    run         : "run",
	    shoal       : "shl",
	    shoals      : "shls",
	    shoar       : "shr",
	    shoars      : "shrs",
	    shore       : "shr",
	    shores      : "shrs",
	    skyway      : "skwy",
	    spng        : "spg",
	    spngs       : "spgs",
	    spring      : "spg",
	    springs     : "spgs",
	    sprng       : "spg",
	    sprngs      : "spgs",
	    spurs       : "spur",
	    sqr         : "sq",
	    sqre        : "sq",
	    sqrs        : "sqs",
	    squ         : "sq",
	    square      : "sq",
	    squares     : "sqs",
	    station     : "sta",
	    statn       : "sta",
	    stn         : "sta",
	    str         : "st",
	    strav       : "stra",
	    strave      : "stra",
	    straven     : "stra",
	    stravenue   : "stra",
	    stravn      : "stra",
	    stream      : "strm",
	    street      : "st",
	    streets     : "sts",
	    streme      : "strm",
	    strt        : "st",
	    strvn       : "stra",
	    strvnue     : "stra",
	    sumit       : "smt",
	    sumitt      : "smt",
	    summit      : "smt",
	    terr        : "ter",
	    terrace     : "ter",
	    throughway  : "trwy",
	    tpk         : "tpke",
	    tr          : "trl",
	    trace       : "trce",
	    traces      : "trce",
	    track       : "trak",
	    tracks      : "trak",
	    trafficway  : "trfy",
	    trail       : "trl",
	    trails      : "trl",
	    trk         : "trak",
	    trks        : "trak",
	    trls        : "trl",
	    trnpk       : "tpke",
	    trpk        : "tpke",
	    tunel       : "tunl",
	    tunls       : "tunl",
	    tunnel      : "tunl",
	    tunnels     : "tunl",
	    tunnl       : "tunl",
	    turnpike    : "tpke",
	    turnpk      : "tpke",
	    underpass   : "upas",
	    union       : "un",
	    unions      : "uns",
	    valley      : "vly",
	    valleys     : "vlys",
	    vally       : "vly",
	    vdct        : "via",
	    viadct      : "via",
	    viaduct     : "via",
	    view        : "vw",
	    views       : "vws",
	    vill        : "vlg",
	    villag      : "vlg",
	    village     : "vlg",
	    villages    : "vlgs",
	    ville       : "vl",
	    villg       : "vlg",
	    villiage    : "vlg",
	    vist        : "vis",
	    vista       : "vis",
	    vlly        : "vly",
	    vst         : "vis",
	    vsta        : "vis",
	    wall        : "wall",
	    walks       : "walk",
	    well        : "wl",
	    wells       : "wls",
	    wy          : "way",
	  };

	  var State_Code = {
	    "alabama" : "AL",
	    "alaska" : "AK",
	    "american samoa" : "AS",
	    "arizona" : "AZ",
	    "arkansas" : "AR",
	    "california" : "CA",
	    "colorado" : "CO",
	    "connecticut" : "CT",
	    "delaware" : "DE",
	    "district of columbia" : "DC",
	    "federated states of micronesia" : "FM",
	    "florida" : "FL",
	    "georgia" : "GA",
	    "guam" : "GU",
	    "hawaii" : "HI",
	    "idaho" : "ID",
	    "illinois" : "IL",
	    "indiana" : "IN",
	    "iowa" : "IA",
	    "kansas" : "KS",
	    "kentucky" : "KY",
	    "louisiana" : "LA",
	    "maine" : "ME",
	    "marshall islands" : "MH",
	    "maryland" : "MD",
	    "massachusetts" : "MA",
	    "michigan" : "MI",
	    "minnesota" : "MN",
	    "mississippi" : "MS",
	    "missouri" : "MO",
	    "montana" : "MT",
	    "nebraska" : "NE",
	    "nevada" : "NV",
	    "new hampshire" : "NH",
	    "new jersey" : "NJ",
	    "new mexico" : "NM",
	    "new york" : "NY",
	    "north carolina" : "NC",
	    "north dakota" : "ND",
	    "northern mariana islands" : "MP",
	    "ohio" : "OH",
	    "oklahoma" : "OK",
	    "oregon" : "OR",
	    "palau" : "PW",
	    "pennsylvania" : "PA",
	    "puerto rico" : "PR",
	    "rhode island" : "RI",
	    "south carolina" : "SC",
	    "south dakota" : "SD",
	    "tennessee" : "TN",
	    "texas" : "TX",
	    "utah" : "UT",
	    "vermont" : "VT",
	    "virgin islands" : "VI",
	    "virginia" : "VA",
	    "washington" : "WA",
	    "west virginia" : "WV",
	    "wisconsin" : "WI",
	    "wyoming" : "WY",
	  };

	  var Direction_Code;
	  var initialized = false;

	  var Normalize_Map = {
	    prefix: Directional,
	    prefix1: Directional,
	    prefix2: Directional,
	    suffix: Directional,
	    suffix1: Directional,
	    suffix2: Directional,
	    type: Street_Type,
	    type1: Street_Type,
	    type2: Street_Type,
	    state: State_Code,
	  };

	  function capitalize(s){
	    return s && s[0].toUpperCase() + s.slice(1);
	  }
	  function keys(o){
	    return Object.keys(o);
	  }
	  function values(o){
	    var v = [];
	    keys(o).forEach(function(k){
	      v.push(o[k]);
	    });
	    return v;
	  }
	  function each(o,fn){
	    keys(o).forEach(function(k){
	      fn(o[k],k);
	    });
	  }
	  function invert(o){
	    var o1= {};
	    keys(o).forEach(function(k){
	      o1[o[k]] = k;
	    });
	    return o1;
	  }
	  function flatten(o){
	    return keys(o).concat(values(o));
	  }
	  function lazyInit(){
	    if (initialized) {
	      return;
	    }
	    initialized = true;

	    Direction_Code = invert(Directional);

	    /*
	    var Street_Type_Match = {};
	    each(Street_Type,function(v,k){ Street_Type_Match[v] = XRegExp.escape(v) });
	    each(Street_Type,function(v,k){ Street_Type_Match[v] = Street_Type_Match[v] + "|" + XRegExp.escape(k); });
	    each(Street_Type_Match,function(v,k){ Street_Type_Match[k] = new RegExp( '\\b(?:' +  Street_Type_Match[k]  + ')\\b', 'i') });
	    */

	    Addr_Match = {
	      type    : flatten(Street_Type).sort().filter(function(v,i,arr){return arr.indexOf(v)===i }).join('|'),
	      fraction : '\\d+\\/\\d+',
	      state   : '\\b(?:' + keys(State_Code).concat(values(State_Code)).map(XRegExp.escape).join('|') + ')\\b',
	      direct  : values(Directional).sort(function(a,b){return a.length < b.length}).reduce(function(prev,curr){return prev.concat([XRegExp.escape(curr.replace(/\w/g,'$&.')),curr])},keys(Directional)).join('|'),
	      dircode : keys(Direction_Code).join("|"),
	      zip     : '(?<zip>\\d{5})[- ]?(?<plus4>\\d{4})?',
	      corner  : '(?:\\band\\b|\\bat\\b|&|\\@)',
	    };

	    Addr_Match.number = '(?<number>(\\d+-?\\d*)|([N|S|E|W]\\d{1,3}[N|S|E|W]\\d{1,6}))(?=\\D)';

	    Addr_Match.street = '                                       \n\
	      (?:                                                       \n\
	        (?:(?<street_0>'+Addr_Match.direct+')\\W+               \n\
	           (?<type_0>'+Addr_Match.type+')\\b                    \n\
	        )                                                       \n\
	        |                                                       \n\
	        (?:(?<prefix_0>'+Addr_Match.direct+')\\W+)?             \n\
	        (?:                                                     \n\
	          (?<street_1>[^,]*\\d)                                 \n\
	          (?:[^\\w,]*(?<suffix_1>'+Addr_Match.direct+')\\b)     \n\
	          |                                                     \n\
	          (?<street_2>[^,]+)                                    \n\
	          (?:[^\\w,]+(?<type_2>'+Addr_Match.type+')\\b)         \n\
	          (?:[^\\w,]+(?<suffix_2>'+Addr_Match.direct+')\\b)?    \n\
	          |                                                     \n\
	          (?<street_3>[^,]+?)                                   \n\
	          (?:[^\\w,]+(?<type_3>'+Addr_Match.type+')\\b)?        \n\
	          (?:[^\\w,]+(?<suffix_3>'+Addr_Match.direct+')\\b)?    \n\
	        )                                                       \n\
	      )';

	    Addr_Match.po_box = 'p\\W*(?:[om]|ost\\ ?office)\\W*b(?:ox)?';

	    Addr_Match.sec_unit_type_numbered = '             \n\
	      (?<sec_unit_type_1>su?i?te                      \n\
	        |'+Addr_Match.po_box+'                        \n\
	        |(?:ap|dep)(?:ar)?t(?:me?nt)?                 \n\
	        |ro*m                                         \n\
	        |flo*r?                                       \n\
	        |uni?t                                        \n\
	        |bu?i?ldi?n?g                                 \n\
	        |ha?nga?r                                     \n\
	        |lo?t                                         \n\
	        |pier                                         \n\
	        |slip                                         \n\
	        |spa?ce?                                      \n\
	        |stop                                         \n\
	        |tra?i?le?r                                   \n\
	        |box)(?![a-z]                                 \n\
	      )                                               \n\
	      ';

	    Addr_Match.sec_unit_type_unnumbered = '           \n\
	      (?<sec_unit_type_2>ba?se?me?n?t                 \n\
	        |fro?nt                                       \n\
	        |lo?bby                                       \n\
	        |lowe?r                                       \n\
	        |off?i?ce?                                    \n\
	        |pe?n?t?ho?u?s?e?                             \n\
	        |rear                                         \n\
	        |side                                         \n\
	        |uppe?r                                       \n\
	      )\\b';

	    Addr_Match.sec_unit = '                               \n\
	      (?:                               #fix3             \n\
	        (?:                             #fix1             \n\
	          (?:                                             \n\
	            (?:'+Addr_Match.sec_unit_type_numbered+'\\W*) \n\
	            |(?<sec_unit_type_3>\\#)\\W*                  \n\
	          )                                               \n\
	          (?<sec_unit_num_1>[\\w-]+)                      \n\
	        )                                                 \n\
	        |                                                 \n\
	        '+Addr_Match.sec_unit_type_unnumbered+'           \n\
	      )';

	    Addr_Match.city_and_state = '                       \n\
	      (?:                                               \n\
	        (?<city>[^\\d,]+?)\\W+                          \n\
	        (?<state>'+Addr_Match.state+')                  \n\
	      )                                                 \n\
	      ';

	    Addr_Match.place = '                                \n\
	      (?:'+Addr_Match.city_and_state+'\\W*)?            \n\
	      (?:'+Addr_Match.zip+')?                           \n\
	      ';

	    Addr_Match.address = XRegExp('                      \n\
	      ^                                                 \n\
	      [^\\w\\#]*                                        \n\
	      ('+Addr_Match.number+')\\W*                       \n\
	      (?:'+Addr_Match.fraction+'\\W*)?                  \n\
	         '+Addr_Match.street+'\\W+                      \n\
	      (?:'+Addr_Match.sec_unit+')?\\W*          #fix2   \n\
	         '+Addr_Match.place+'                           \n\
	      \\W*$','ix');

	    var sep = '(?:\\W+|$)'; // no support for \Z

	    Addr_Match.informal_address = XRegExp('                   \n\
	      ^                                                       \n\
	      \\s*                                                    \n\
	      (?:'+Addr_Match.sec_unit+sep+')?                        \n\
	      (?:'+Addr_Match.number+')?\\W*                          \n\
	      (?:'+Addr_Match.fraction+'\\W*)?                        \n\
	         '+Addr_Match.street+sep+'                            \n\
	      (?:'+Addr_Match.sec_unit.replace(/_\d/g,'$&1')+sep+')?  \n\
	      (?:'+Addr_Match.place+')?                               \n\
	      ','ix');

	    Addr_Match.po_address = XRegExp('                         \n\
	      ^                                                       \n\
	      \\s*                                                    \n\
	      (?:'+Addr_Match.sec_unit.replace(/_\d/g,'$&1')+sep+')?  \n\
	      (?:'+Addr_Match.place+')?                               \n\
	      ','ix');

	    Addr_Match.intersection = XRegExp('                     \n\
	      ^\\W*                                                 \n\
	      '+Addr_Match.street.replace(/_\d/g,'1$&')+'\\W*?      \n\
	      \\s+'+Addr_Match.corner+'\\s+                         \n\
	      '+Addr_Match.street.replace(/_\d/g,'2$&') + '\\W+     \n\
	      '+Addr_Match.place+'\\W*$','ix');
	  }
	  parser.normalize_address = function(parts){
	    lazyInit();
	    if(!parts)
	      return null;
	    var parsed = {};

	    Object.keys(parts).forEach(function(k){
	      if(['input','index'].indexOf(k) !== -1 || isFinite(k))
	        return;
	      var key = isFinite(k.split('_').pop())? k.split('_').slice(0,-1).join('_'): k ;
	      if(parts[k])
	        parsed[key] = parts[k].trim().replace(/^\s+|\s+$|[^\w\s\-#&]/g, '');
	    });
	    each(Normalize_Map, function(map,key) {
	      if(parsed[key] && map[parsed[key].toLowerCase()]) {
	        parsed[key] = map[parsed[key].toLowerCase()];
	      }
	    });

	    ['type', 'type1', 'type2'].forEach(function(key){
	      if(key in parsed)
	        parsed[key] = parsed[key].charAt(0).toUpperCase() + parsed[key].slice(1).toLowerCase();
	    });

	    if(parsed.city){
	      parsed.city = XRegExp.replace(parsed.city,
	        XRegExp('^(?<dircode>'+Addr_Match.dircode+')\\s+(?=\\S)','ix'),
	        function(match){
	          return capitalize(Direction_Code[match.dircode.toUpperCase()]) +' ';
	        });
	    }
	    return parsed;
	  };

	  parser.parseAddress = function(address){
	    lazyInit();
	    var parts = XRegExp.exec(address,Addr_Match.address);
	    return parser.normalize_address(parts);
	  };
	  parser.parseInformalAddress = function(address){
	    lazyInit();
	    var parts = XRegExp.exec(address,Addr_Match.informal_address);
	    return parser.normalize_address(parts);
	  }; 
	  parser.parsePoAddress = function(address){
	    lazyInit();
	    var parts = XRegExp.exec(address,Addr_Match.po_address);
	    return parser.normalize_address(parts);
	  };
	  parser.parseLocation = function(address){
	    lazyInit();
	    if (XRegExp(Addr_Match.corner,'xi').test(address)) {
	        return parser.parseIntersection(address);
	    }
	    if (XRegExp('^'+Addr_Match.po_box,'xi').test(address)){
	      return parser.parsePoAddress(address);
	    }
	    return parser.parseAddress(address)
	        || parser.parseInformalAddress(address);
	  };
	  parser.parseIntersection = function(address){
	    lazyInit();
	    var parts = XRegExp.exec(address,Addr_Match.intersection);
	    parts = parser.normalize_address(parts);
	    if(parts){
	        parts.type2 = parts.type2 || '';
	        parts.type1 = parts.type1 || '';
	        if (parts.type2 && !parts.type1 || (parts.type1 === parts.type2)) {
	            var type = parts.type2;
	            type = XRegExp.replace(type,/s\W*$/,'');
	            if (XRegExp('^'+Addr_Match.type+'$','ix').test(type)) {
	                parts.type1 = parts.type2 = type;
	            }
	        }
	    }

	    return parts;
	  };

	  // AMD / RequireJS
	  {
	    exports.parseIntersection = parser.parseIntersection;
	    exports.parseLocation = parser.parseLocation;
	    exports.parseInformalAddress = parser.parseInformalAddress;
	    exports.parseAddress = parser.parseAddress;
	  }

	}()); 
} (address));

var isSecUnitType = function (input) {
    return Object.values(SecondaryUnitTypes).includes(input);
};
var toTrellisSecUnitType = function (input) {
    return input && isSecUnitType(input) ? input : undefined;
};

var isStateCode = function (input) { return Object.values(StateCodes).includes(input); };
var toTrellisStateCode = function (input) {
    return input && isStateCode(input) ? input : undefined;
};

var isStreetTypes = function (input) { return Object.values(StreetTypes).includes(input); };
var toTrellisStreetTypes = function (input) {
    return input && isStreetTypes(input) ? input : undefined;
};

var toTrellisAddress = function (input) {
    if (input === void 0) { input = {}; }
    if (!input) {
        return undefined;
    }
    var address1 = input.address1, address2 = input.address2, rawCity = input.city, rawState = input.state, rawZip = input.zip;
    var rawBase = [address1, address2, rawCity, rawState].filter(Boolean).join(', ');
    var addressRaw = [rawBase, rawZip].filter(Boolean).join(' ');
    if (!addressRaw) {
        return undefined;
    }
    var _a = address.parseLocation(addressRaw) || {}, sec_unit_type = _a.sec_unit_type, parsedState = _a.state, type = _a.type, city = _a.city, zip = _a.zip, location = __rest(_a, ["sec_unit_type", "state", "type", "city", "zip"]);
    var secUnitType = toTrellisSecUnitType(sec_unit_type);
    var stateCode = toTrellisStateCode(parsedState || rawState);
    var streetType = toTrellisStreetTypes(type);
    var parsedCity = city || rawCity;
    var zipCode = zip || rawZip;
    var address$1 = __assign(__assign(__assign(__assign(__assign(__assign({}, location), (parsedCity && { city: parsedCity })), (secUnitType && { sec_unit_type: secUnitType })), (stateCode && { state: stateCode })), (streetType && { type: streetType })), (zipCode && { zip: zipCode }));
    return { address: address$1, addressRaw: addressRaw };
};

var isUsage = function (input) { return Object.values(UsageType).includes(input); };
var toTrellisUsage = function (input) { return (input && isUsage(input) ? input : null); };

var isDwellingType = function (input) { return Object.values(DwellingType).includes(input); };
var toTrellisDwellingType = function (input) {
    return input && isDwellingType(input) ? input : null;
};

var toTrellisProperty = function (_a) {
    var address = _a.address, architecturalStyle = _a.architecturalStyle, dwelling = _a.dwelling, estimatedReplacementCost = _a.estimatedReplacementCost, numberOfStories = _a.numberOfStories, purchaseDate = _a.purchaseDate, squareFeet = _a.squareFeet, usage = _a.usage, wallType = _a.wallType, yearBuilt = _a.yearBuilt;
    var addressContainer = toTrellisAddress(address);
    return {
        address: (addressContainer === null || addressContainer === void 0 ? void 0 : addressContainer.address) || null,
        addressRaw: (addressContainer === null || addressContainer === void 0 ? void 0 : addressContainer.addressRaw) || null,
        ageOfRoofInYears: null,
        architecturalStyle: architecturalStyle !== null && architecturalStyle !== void 0 ? architecturalStyle : null,
        composition: null,
        constructionType: null,
        distanceToFireDepartmentInMiles: null,
        distanceToFireHydrantInFeet: null,
        dwellingType: toTrellisDwellingType(dwelling),
        estimatedReplacementCost: estimatedReplacementCost !== null && estimatedReplacementCost !== void 0 ? estimatedReplacementCost : null,
        features: null,
        foundationType: null,
        garages: null,
        numberOfBathrooms: null,
        numberOfFireplaces: null,
        numberOfHouseholdMembers: null,
        numberOfKitchens: null,
        numberOfStories: numberOfStories !== null && numberOfStories !== void 0 ? numberOfStories : null,
        purchaseDate: purchaseDate !== null && purchaseDate !== void 0 ? purchaseDate : null,
        squareFeet: squareFeet !== null && squareFeet !== void 0 ? squareFeet : null,
        usage: toTrellisUsage(usage),
        wallType: wallType !== null && wallType !== void 0 ? wallType : null,
        yearBuilt: yearBuilt !== null && yearBuilt !== void 0 ? yearBuilt : null,
    };
};

var toTrellisName = function (_a) {
    var firstName = _a.firstName, lastName = _a.lastName, middleName = _a.middleName;
    return ({
        firstName: firstName,
        lastName: lastName,
        middleName: middleName || '',
    });
};

var toTrellisPolicyHolder = function (_a) {
    var name = _a.name, address = _a.address, email = _a.email, phoneNumber = _a.phoneNumber, dateOfBirth = _a.dateOfBirth;
    return (__assign({ name: name ? toTrellisName(name) : undefined, email: email, phoneNumber: phoneNumber, birthday: dateOfBirth !== null && dateOfBirth !== void 0 ? dateOfBirth : null, birthdayRange: dateOfBirth ? toBirthdayRange(dateOfBirth) : null }, toTrellisAddress(address)));
};

var toTrellisHouseholdMember = function (_a) {
    var dateOfBirth = _a.dateOfBirth, name = _a.name;
    return {
        name: name ? toTrellisName(name) : { firstName: '', lastName: '', middleName: '' },
        birthday: dateOfBirth !== null && dateOfBirth !== void 0 ? dateOfBirth : null,
        birthdayRange: dateOfBirth ? toBirthdayRange(dateOfBirth) : null,
        gender: null,
        occupation: null,
        relationship: null,
    };
};

var toTrellisHomeownersPolicy = function (_a, autoPolicyId) {
    var _b;
    var canceledDate = _a.canceledDate, currentIssuer = _a.currentIssuer, isActive = _a.isActive, issueDate = _a.issueDate, numberOfPayments = _a.numberOfPayments, policyHolder = _a.policyHolder, policyTermMonths = _a.policyTermMonths, premiumCents = _a.premiumCents, expectedPremiumCents = _a.expectedPremiumCents, renewalDate = _a.renewalDate, householdMembers = _a.householdMembers, property = _a.property;
    return (__assign(__assign({ active: isActive, canceledDate: canceledDate, dateRetrieved: null, discountTotalCents: undefined, discounts: undefined, id: autoPolicyId, issueDate: issueDate, issuer: (_b = toTrellisIssuer(currentIssuer)) !== null && _b !== void 0 ? _b : currentIssuer, numberOfPayments: numberOfPayments, paymentHistory: [], paymentScheduleMonths: undefined, policyHolder: policyHolder ? toTrellisPolicyHolder(policyHolder) : undefined, policyNumber: '', policyTermMonths: policyTermMonths ? toTrellisPolicyTermMonths(policyTermMonths) : undefined, policyType: PolicyTypes.HOMEOWNERS, premiumCents: premiumCents }, (expectedPremiumCents && { expectedPremiumCents: expectedPremiumCents })), { renewalDate: renewalDate, coverages: undefined, householdMembers: householdMembers === null || householdMembers === void 0 ? void 0 : householdMembers.map(toTrellisHouseholdMember), mortgages: [], property: property ? toTrellisProperty(property) : undefined }));
};

var SECTION_I_COVERAGES = new Set([
    PropertyPolicyCoverageTypes.DWELLING,
    PropertyPolicyCoverageTypes.PERSONAL_PROPERTY,
    PropertyPolicyCoverageTypes.OTHER_STRUCTURES,
    PropertyPolicyCoverageTypes.LOSS_OF_USE,
]);
var getSavvyHomeownersDeductibleNamesByCoverage = function (trellisHomeownersCoverage) {
    var deductibleNames = [];
    // All Other Perils, Hurricane, Windstorm, and Earthquake deductibles apply to SECTION I coverages defined in Trellis at https://gitlab.com/trellisconnect/apify-scraper/-/blob/master/src/policy/PolicyBuilder/PropertyCoverageCollectionBuilder.ts#L9
    if (SECTION_I_COVERAGES.has(trellisHomeownersCoverage.name)) {
        if (trellisHomeownersCoverage.hurricaneDeductibleCents) {
            deductibleNames.push(SavvyHomeownersDeductibleName.Hurricane);
        }
        if (trellisHomeownersCoverage.windstormDeductibleCents) {
            deductibleNames.push(SavvyHomeownersDeductibleName.WindAndHail);
        }
        if (trellisHomeownersCoverage.earthquakeDeductibleCents) {
            deductibleNames.push(SavvyHomeownersDeductibleName.Earthquake);
        }
        if (trellisHomeownersCoverage.deductibleCents) {
            deductibleNames.push(SavvyHomeownersDeductibleName.AllOtherPerils);
        }
    }
    if (trellisHomeownersCoverage.name === PropertyPolicyCoverageTypes.PERSONAL_PROPERTY_WATER_BACKUP &&
        trellisHomeownersCoverage.deductibleCents) {
        deductibleNames.push(SavvyHomeownersDeductibleName.WaterBackup);
    }
    return deductibleNames;
};
var toSavvyHomeownersDeductibles = function (trellisHomeownersCoverages) {
    var savvyHomeownersDeductibles = [];
    var dwellingCoverage = trellisHomeownersCoverages === null || trellisHomeownersCoverages === void 0 ? void 0 : trellisHomeownersCoverages.find(function (coverage) { return coverage.name === PropertyPolicyCoverageTypes.DWELLING; });
    var waterBackupCoverage = trellisHomeownersCoverages === null || trellisHomeownersCoverages === void 0 ? void 0 : trellisHomeownersCoverages.find(function (coverage) { return coverage.name === PropertyPolicyCoverageTypes.PERSONAL_PROPERTY_WATER_BACKUP; });
    if (dwellingCoverage === null || dwellingCoverage === void 0 ? void 0 : dwellingCoverage.hurricaneDeductibleCents) {
        savvyHomeownersDeductibles.push({
            name: SavvyHomeownersDeductibleName.Hurricane,
            deductibleCents: dwellingCoverage.hurricaneDeductibleCents,
        });
    }
    if (dwellingCoverage === null || dwellingCoverage === void 0 ? void 0 : dwellingCoverage.windstormDeductibleCents) {
        savvyHomeownersDeductibles.push({
            name: SavvyHomeownersDeductibleName.WindAndHail,
            deductibleCents: dwellingCoverage.windstormDeductibleCents,
        });
    }
    if (dwellingCoverage === null || dwellingCoverage === void 0 ? void 0 : dwellingCoverage.earthquakeDeductibleCents) {
        savvyHomeownersDeductibles.push({
            name: SavvyHomeownersDeductibleName.Earthquake,
            deductibleCents: dwellingCoverage.earthquakeDeductibleCents,
        });
    }
    if (dwellingCoverage === null || dwellingCoverage === void 0 ? void 0 : dwellingCoverage.deductibleCents) {
        savvyHomeownersDeductibles.push({
            name: SavvyHomeownersDeductibleName.AllOtherPerils,
            deductibleCents: dwellingCoverage.deductibleCents,
        });
    }
    if (waterBackupCoverage === null || waterBackupCoverage === void 0 ? void 0 : waterBackupCoverage.deductibleCents) {
        savvyHomeownersDeductibles.push({
            name: SavvyHomeownersDeductibleName.WaterBackup,
            deductibleCents: waterBackupCoverage.deductibleCents,
        });
    }
    return savvyHomeownersDeductibles;
};

var _a;
var savvyHomeownersCoverageNameEquivalenceFromTrellis = (_a = {},
    _a[PropertyPolicyCoverageTypes.DWELLING] = SavvyHomeownersCoverageName.Dwelling,
    _a[PropertyPolicyCoverageTypes.OTHER_STRUCTURES] = SavvyHomeownersCoverageName.OtherStructures,
    _a[PropertyPolicyCoverageTypes.DWELLING_REPLACEMENT_COST] = SavvyHomeownersCoverageName.ExtendedReplacementCost,
    _a[PropertyPolicyCoverageTypes.ROOF_SURFACE] = SavvyHomeownersCoverageName.ExtendedReplacementCostRoof,
    _a[PropertyPolicyCoverageTypes.PERSONAL_PROPERTY] = SavvyHomeownersCoverageName.PersonalProperty,
    _a[PropertyPolicyCoverageTypes.LOSS_OF_USE] = SavvyHomeownersCoverageName.AdditionalLivingExpense,
    _a[PropertyPolicyCoverageTypes.PERSONAL_LIABILITY] = SavvyHomeownersCoverageName.LegalLiability,
    _a[PropertyPolicyCoverageTypes.MEDICAL_PAYMENTS_TO_OTHERS] = SavvyHomeownersCoverageName.GuestMedicalLimit,
    _a[PropertyPolicyCoverageTypes.PERSONAL_PROPERTY_WATER_BACKUP] = SavvyHomeownersCoverageName.WaterBackup,
    _a[PropertyPolicyCoverageTypes.ORDINANCE_OR_LAW] = SavvyHomeownersCoverageName.BuildingCode,
    _a[PropertyPolicyCoverageTypes.LOSS_ASSESSMENT] = SavvyHomeownersCoverageName.LossAssessment,
    _a[PropertyPolicyCoverageTypes.DWELLING_EXTENDED_PREMISES] = SavvyHomeownersCoverageName.ExtendedPremises,
    _a[PropertyPolicyCoverageTypes.FIRE_DEPARTMENT_SERVICE_CHARGE] = SavvyHomeownersCoverageName.FireDepartmentCharges,
    _a[PropertyPolicyCoverageTypes.PERSONAL_PROPERTY_ELECTRONIC_APPARATUS] = SavvyHomeownersCoverageName.ElectronicDataRecovery,
    _a[PropertyPolicyCoverageTypes.DANGEROUS_OR_EXOTIC_ANIMAL_LIABILITY] = SavvyHomeownersCoverageName.PetBite,
    _a[PropertyPolicyCoverageTypes.PERSONAL_PROPERTY_CAMERAS] = SavvyHomeownersCoverageName.CameraProperty,
    _a[PropertyPolicyCoverageTypes.PERSONAL_PROPERTY_JEWELRY] = SavvyHomeownersCoverageName.Jewelry,
    _a[PropertyPolicyCoverageTypes.PERSONAL_PROPERTY_MUSICAL_INSTRUMENTS] = SavvyHomeownersCoverageName.MusicalInstruments,
    _a[PropertyPolicyCoverageTypes.DWELLING_MINE_SUBSIDENCE] = SavvyHomeownersCoverageName.MineSubsidenceCoverage,
    _a[PropertyPolicyCoverageTypes.PERSONAL_PROPERTY_SPORT_EQUIPMENT] = SavvyHomeownersCoverageName.SportsEquipment,
    _a[PropertyPolicyCoverageTypes.PERSONAL_PROPERTY_SILVERWARE_GOLDWARE_PEWTERWARE] = SavvyHomeownersCoverageName.SilverwareTheft,
    _a[PropertyPolicyCoverageTypes.PERSONAL_PROPERTY_TREES_SHRUBS_PLANTS] = SavvyHomeownersCoverageName.YardAndGarden,
    // Duplicates Coverages
    _a[PropertyPolicyCoverageTypes.PERSONAL_PROPERTY_JEWELRY_AND_FURS] = SavvyHomeownersCoverageName.Jewelry,
    _a);

var toSavvyHomeownersCoverages = function (trellisHomeownersCoverages) {
    var savvyHomeownersCoverages = [];
    if (isNil$1(trellisHomeownersCoverages)) {
        return [];
    }
    trellisHomeownersCoverages.map(function (trellisHomeownersCoverage) {
        var savvyHomeownersCoverageName = savvyHomeownersCoverageNameEquivalenceFromTrellis[trellisHomeownersCoverage.name];
        if (!savvyHomeownersCoverageName) {
            return;
        }
        var savvyHomeownersDeductibleNamesByCoverage = getSavvyHomeownersDeductibleNamesByCoverage(trellisHomeownersCoverage);
        savvyHomeownersCoverages.push(toSavvyHomeownersCoverage(trellisHomeownersCoverage, savvyHomeownersCoverageName, savvyHomeownersDeductibleNamesByCoverage));
    });
    return savvyHomeownersCoverages;
};
var toSavvyHomeownersCoverage = function (_a, savvyHomeownersCoverageName, savvyHomeownersDeductibleNamesByCoverage) {
    var perOccurrenceLimitCents = _a.perOccurrenceLimitCents, perPersonLimitCents = _a.perPersonLimitCents, maxMonthsLimit = _a.maxMonthsLimit, premiumCents = _a.premiumCents, isDeclined = _a.isDeclined;
    return (__assign({ name: savvyHomeownersCoverageName, perOccurrenceLimitCents: perOccurrenceLimitCents !== null && perOccurrenceLimitCents !== void 0 ? perOccurrenceLimitCents : undefined, perPersonLimitCents: perPersonLimitCents !== null && perPersonLimitCents !== void 0 ? perPersonLimitCents : undefined, maxMonthsLimit: maxMonthsLimit !== null && maxMonthsLimit !== void 0 ? maxMonthsLimit : undefined, premiumCents: premiumCents !== null && premiumCents !== void 0 ? premiumCents : undefined, isDeclined: isDeclined !== null && isDeclined !== void 0 ? isDeclined : undefined }, (savvyHomeownersDeductibleNamesByCoverage &&
        savvyHomeownersDeductibleNamesByCoverage.length > 0 && { deductibles: savvyHomeownersDeductibleNamesByCoverage })));
};

var toSavvyHouseholdMember = function (_a) {
    var birthday = _a.birthday, gender = _a.gender, name = _a.name, relationship = _a.relationship;
    return ({
        name: name,
        dateOfBirth: birthday !== null && birthday !== void 0 ? birthday : undefined,
        relationship: relationship ? relationship : undefined,
        gender: gender ? gender : undefined,
    });
};

var toSavvyBasicAddress = function (_a) {
    var number = _a.number, street = _a.street, type = _a.type, sec_unit_num = _a.sec_unit_num, sec_unit_type = _a.sec_unit_type, city = _a.city, state = _a.state, zip = _a.zip, plus4 = _a.plus4, prefix = _a.prefix;
    return ({
        city: city,
        state: state,
        zip: [zip, plus4].join('-'),
        address1: [number, prefix, street, type].join(' '),
        address2: [sec_unit_type, sec_unit_num].join(' '),
    });
};

var toSavvyProperty = function (_a) {
    var address = _a.address, architecturalStyle = _a.architecturalStyle, dwellingType = _a.dwellingType, estimatedReplacementCost = _a.estimatedReplacementCost, numberOfStories = _a.numberOfStories, purchaseDate = _a.purchaseDate, squareFeet = _a.squareFeet, usage = _a.usage, wallType = _a.wallType, yearBuilt = _a.yearBuilt;
    return ({
        address: isNil$1(address) ? undefined : toSavvyBasicAddress(address),
        architecturalStyle: architecturalStyle !== null && architecturalStyle !== void 0 ? architecturalStyle : undefined,
        dwelling: dwellingType !== null && dwellingType !== void 0 ? dwellingType : undefined,
        estimatedReplacementCost: estimatedReplacementCost !== null && estimatedReplacementCost !== void 0 ? estimatedReplacementCost : undefined,
        numberOfStories: numberOfStories !== null && numberOfStories !== void 0 ? numberOfStories : undefined,
        purchaseDate: purchaseDate !== null && purchaseDate !== void 0 ? purchaseDate : undefined,
        squareFeet: squareFeet !== null && squareFeet !== void 0 ? squareFeet : undefined,
        usage: usage !== null && usage !== void 0 ? usage : undefined,
        wallType: wallType !== null && wallType !== void 0 ? wallType : undefined,
        yearBuilt: yearBuilt !== null && yearBuilt !== void 0 ? yearBuilt : undefined,
    });
};

var toSavvyHomeownersPolicy = function (_a) {
    var active = _a.active, policyTermMonths = _a.policyTermMonths, numberOfPayments = _a.numberOfPayments, premiumCents = _a.premiumCents, issuer = _a.issuer, issueDate = _a.issueDate, renewalDate = _a.renewalDate, canceledDate = _a.canceledDate, policyHolder = _a.policyHolder, householdMembers = _a.householdMembers, property = _a.property, coverages = _a.coverages, expectedPremiumCents = _a.expectedPremiumCents;
    return (__assign(__assign(__assign({ policyType: SAVVY_POLICY_TYPE.HOMEOWNERS_POLICY, isActive: active, policyTermMonths: policyTermMonths !== null && policyTermMonths !== void 0 ? policyTermMonths : undefined, numberOfPayments: numberOfPayments !== null && numberOfPayments !== void 0 ? numberOfPayments : undefined }, (premiumCents && { premiumCents: premiumCents })), (expectedPremiumCents && { expectedPremiumCents: expectedPremiumCents })), { currentIssuer: issuer, issueDate: issueDate !== null && issueDate !== void 0 ? issueDate : undefined, renewalDate: renewalDate !== null && renewalDate !== void 0 ? renewalDate : undefined, canceledDate: canceledDate !== null && canceledDate !== void 0 ? canceledDate : undefined, policyHolder: isNil$1(policyHolder) ? {} : toSavvyPolicyHolder(policyHolder), property: isNil$1(property) ? {} : toSavvyProperty(property), householdMembers: isNil$1(householdMembers) ? [] : householdMembers.map(toSavvyHouseholdMember), coverages: isNil$1(coverages) ? [] : toSavvyHomeownersCoverages(coverages), deductibles: isNil$1(coverages) ? [] : toSavvyHomeownersDeductibles(coverages) }));
};

var toSavvyPolicy = function (_a) {
    var active = _a.active, policyTermMonths = _a.policyTermMonths, numberOfPayments = _a.numberOfPayments, premiumCents = _a.premiumCents, expectedPremiumCents = _a.expectedPremiumCents, issuer = _a.issuer, issueDate = _a.issueDate, renewalDate = _a.renewalDate, canceledDate = _a.canceledDate, policyHolder = _a.policyHolder, operators = _a.operators, vehicles = _a.vehicles, incidents = _a.incidents, discounts = _a.discounts, paymentScheduleMonths = _a.paymentScheduleMonths;
    return (__assign(__assign(__assign({ policyType: SAVVY_POLICY_TYPE.AUTO_POLICY, isActive: active, policyTermMonths: policyTermMonths, numberOfPayments: numberOfPayments, paymentScheduleMonths: paymentScheduleMonths }, (premiumCents && { premiumCents: premiumCents })), (expectedPremiumCents && { expectedPremiumCents: expectedPremiumCents })), { currentIssuer: issuer, issueDate: issueDate, renewalDate: renewalDate, canceledDate: canceledDate, policyHolder: isNil$1(policyHolder) ? {} : toSavvyPolicyHolder(policyHolder), operators: isNil$1(operators) ? [] : operators.map(toSavvyOperator), vehicles: isNil$1(vehicles) ? [] : vehicles.map(function (vehicle) { return toSavvyVehicle(vehicle, operators); }), discounts: isNil$1(discounts) ? [] : discounts.map(toSavvyDiscount), incidents: isNil$1(incidents) ? [] : incidents.map(toSavvyIncident) }));
};
var toTrellisPolicy = function (_a, autoPolicyId) {
    var canceledDate = _a.canceledDate, currentIssuer = _a.currentIssuer, discounts = _a.discounts, incidents = _a.incidents, isActive = _a.isActive, issueDate = _a.issueDate, numberOfPayments = _a.numberOfPayments, operators = _a.operators, policyHolder = _a.policyHolder, policyTermMonths = _a.policyTermMonths, premiumCents = _a.premiumCents, renewalDate = _a.renewalDate, vehicles = _a.vehicles, expectedPremiumCents = _a.expectedPremiumCents, paymentScheduleMonths = _a.paymentScheduleMonths;
    return ({
        active: isActive,
        canceledDate: canceledDate,
        // Trellis data point: Marking it optional can be evaluated later
        dateRetrieved: undefined,
        discountTotalCents: isNil$1(discounts) ? 0 : getDiscountTotalCents(discounts),
        discounts: isNil$1(discounts) ? [] : discounts.map(toTrellisDiscount),
        hasAtFaultAccident: isNil$1(incidents) || isEmpty$1(incidents) ? 'unknown' : hasAtFaultAccident(incidents) ? 'yes' : 'no',
        hasAtFaultClaim: isNil$1(incidents) || isEmpty$1(incidents) ? 'unknown' : hasAtFaultClaim(incidents) ? 'yes' : 'no',
        id: autoPolicyId,
        incidents: isNil$1(incidents) ? [] : incidents.map(toTrellisIncident),
        issueDate: issueDate,
        issuer: currentIssuer,
        issuerId: currentIssuer,
        numberOfPayments: numberOfPayments,
        operators: isNil$1(operators) ? [] : operators.map(toTrellisOperator),
        // Savvy does not currently collect this
        paymentHistory: [],
        paymentScheduleMonths: paymentScheduleMonths,
        policyHolder: isNil$1(policyHolder) ? {} : toTrellisPolicyHolder$1(policyHolder),
        // Unlikely to have this outside of Trellis
        policyNumber: undefined,
        policyTermMonths: policyTermMonths,
        policyType: TrellisPolicyTypes.PERSONAL_AUTO,
        premiumCents: premiumCents,
        expectedPremiumCents: expectedPremiumCents,
        renewalDate: renewalDate,
        vehicles: isNil$1(vehicles) ? [] : vehicles.map(function (vehicle) { return toTrellisVehicle(vehicle, operators); }),
    });
};

export { AccidentTypeDetails, ClaimTypeDetails, DUITypeDetails, PersonalAutoIncidentTypes, SAVVY_POLICY_TYPE, SavvyCoverageName, SavvyDiscountName, SavvyDriversLicenseStatus, SavvyEducation, SavvyGender, SavvyHomeownersCoverageName, SavvyHomeownersDeductibleName, SavvyIncidentSubType, SavvyIncidentType, SavvyMaritalStatus, SavvyOwnershipStatus, SavvyRelationship, SavvyResidenceStatus, SavvyVehicleType, SavvyVehicleUse, TicketTypeDetails, TrellisDiscountType, TrellisEducation, TrellisFinancialResponsibilityTypes, TrellisGender, TrellisMaritalStatus, TrellisOwnershipStatus, TrellisPolicyTypes, TrellisVehicleType, TrellisVehicleUse, jsonSchemaMinimum$c as addressSchemaMinimum, jsonSchemaQuoteMinimum$8 as addressSchemaQuoteMinimum, buildSavvyAddress, buildSavvyAutoPolicy, buildSavvyBasicAddress, buildSavvyBasicPolicyHolder, buildSavvyCoverage, buildSavvyDiscount, buildSavvyHomeownersPolicy, buildSavvyHouseholdMember, buildSavvyIncident, buildSavvyName, buildSavvyOperator, buildSavvyPolicyHolder, buildSavvyProperty, buildSavvyVehicle, buildTrellisAddress, buildTrellisAutoPolicy, buildTrellisCoverage, buildTrellisDiscount, buildTrellisIncident, buildTrellisName, buildTrellisOperator, buildTrellisPaymentHistory, buildTrellisPolicyHolder, buildTrellisVehicle, jsonSchemaMinimum$b as coverageSchemaMinimum, jsonSchemaMinimum$a as discountSchemaMinimum, getExpectedTrellisDiscount, getExpectedTrellisOperator, getExpectedTrellisPolicy, getExpectedTrellisPolicyHolder, getExpectedTrellisVehicle, jsonSchemaMinimum$8 as incidentSchemaMinimum, jsonSchemaMinimum, jsonSchemaMinimumId, jsonSchemaQuoteMinimum, jsonSchemaQuoteMinimumId, largeSixMonthPremiumCents, jsonSchemaMinimum$9 as nameSchemaMinimum, jsonSchemaQuoteMinimum$7 as operatorSchemaQuoteMinimum, jsonSchemaQuoteMinimum$5 as policyHolderQuoteMinimumSchema, jsonSchemaQuoteMinimum$3 as policySchemaMinimum, jsonSchemaQuoteMinimumId$3 as policySchemaMinimumId, tinyPremiumCents, toSavvyHomeownersPolicy, toSavvyPolicy, toTrellisHomeownersPolicy, toTrellisPolicy, validateCoverageName, validateDiscountName, validateMinimumAutoPolicy, validateMinimumCoverage, validateMinimumDiscount, validateMinimumHomeownersPolicy, validateQuoteMinimumAutoPolicy, validateQuoteMinimumHomeownersPolicy, jsonSchemaQuoteMinimum$4 as vehicleSchemaQuoteMinimum };
//# sourceMappingURL=index.esm.js.map
